// 2024-10-07T09:50:18.508Z  (1728294618508)
export const locale = {
	lang: 'pl',
	data: {
		'ACCOUNTING_VALUE': 'Wartość ewidencyjna ',
		'ACCOUNTING_VALUES': 'Wartości dodatkowe',
		'ACCOUNTING_VALUE.COMPUTE_IN_STATES': 'Wyliczanie w stopniach',
		'ACCOUNTING_VALUE.VALUE_AGGREGATION': 'Sumowanie składników ',
		'ACCOUNTING_VALUE.VALUE_COMPUTATION': 'Obliczanie wartości',
		"ACCOUNTING_VALUE.RESOURCE_TYPE": "Typ zasobu operacyjnego",
		'ACCOUNTING_VALUE.VALUE_SUMMATION': 'Sumowanie wartości ',
		'ACCOUNT_ACTIVATION': 'Aktywacja konta ',
		'ACCOUNT_ACTIVATION.CODE': 'Kod aktywacji',
		'ACCOUNT_ACTIVATION.CODE.RESEND': ' Wyślij ponownie kod aktywacyjny ',
		'ACCOUNT_ACTIVATION.INTRO': ' Proszę wpisać kod aktywacyjny, który otrzymałeś e-mailem',
		'ACID': 'Kwas',
		'ACTIVATE': 'Aktywuj ',
		'ACTIVATE.SELECTED': 'Aktywuj wybrane ',
		'ACTIVE': 'Aktywny ',
		'ACTIVITIES.DAILY': 'Aktywność codzienna',
		'ACTIVITIES.EXPORT': 'Działalność eksportowa',
		'ACTIVITIES.NO': 'Brak aktywności',
		'ACTIVITIES.WEEKLY': 'Tygodniowe aktywności',
		'ACTIVITY': 'Aktywność',
		'ACTIVITY.EXPORT_DETAILS': 'Eksportuj wybraną aktywność',
		'ACTIVITY.NO_FIELDS_WORKED': 'Nie prowadzono żadnych prac na wybranych polach',
		'ADAPTER': 'Adapter',
		'ADAPTER.ASSIGN': 'Przypisz adapter',
		'ADAPTER.ASSIGN.FAILURE': 'Wystąpił błąd podczas podłączania adaptera',
		'ADAPTER.ASSIGN.SUCCESS': 'Adapter został pomyślnie przypisany',
		'ADAPTER.ASSIGNED_MACHINE': 'Przydzielona maszyna ',
		'ADAPTER.ASSIGNMENT': 'Przypisywanie adaptera do maszyny ',
		'ADAPTER.CHOSEN': 'Wybrany adapter ',
		'ADAPTER.LOAD.FAILURE': 'Wystąpił błąd podczas wgrywania Adapterów ',
		'ADAPTER.NO': 'Brak adaptera',
		'ADAPTER.NONE_AVAILABLE': 'Brak dostępnego adaptera ',
		'ADAPTER.PAIR_INFO': 'Wybierz właściwy adapter. Już przypisane adaptery zostaną nadpisane nową maszyną. Nowa konfiguracja zostanie automatycznie załadowana przy ponownym uruchomieniu adaptera.',
		'ADAPTER.PREVIOUS': ' Poprzedni adapter ',
		'ADAPTERS.NO': 'Brak adapterów ',
		'ADBLUE.LEVEL': 'Poziom AdBlue ',
		'ADD': 'Dodaj ',
		'ADDITIONAL_VALUE': 'Dodatkowa wartość',
		'ADDITIVE': 'Dodatek',
		'ADDRESS': 'Adres',
		'ALL': 'Wszystkie',
		'ALL_DEVICES': 'Urządzenia ogólne',
		'AMOUNT': 'Kwota ',
		'AMOUNT.INVALID': 'Kwota niepoprawna',
		'AMOUNTS': 'Kwoty',
		'APPLY': 'zastosowanie',
		'ARCHIVE': 'Archiwum ',
		'ARCHIVE.SELECTED': 'Wybrano archiwum',
		'AREA': 'Obszar',
		'AREA.FIELD': 'Areał',
		'AREA.LOCATION': 'Lokalizacje obszarów',
		'AREA.PERFORMANCE': 'Areał na h',
		'AREA.PROCESSED': 'Przetwarzany areał',
		'AREA.TOTAL': 'Całkowity areał',
		'AREA.WORKED': 'Obszar roboczy',
		'ASSIGN': 'Przypisz',
		'AUTH.REMEMBER_ME': 'Zapamiętaj mnie',
		'BACK': 'Wróć',
		'BALES': 'Bale',
		'BASIC_DATA': 'Podstawowe dane',
		'BEACON': 'Sygnalizator ',
		'BEACON.ASSIGN': 'Przypisz sygnalizator',
		'BEACON.ASSIGN.SUCCESS': 'Sygnalizator został pomyślnie przypisany',
		'BEACON.ASSIGNED_EMPLOYEE': 'Przypisany pracownik',
		'BEACON.ASSIGNED_IMPLEMENT': 'Przypisane narzędzie',
		'BEACON.ASSIGN_TO_EMPLOYEE': 'Przypisz sygnalizator do pracownika ',
		'BEACON.ASSIGN_TO_IMPLEMENT': 'Przypisać sygnalizator do urządzenia',
		'BEACON.CHOSEN': 'Wybrany sygnalizator',
		'BEACON.ERROR': 'Wystąpił błąd przy sparowaniu sygnalizatora',
		'BEACON.LOAD_ERROR': ' Wystąpił błąd podczas ładowania sygnalizatora',
		'BEACON.NONE_AVAILABLE': 'Brak dostępnych sygnalizatorów',
		'BEACON.NO_BEACON': 'Brak sygnalizatorów',
		'BEACON.PAIR_INFO_EMPLOYEE': 'Wybierz odpowiedni sygnalizator. Już przypisane sygnalizatory zostaną nadpisane nowym pracownikiem',
		'BEACON.PAIR_INFO_IMPLEMENT': 'Wybierz odpowiedni sygnalizator. Już przypisane sygnalizatory zostaną nadpisane nowymi.',
		'BEACON.PREVIOUS': 'Przedostatni sygnalizator',
		'BEACONS': 'Sygnalizator',
		'BUILD_YEAR': 'Rok produkcji',
		'BUILD_YEAR.INVALID': 'Rok budowy nieprawidłowy',
		'CAN.STATUS': 'Status CAN',
		'CANCEL': 'Anuluj',
		'CHANGE': 'Zmień',
		'CHANGE.NO': 'Bez zmian',
		'CHOOSE_ALL': 'Wybierz wszystko',
		'CHOOSE_ROLE': 'Wybierz funkcję',
		'CHRONOLOGICAL': 'kolejność chronologiczna',
		'CLICK_PROCESS': 'Wybierz czynność, aby uzyskać więcej szczegółów ',
		'CLOSE': 'Zamknij',
		'CO2.EMISSION': 'Emisja CO2',
		'CO2.PER': 'Ilość CO2 na ha ',
		'CO2.TOTAL': 'Całkowita ilość CO2',
		'COLOR': 'Kolor',
		'COMMENT': 'Komentarz',
		'CONDITION': 'stan',
		'CONFIRM': 'Potwierdź ',
		'CONFIRM_PASSWORD': 'Potwierdź hasło',
		'CONNECT': 'Połącz',
		'CONTACT_PERSON': 'Osoba do kontaktu',
		'CONTINUE': 'Kontynuuj ',
		'COST': 'Koszt',
		'COST.INVALID': 'Koszt nieprawidłowy',
		'COST.OVERALL': 'Całkowity koszt',
		'COST.OVERALL.ARRIVAL': 'Całkowity koszt przybycia',
		'COST.OVERALL.DRIVER': 'Ogólny czynnik kosztotwórczy',
		'COST.OVERALL.FIELD_TIME': 'Całkowity koszt w terenie',
		'COST.OVERALL.IMPLEMENTS': 'Ogólny koszt wdrożenia',
		'COST.OVERALL.MACHINES': 'Całkowity koszt maszyn',
		'COST.OVERALL.PREPARATION': 'Ogólne przygotowanie kosztów',
		'COST.TOTAL': 'Koszt całkowity',
		'COSTS': 'Koszty',
		'COST_RATE': 'Wysokość kosztów',
		'COUNTRY': 'Kraj',
		'COVERAGE': 'Coverage',
		'COVERAGE.MAP': 'Mapa zasięgu',
		'COVERAGE.MAP.SETTINGS': 'Ustawienia mapy zasięgu',
		'COVERAGE.MAP.ZONES': 'Strefy',
		'CREATED': 'Utworzony',
		'CREATE_USER': 'Utwórz użytkownika ',
		"CROP": "Uprawa",
		'CROP.TYPE': 'Rodzaj uprawy ',
		'CROP.NO_CROP': 'Brak uprawy',
		'CURRENCY': 'Waluta',
		'CUSTOMER': 'Klient ',
		'CUSTOMER.ADD': 'Dodaj nowego klienta',
		'CUSTOMER.ADD.SUCCESS': 'Klient dodany',
		'CUSTOMER.ASSIGN': 'Przypisz klienta ',
		'CUSTOMER.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć klienta?',
		'CUSTOMER.DELETE.SUCCESS': 'Klient został usunięty ',
		'CUSTOMER.DETAILS': 'Szczegóły klienta',
		'CUSTOMER.EDIT': 'Edytuj klienta',
		'CUSTOMER.EDIT.SUCCESS': 'Klient pomyślnie edytowany ',
		'CUSTOMER.NAME': 'Nazwa klienta',
		'CUSTOMER.NO': 'Brak klienta',
		'CUSTOMER.NOT_SELECTED': 'Nie wybrano żadnego klienta ',
    'CUSTOMER.NO.ASSIGNEE': 'Brak przypisanych klientów',
		'CUSTOMER.SELECT': 'Wybierz klienta ',
		'CUSTOMERS': 'Klienci',
		'CUSTOMERS.ALL': 'Wszyscy klienci',
		'CUSTOMERS.DELETE.FAILURE': 'Niektórych klientów nie można było usunąć',
		'CUSTOMERS.DELETE.QUESTION': 'Czy chcesz usunąć wybranych klientów?',
		'CUSTOMERS.DELETE.SUCCESS': 'Klienci usunięci pomyślnie ',
		'CUSTOMERS.MANAGEMENT': 'Zarządzanie klientami ',
		'CUSTOMERS.NO': 'Brak klientów',
		'CUSTOMERS.SELECTED': 'Wybrani klienci ',
		'CUSTOM_LABELING': 'Indywidualne oznakowanie',
		'CUSTOM_LABELING.ADD_WORKSTATE': 'Dodaj nowe stanowisko pracy',
		'CUSTOM_LABELING.DEFINE_FOR_IMPLEMENT': 'Zdefiniuj niestandardowe oznaczenie dla wybranego narzędzia.',
		'CUSTOM_LABELING.DEFINE_INDIVIDUAL_CONDITION': 'Zdefiniuj indywidualne kryteria dla danego oznaczenia.',
		'CUSTOM_LABELING.EDIT.SUCCESS': 'Edycja indywidualnego oznakowania zakończona sukcesem ',
		'CUSTOM_LABELING.INDIVIDUAL_CONDITION': 'Stan ogólny ',
		'CUSTOM_LABELING.ISOBUS_OVERRIDE': 'Umożliwienie nadpisania za pomocą warunków ISOBUS',
		'CUSTOM_LABELING.NO_LABELS_AVAILABLE': 'Brak dostępnych oznaczeń',
		'DASHBOARD.GPS_DATA.NO': 'Brak danych GPS ',
		'DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE': 'Wystąpił błąd podczas ładowania pozycji maszyny',
		'DATA': 'Dane',
		'DATA.ARCHIVED.WARNING': 'Dane bazowe są częściowo lub w pełni zarchiwizowane',
		'DATA.EXPORT': 'Eksport danych',
		'DATA.INPUT': 'Data input',
		'DATA.UPDATING.WARNING': 'Dane bazowe są aktualizowane',
		'DATA_PREPARATION': 'Sporządzanie danych',
		'DATE': 'Data',
		'DATE.APRIL': 'Kwiecień',
		'DATE.AUGUST': 'Sierpień',
		'DATE.DECEMBER': 'Grudzień',
		'DATE.FEBRUARY': 'Luty',
		'DATE.FRIDAY': 'Piątek',
		'DATE.FROM': 'Od',
		'DATE.JANUARY': 'Styczeń',
		'DATE.JULY': 'Lipiec',
		'DATE.JUNE': 'Czerwiec',
		'DATE.MARCH': 'Marzec',
		'DATE.MAY': 'Maj',
		'DATE.MONDAY': 'Poniedziałek',
		'DATE.NOVEMBER': 'Listopad',
		'DATE.OCTOBER': 'Październik',
		'DATE.PERIOD': 'Okres',
		'DATE.RANGE': 'Zakres dat',
		'DATE.SATURDAY': 'Sobota',
		'DATE.SEPTEMBER': 'Wrzesień',
		'DATE.SUNDAY': 'Niedziela',
		'DATE.THURSDAY': 'Czwartek',
		'DATE.TUESDAY': 'Wtorek',
		'DATE.UNTIL': 'Do',
		'DATE.WEDNESDAY': 'Środa',
		'DAY.CURRENT': 'Aktualny dzień',
		'DAY.NEXT': 'Następny dzień',
		'DAY.PREVIOUS': 'Poprzedni dzień',
		'DAY.SELECTED': 'Wybierz dzień',
		'DAYS': 'Dni',
		'DAY_ACTIVITIES': 'Aktywność dzienna',
		'DEACTIVATE': ' Dezaktywuj pracowników ',
		'DEACTIVATE.SELECTED': 'Dezaktywuj wybrane ',
		'DEADLINE': 'Termin realizacji',
		'DEADLINE.ADD': 'Dodaj termin realizacji',
		'DEADLINE.ADD.SUCCESS': 'Termin realizacji dodany',
		'DEADLINE.DELETE.SUCCESS': 'Termin realizacji usunięty',
		'DEADLINE.DONE': 'Zakończ',
		'DEADLINE.DUE': 'Drugi termin',
		'DEADLINE.DUE_IN_AT': 'Wymagalne w/do',
		'DEADLINE.EDIT': 'Termín úprav',
		'DEADLINE.EDIT.SUCCESS': 'Termin został zmieniony',
		'DEADLINE.IS_CLOSE': 'Zbliża się ostateczny termin',
		'DEADLINE.IS_OVERDUE': 'Powyższy termin jest przeterminowany. ',
		'DEADLINE.OPEN': 'Otwórz',
		'DEADLINE.PROCESS.SUCCESS': 'Úspěšně zpracovaný termín',
		'DEADLINE.PROCESSED': 'Przetwarzane',
		'DEADLINE.PROCESSED.SUCCESS': 'Termin pomyślnie zrealizowany',
		'DEADLINE.WARN': 'Najbliższy termin',
		'DEADLINES': ' Terminy ',
		'DEADLINES.NO': 'Brak terminów ',
		'DEFINE_ROLE': 'Zdefiniuj rolę',
		'DELETE': 'Usuń',
		'DELETE.SELECTED': 'Usuń zaznaczone',
		'DELETED': 'Usunięte',
		'DESCRIPTION': 'Opis ',
		'DIAGRAM': 'Diagram ',
		'DISPLAY': 'Wyświetl',
		'DISPLAY_TRACK': 'Wyświetlanie trasy',
		'DISTANCE': 'Odległość ',
		'DISTANCE.TOTAL': 'Całkowita odległość ',
		'DISTANCE.WORKED': 'Przepracowany dystans',
		'DOWNLOAD': 'Pobierz',
		'DRIVER': 'Kierowca ',
		'DRIVER.EDIT': 'Kierowca prowadzący',
		'DRIVER.FIXED': 'Ustalony kierowca',
		'DRIVER.NO': ' Brak kierowcy ',
		'DRIVER.REMOVE': 'Zdemontować sterownik',
		'DRIVERS': 'Kierowcy ',
		'DRIVERS.ALL': 'Wszyscy kierowcy ',
		'DRIVER_SCAN_DISABLED': 'Brak aktywnego skanowania sygnalizatora operatora',
		'DURATION': 'Czas trwania',
		'DURATION.WORKED': 'Czas pracy',
		'EDIT': 'Edytuj',
		'EDIT.SELECTED': 'Edytuj wybrane',
		'EDIT_USER': 'Edytuj użytkownika',
		'EMAIL': 'Kontakt email',
		'EMAIL.ACTIVATE': 'Aktywuj e-mail ',
		'EMAIL.ACTIVATE.CODE': 'Kod aktywacyjny',
		'EMAIL.ACTIVATE.EXPLANATION': 'Jeśli zmieniłeś swój adres e-mail, wyślemy Ci kod aktywacyjny na Twój nowy adres',
		'EMAIL.CHANGE': 'Zmień email',
		'EMAIL.CHANGE.SUCCESS': 'Email zmieniony',
		'EMAIL.CONFIRM': 'Potwierdź e-mail',
		'EMAIL.CURRENT': 'Obecny email',
		'EMAIL.INVALID': 'E-mail nieprawidłowy',
		'EMAIL.NEW': 'Nowy email',
		'EMAIL.NO_MATCH': 'E-maile nie zgadzają się ',
		'EMPLOYEE': ' Pracownik ',
		'EMPLOYEE.ACTIVATE.QUESTION': 'Czy na pewno chcesz aktywować pracownika?',
		'EMPLOYEE.ADD': 'Dodaj pracownika ',
		'EMPLOYEE.ADD.SUCCESS': 'Pracownik pomyślnie dodany ',
		'EMPLOYEE.CREATE': 'Utwórz pracownika',
		'EMPLOYEE.CREATE.SUCCESS': 'Pracownik utworzony pomyślnie',
		'EMPLOYEE.DEACTIVATE.QUESTION': 'Czy na pewno chcesz dezaktywować pracownika?',
		'EMPLOYEE.DELETE.QUESTION': 'Czy na pewno chcesz usunąć pracownika?',
		'EMPLOYEE.EDIT': 'Edytuj pracownika ',
		'EMPLOYEE.EDIT.SUCCESS': 'Pracownik pomyślnie edytowany ',
		'EMPLOYEE.ROLE': 'Funkcja pracownika',
		'EMPLOYEE.ROLE_OF': 'Rola pracownika ',
		'EMPLOYEES': 'Pracownicy',
		'EMPLOYEES.ACTIVATE.QUESTION': 'Czy naprawdę chcesz aktywować pracowników?',
		'EMPLOYEES.ACTIVATE.SUCCESS': 'Pracownicy, którzy pomyślnie przeszli aktywację',
		'EMPLOYEES.ALL': 'Wszyscy pracownicy ',
		'EMPLOYEES.DEACTIVATE.FAILURE': ' Niektórych pracowników nie można było dezaktywować',
		'EMPLOYEES.DEACTIVATE.QUESTION': 'Czy naprawdę chcesz dezaktywować wybranych pracowników? ',
		'EMPLOYEES.DEACTIVATE.SUCCESS': 'Pracownicy zostali dezaktywowani ',
		'EMPLOYEES.DELETE.FAILURE': 'Niektórych pracowników nie można było usunąć',
		'EMPLOYEES.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć wybranych pracowników?',
		'EMPLOYEES.DELETE.SUCCESS': 'Pracownicy usunięci ',
		'EMPLOYEES.MANAGEMENT': 'Zarządzanie pracownikami',
		'EMPLOYEES.NO': 'Brak pracowników ',
		'EMPLOYEES.NOT_SELECTED': 'Nie wybrano żadnego pracownika',
		'EMPLOYEES.SELECTED': 'Wybrani pracownicy',
		'EMPLOYER.NO': 'Brak pracodawcy',
		'EMPLOYER.NOT_SELECTED': 'Nie wybrano pracodawcy ',
		'EMPLOYES.NO': ' Brak pracowników ',
		'END_DRAW_MODE': 'Tryb rysowania anulowany ',
		'ENTERPRISE': ' Przedsiębiorstwo ',
		'ENTERPRISE.ADD': 'Dodaj przedsiębiorstwo',
		'ENTERPRISE.ADD.EMPLOYER_REQUIRED': 'Musisz dodać pracodawcę',
		'ENTERPRISE.ADDED.SUCCESS': 'Bedrijf succesvol toegevoegd',
		'ENTERPRISE.ADD.SUCCESS': 'Pomyślne dodanie do przedsiębiorstwa ',
		'ENTERPRISE.ENTER_ACCESS_TOKEN': 'Proszę wprowadzić kod dostępu dla przedsiębiorstwa',
		'ENTERPRISE.NAME': 'Nazwa przedsiębiorstwa',
		'ENTERPRISE.NOT_SELECTED': 'Nie wybrano żadnego przedsiębiorstwa ',
		'ENTERPRISE.OF': 'Przedsiębiorstwo:',
		'ENTERPRISE.SETTINGS': 'Ustawienia przedsiębiorstwa ',
		'ENTERPRISE.SETTINGS.CONFIGURATION_UPDATE.SUCCESS': 'Pomyślna aktualizacja konfiguracji przedsiębiorstwa',
		'ENTERPRISE.SETTINGS.MACHINES_SYNC.SUCCESS': 'Maszyny zsynchronizowane pomyślnie',
		'ENTERPRISE_LICENSE.EMPLOYEES': 'Licencje pracownicze',
		'ENTERPRISE_LICENSE.LICENSE': 'Licencja',
		'ENTERPRISE_LICENSE.MACHINE': 'Licencja na maszynę ',
		'ENTERPRISE_LICENSE.MACHINES': 'Licencja na maszyny ',
		'ENTERPRISE_MIN': 'Nazwa przedsiębiorstwa musi zawierać co najmniej 3 znaki ',
		'ENTERPRISE_NAME_REQUIRED': 'Wymagana nazwa przedsiębiorstwa',
		'ENTERPRISE_SELECTION.ADD_ENTERPRISE': 'Dodaj przedsiębiorstwo',
		'ENTERPRISE_SELECTION.LICENSE_EXPIRED': 'Licencja wygasła',
		'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT': 'Poproś o konto testowe',
		'ENTERPRISE_STATISTICS': 'Statystyki przedsiębiorstwa',
		'ENTERPRISE_STATISTICS.COST_DIAGRAMM': 'Wykres kosztów',
		'ENTERPRISE_STATISTICS.PROCESS_DIVISION': 'Podział zabiegów',
		'ENUM.ACCOUNTING_COMP_MODE.A': 'Wszystkie ',
		'ENUM.ACCOUNTING_COMP_MODE.WT': 'Praca / transport ',
		'ENUM.ACCOUNTING_MODE.AVG': 'Średnia',
		'ENUM.ACCOUNTING_MODE.MAX': 'Maksimum',
		'ENUM.ACCOUNTING_MODE.MED': 'Średnia',
		'ENUM.ACCOUNTING_MODE.MIN': 'Minimum ',
		'ENUM.ACCOUNTING_MODE.SUM': 'Suma',
		'ENUM.ACCOUNTING_VALUE_MODE.ABSDIF': 'Różnica bezwzględna',
		'ENUM.ACCOUNTING_VALUE_MODE.DIR': 'Bezpośrednio',
		'ENUM.ACCOUNTING_VALUE_MODE.NEGDIF': ' Różnica ujemna',
		'ENUM.ACCOUNTING_VALUE_MODE.POSDIF': 'Różnica dodatnia',
		'ENUM.ACCOUNTING_VALUE_MODE.TIMACT': 'Aktywny czas',
		'ENUM.BEACONTYPE.BDrv': 'Sygnalizator jazdy',
		'ENUM.BEACONTYPE.BImpl': 'Wdrożenie radiolatarni',
		'ENUM.CAN_IDENTIFIER.A1': 'Analogowy 1',
		'ENUM.CAN_IDENTIFIER.A2': 'Analogowy 2',
		'ENUM.CAN_IDENTIFIER.A3': 'Analogowy 3',
		'ENUM.CAN_IDENTIFIER.A4': 'Analogowy 4',
		'ENUM.CAN_IDENTIFIER.AUX0_Ext_Fl': 'AUX0 - przepływ zewnętrzny',
		'ENUM.CAN_IDENTIFIER.AUX0_Ret_Fl': 'AUX0 przepływ wsteczny',
		'ENUM.CAN_IDENTIFIER.AUX1_Ext_Fl': 'AUX1 przepływ zewnętrzny',
		'ENUM.CAN_IDENTIFIER.AUX1_Ret_Fl': 'AUX1 przepływ wsteczny',
		'ENUM.CAN_IDENTIFIER.AUX2_Ext_Fl': 'AUX2 przepływ zewnętrzny',
		'ENUM.CAN_IDENTIFIER.AUX2_Ret_Fl': 'AUX2 przepływ wsteczny',
		'ENUM.CAN_IDENTIFIER.AUX3_Ext_Fl': 'AUX3 przepływ zewnętrzny',
		'ENUM.CAN_IDENTIFIER.AUX3_Ret_Fl': 'AUX3 przepływ wsteczny',
		'ENUM.CAN_IDENTIFIER.AUX4_Ext_Fl': 'AUX4 przepływ zewnętrzny',
		'ENUM.CAN_IDENTIFIER.AUX4_Ret_Fl': 'AUX4 przepływ wsteczny',
		'ENUM.CAN_IDENTIFIER.Ag1avg': 'Średnia dla 1 kąta',
		'ENUM.CAN_IDENTIFIER.Ag1max': 'Kąt 1 maks.',
		'ENUM.CAN_IDENTIFIER.Ag1min': 'Kąt 1 min ',
		'ENUM.CAN_IDENTIFIER.Ag2avg': 'Średnia dla 2 kąta',
		'ENUM.CAN_IDENTIFIER.Ag2max': 'Kąt 2 maks.',
		'ENUM.CAN_IDENTIFIER.Ag2min': 'Kąt 2 min ',
		'ENUM.CAN_IDENTIFIER.Ag3avg': 'Średnia dla 3 kąta',
		'ENUM.CAN_IDENTIFIER.Ag3max': 'Kąt 3 maks.',
		'ENUM.CAN_IDENTIFIER.Ag3min': 'Kąt 3 min ',
		'ENUM.CAN_IDENTIFIER.ApplAci': 'Zastosowany preparat',
		'ENUM.CAN_IDENTIFIER.ApplAdd': 'Zastosowane dodatki ',
		'ENUM.CAN_IDENTIFIER.ApplSlu': 'Zastosowana gnojowica ',
		'ENUM.CAN_IDENTIFIER.AxleWeight_1': 'Masa osi 1',
		'ENUM.CAN_IDENTIFIER.AxleWeight_2': 'Masa osi 2',
		'ENUM.CAN_IDENTIFIER.C1': 'Licznik 1',
		'ENUM.CAN_IDENTIFIER.C2': 'Licznik 2',
		'ENUM.CAN_IDENTIFIER.Chop_Act': 'Sieczkarnia',
		'ENUM.CAN_IDENTIFIER.Circ_1_Stat': 'Circ_1_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_2A_Stat': 'Circ_2A_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_2B_Stat': 'Circ_2B_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_3_Stat': 'Circ_3_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_4_Stat': ' Circ_4_Stat ',
		'ENUM.CAN_IDENTIFIER.ClutSlip': 'Poślizg sprzęgła ',
		'ENUM.CAN_IDENTIFIER.Cutter_Guide': 'Prowadnica frezu',
		'ENUM.CAN_IDENTIFIER.Cutter_GuideP': 'Prowadnica frezu(P)',
		'ENUM.CAN_IDENTIFIER.Cutter_Pos': 'Położenie noża',
		'ENUM.CAN_IDENTIFIER.Cutter_State': 'Noż',
		'ENUM.CAN_IDENTIFIER.D1': 'Cyfrowy 1',
		'ENUM.CAN_IDENTIFIER.D2': 'Cyfrowy 2',
		'ENUM.CAN_IDENTIFIER.D3': 'Cyfrowy 3',
		'ENUM.CAN_IDENTIFIER.D4': 'Cyfrowy 4',
		'ENUM.CAN_IDENTIFIER.Driv_Lever': 'Dźwignia jazdy',
		'ENUM.CAN_IDENTIFIER.ENG_ABLev': 'Poziom AdBlue',
		'ENUM.CAN_IDENTIFIER.ENG_FueLev': 'Poziom paliwa',
		'ENUM.CAN_IDENTIFIER.ENG_FueRat': 'Dawka paliwa',
		'ENUM.CAN_IDENTIFIER.ENG_Spe': 'Obr/min',
		'ENUM.CAN_IDENTIFIER.ENG_Tor': 'Obciążenie silnika',
		'ENUM.CAN_IDENTIFIER.FHitch_Pos': 'Przednia pozycja zaczepu',
		'ENUM.CAN_IDENTIFIER.FPTO_Eng': 'Aktywny przedni WOM',
		'ENUM.CAN_IDENTIFIER.FPTO_Spe': 'Liczba obrotów WOM z przodu ',
		'ENUM.CAN_IDENTIFIER.Field_Switch': 'Przełącznik pola',
		'ENUM.CAN_IDENTIFIER.Field_Switch2': 'Przełącznik pola2',
		'ENUM.CAN_IDENTIFIER.Front_Draft': 'Wysokość przód',
		'ENUM.CAN_IDENTIFIER.Front_NForce': 'Wysokość (nominalna) przód',
		'ENUM.CAN_IDENTIFIER.GB_Dir': 'Kierunek ( na powierzchni) ',
		'ENUM.CAN_IDENTIFIER.GB_Speed': 'Prędkość obrotowa na powierzchni',
		'ENUM.CAN_IDENTIFIER.GPS_Speed': 'Prędkość GPS',
		'ENUM.CAN_IDENTIFIER.Gear_Sel': 'Wybrany bieg',
		'ENUM.CAN_IDENTIFIER.GrainCnv_Pos': 'Położenie przenośnika ziarna',
		'ENUM.CAN_IDENTIFIER.GrainTnk_Lev': 'Poziom zbiornika ziarna ',
		'ENUM.CAN_IDENTIFIER.HySt_Dir': 'HySt_Dir ',
		'ENUM.CAN_IDENTIFIER.HySt_Mod': 'HySt_Mod ',
		'ENUM.CAN_IDENTIFIER.Impl_Work': 'Wdrożenie stanu roboczego',
		'ENUM.CAN_IDENTIFIER.JbSta': 'Aktywna praca',
		'ENUM.CAN_IDENTIFIER.Mot_L_Spe': 'Prędkość silnika (lewy)',
		'ENUM.CAN_IDENTIFIER.Mot_L_Tor': 'Moment obrotowy silnika (lewy)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Spe': 'Prędkość silnika (prawa)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Tor': 'Moment obrotowy silnika (prawy)',
		'ENUM.CAN_IDENTIFIER.NO_XTR': ' Brak wartości',
		'ENUM.CAN_IDENTIFIER.NUE_abs': 'SyreN: NUE bezwzględny',
		'ENUM.CAN_IDENTIFIER.NUE_rel': 'SyreN: NUE względny',
		'ENUM.CAN_IDENTIFIER.PHSlu': 'pH gnojowicy ',
		'ENUM.CAN_IDENTIFIER.PTO_Switch': 'WOM_Przełącznik',
		'ENUM.CAN_IDENTIFIER.PTO_Switch1': 'WOM_Przełącznik1',
		'ENUM.CAN_IDENTIFIER.PTO_Switch2': 'WOM_Przełącznik2',
		'ENUM.CAN_IDENTIFIER.PTO_Switch3': 'WOM_Switch3',
		'ENUM.CAN_IDENTIFIER.PrxSen': 'Czujnik odległości',
		'ENUM.CAN_IDENTIFIER.RHitch_Pos': 'Tylna pozycja zaczepu',
		'ENUM.CAN_IDENTIFIER.RPTO_Eng': 'WOM tylny aktywny',
		'ENUM.CAN_IDENTIFIER.RPTO_Spe': 'Liczba obrotów WOM z tyłu ',
		'ENUM.CAN_IDENTIFIER.Rear_Draft': 'Rzut tylny',
		'ENUM.CAN_IDENTIFIER.Rear_NForce': 'Wysokość (nominalna) tylna ',
		'ENUM.CAN_IDENTIFIER.Roll': 'Rolka',
		'ENUM.CAN_IDENTIFIER.Sli': 'Poślizg',
		'ENUM.CAN_IDENTIFIER.Spe': 'Prędkość',
		'ENUM.CAN_IDENTIFIER.StrawChop_Pos': 'Pozycja rozdrabniacza słomy',
		'ENUM.CAN_IDENTIFIER.Thresh_Drum': 'Ciągnik',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A1': 'Ciśnienie w lewej oponie A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A2': 'Ciśnienie w lewej oponie A2',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A1': 'Właściwe ciśnienie w oponach A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A2': 'Właściwe ciśnienie w oponach A2',
		'ENUM.CAN_IDENTIFIER.UnlAuger_Act': 'UnlAuger_Act ',
		'ENUM.CAN_IDENTIFIER.WB_Dir': ' Tryb jazdy ( na podstawie kół)',
		'ENUM.CAN_IDENTIFIER.WB_Speed': 'Prędkość obrotowa wg koła ',
		'ENUM.CAN_IDENTIFIER.Xacc': ' Przyspieszenie X ',
		'ENUM.CAN_IDENTIFIER.Yacc': ' Przyspieszenie Y',
		'ENUM.CAN_IDENTIFIER.Yaw': 'Yaw',
		'ENUM.CAN_IDENTIFIER.Yield_Act': 'Rzeczywisty plon',
		'ENUM.CAN_IDENTIFIER.Yield_Mois': 'Wilgotność plonów',
		'ENUM.CAN_IDENTIFIER.Zacc': ' Przyspieszenie',
		'ENUM.COSTPER.h': 'h',
		'ENUM.COSTPER.ha': 'ha',
		'ENUM.COSTPER.km': 'km',
		'ENUM.COSTPER.l': 'l',
		'ENUM.CURRENCY.DOLLAR': '$',
		'ENUM.CURRENCY.EURO': '€',
		'ENUM.CURRENCY.GBP': ' £ ',
		'ENUM.EMPLOYEEROLE.ADMIN': 'Admin ',
		'ENUM.EMPLOYEEROLE.CONSULTANT': 'Konsultant ',
		'ENUM.EMPLOYEEROLE.DISPONENT': 'Dyspozytor',
		'ENUM.EMPLOYEEROLE.DRIVER': 'Kierowca',
		'ENUM.EVENTTYPE.COMMENT': 'Wiadomość ',
		'ENUM.EVENTTYPE.CT': 'Licznik',
		'ENUM.EVENTTYPE.CT_RS': 'Reset licznika',
		'ENUM.EVENTTYPE.CUSTOMER': 'Klient',
		'ENUM.EVENTTYPE.EMPL_C_IMPL': 'Pary pracowników realizują',
		'ENUM.EVENTTYPE.EMPL_E_FIELD': 'Pracownik rozpoczyna pracę w polu ',
		'ENUM.EVENTTYPE.EMPL_E_MACH': 'Pracownik wchodzi do ciągnika',
		'ENUM.EVENTTYPE.EMPL_L_FIELD': 'Pracownik opuszcza pole ',
		'ENUM.EVENTTYPE.EMPL_L_MACH': 'Pracownik opuszcza ciągnik ',
		'ENUM.EVENTTYPE.EMPL_P_START': 'Pracownik rozpoczyna przerwę',
		'ENUM.EVENTTYPE.EMPL_P_STOP': 'Pracownik kończy przerwę',
		'ENUM.EVENTTYPE.EMPL_UC_IMPL': 'Pracownik odłącza narzędzie',
		'ENUM.EVENTTYPE.EMPL_W_START': 'Pracownik rozpoczyna pracę ',
		'ENUM.EVENTTYPE.EMPL_W_STOP': 'Pracownik kończy pracę ',
		'ENUM.EVENTTYPE.GTO70': 'Zbiornik ziarna pełny',
		'ENUM.EVENTTYPE.JOBINFO': 'Informacja o pracy ',
		'ENUM.EVENTTYPE.JOB_PAUSE': 'Przerwa w pracy ',
		'ENUM.EVENTTYPE.JOB_RESUME': 'Profil zawodowy ',
		'ENUM.EVENTTYPE.JOB_START': 'Początek pracy ',
		'ENUM.EVENTTYPE.JOB_STOP': 'Koniec pracy ',
		'ENUM.EVENTTYPE.L_IMPL': 'Implement załadowany',
		'ENUM.EVENTTYPE.REFUELING': 'Tankowanie ',
		'ENUM.EVENTTYPE.SYREN_CUSTOMER': 'Klient SyreN',
		'ENUM.EVENTTYPE.SYREN_FIELD': 'Pole SyreN',
		'ENUM.EVENTTYPE.SYREN_SLURRY_TYPE': 'Typ zawiesiny SyreN',
		'ENUM.EVENTTYPE.T2_ON': 'Adapter online',
		'ENUM.EVENTTYPE.UL_IMPL': 'Implement rozładowany',
		'ENUM.EVENTTYPE.WEATHER': 'Pogoda ',
		'ENUM.EVENTTYPE.WEIGHING': 'Waga',
		'ENUM.EVENTTYPE.WEIGHING_TARA': 'Waga (tara)',
		'ENUM.ISO_TASKDATA_STATE.CRE': 'Utworzony',
		'ENUM.ISO_TASKDATA_STATE.ONM': 'W maszynie',
		'ENUM.ISO_TASKDATA_STATE.RDY': 'Gotowy',
		'ENUM.JOBGENERATIONSTATE.ARC': 'Archiwizowany ',
		'ENUM.JOBGENERATIONSTATE.DEL': 'Usuwanie ',
		'ENUM.JOBGENERATIONSTATE.EDT': 'Edytowanie ',
		'ENUM.JOBGENERATIONSTATE.GEN': 'Generowanie ',
		'ENUM.JOBGENERATIONSTATE.MER': 'Łączenie ',
		'ENUM.JOBGENERATIONSTATE.QUE': 'W kolejce',
		'ENUM.JOBGENERATIONSTATE.READY': 'OK',
		'ENUM.JOBGENERATIONSTATE.REGEN': 'Regeneracja',
		'ENUM.JOBGENERATIONSTATE.SPLT': 'Podział ',
		'ENUM.JOBGENERATIONSTATE.UPD': 'Aktualizacja',
		'ENUM.LOCATIONTYPE.FARM': 'Gospodarstwo ',
		'ENUM.LOCATIONTYPE.FUEL': 'Stacja paliw ',
		'ENUM.LOCATIONTYPE.OTHERS': 'Inne ',
		'ENUM.LOCATIONTYPE.STABLE': 'Stabilny ',
		'ENUM.LOCATIONTYPE.WEIGHING': 'Waga ',
		'ENUM.MACHINETYPE.COMBINE': 'Kombajn zbożowy ',
		'ENUM.MACHINETYPE.EXCAVATOR': 'Koparka ',
		'ENUM.MACHINETYPE.FORAGE_HARVESTER': 'Sieczkarnia polowa',
		'ENUM.MACHINETYPE.MISC': 'Inne',
		'ENUM.MACHINETYPE.SELF_PROPELLED': 'Samojezdny',
		'ENUM.MACHINETYPE.SYREN': 'Syrena ',
		'ENUM.MACHINETYPE.TELEHANDLER': ' Ładowarka teleskopowa',
		'ENUM.MACHINETYPE.TRACTOR': 'Traktor',
		'ENUM.MACHINETYPE.TRUCK': 'Ciężarówka',
		'ENUM.MACHINETYPE.WHEELLOADER': 'Ładowarka kołowa',
		'ENUM.MSGUNIT.-': '-',
		'ENUM.MSGUNIT.AXLES': 'Osie ',
		'ENUM.MSGUNIT.CUBIC_M': 'm³ ',
		'ENUM.MSGUNIT.DOLLAR': '$ ',
		'ENUM.MSGUNIT.EURO': '€ ',
		'ENUM.MSGUNIT.KG': 'kg ',
		'ENUM.MSGUNIT.LITER': 'l',
		'ENUM.MSGUNIT.TONS': 't',
		'ENUM.MSGUNIT.h': 'h',
		'ENUM.MSGUNIT.ha': 'ha ',
		'ENUM.MSGUNIT.km': 'km ',
		'ENUM.ONLY_ON_STATE.A': 'Zawsze',
		'ENUM.ONLY_ON_STATE.F': 'Pole',
		'ENUM.ONLY_ON_STATE.L': 'Lokalizacja ',
		'ENUM.ONLY_ON_STATE.R': 'Droga',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_1200': 'AgLeader InCommand 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_800': 'AgLeader InCommand 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INTEGRA': 'AgLeader Integra',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_VERSA': 'AgLeader Versa',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD': 'Amazone Amapad',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD_2': 'Amazone Amapad 2',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_3': 'Amazone Amatron 3',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_4': 'Amazone Amatron 4',
		'ENUM.TRACTOR_TERMINAL_TYPE.AN_L10I': 'Andeo L10i',
		'ENUM.TRACTOR_TERMINAL_TYPE.A_XY': 'A_XY ',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_1200': 'Case AFS Pro 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_700': 'Case AFS Pro 700',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_1200': 'CCI 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_800': 'CCI 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_CEMIS_1200': 'Claas Cemis 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S10': 'Claas S10',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S7': 'Claas S7',
		'ENUM.TRACTOR_TERMINAL_TYPE.C_S2034': ' C_S2034 ',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_ONE': 'Fendt One',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_VARIOTERMINAL_10_4': 'Fendt Varioterminal 10.4',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_2630': 'John Deere 2630',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_GEN4': 'John Deere Gen4',
		'ENUM.TRACTOR_TERMINAL_TYPE.KV_TELLUS': 'Kverneland Tellus',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME': 'Müller Elektronik Basic',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_COMFORT': 'Müller Elektronik Comfort',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_1200': 'Müller Elektronik Touch 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_800': 'Müller Elektronik Touch 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.MF_DATATRONIC_5': 'MF Datatronic 5',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR12': 'Raven CR12',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR7': 'Raven CR7',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_VIPER4': 'Raven Viper4',
		'ENUM.TRACTOR_TERMINAL_TYPE.RH_SMART_COMMAND': 'Reichhardt Smart Command',
		'ENUM.TRACTOR_TERMINAL_TYPE.SDF_IMONITOR3': 'SDF iMonitor3',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X25': 'Topcon x25',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X30': 'Topcon x30',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X35': 'Topcon x35',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_XD': 'Topcon XD',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_1260': 'Trimble GFX 1260',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_750': 'Trimble GFX 750',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_TMX_2050': 'Trimble TMX 2050',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_1': 'Typ 1 (zapis w pamięci USB)',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_2': 'Typ 2 (nie zapisuje na pamięci USB)',
		'ENUM.TRANSPORTUNIT.-': '-',
		'ENUM.TRANSPORTUNIT.AXLES': 'Osie ',
		'ENUM.TRANSPORTUNIT.BALE': 'Belka ',
		'ENUM.TRANSPORTUNIT.CUBIC_M': 'm³',
		'ENUM.TRANSPORTUNIT.KG': 'kg',
		'ENUM.TRANSPORTUNIT.LITER': 'l',
		'ENUM.TRANSPORTUNIT.TONS': 't',
		'ENUM.USERROLE.ADMIN': ' Admin ',
		'ENUM.USERROLE.ENTERPRISE': 'Przedsiębiorstwo',
		'ENUM.USERROLE.SALES_FORCE_TECH': 'Wsparcie techniczne',
		'ENUM.USERROLE.TRAN': 'Tłumaczenie',
		'ENUM.USERROLE.USER': 'Użytkownik',
		'ENUM.USERROLE.USER_EMPL': 'Użytkownik (Enterprise)',
		'ENUM.USERSTATE.ACTIVE': 'Aktywny',
		'ENUM.USERSTATE.DISABLED': 'Wyłączone',
		'ENUM.USERSTATE.NOT_VERIFIED': 'Nie zweryfikowano',
		'ENUM.WORKSTATE.DRIVING': 'Jazda ',
		'ENUM.WORKSTATE.DRIVING_MISC': 'Oczekiwanie na jazdę',
		'ENUM.WORKSTATE.MISC_FIELD': 'Oczekiwanie na polu',
		'ENUM.WORKSTATE.MISC_FIELD_GTF': 'Zbiornik ziarna pełny ',
		'ENUM.WORKSTATE.MISC_ROAD': 'Postój na drodze',
		'ENUM.WORKSTATE.PAUSE': 'Pause ',
		'ENUM.WORKSTATE.PREPARATION': 'Praca na farmie',
		'ENUM.WORKSTATE.ROAD': 'Droga ',
		'ENUM.WORKSTATE.THRESHING': 'Młócenie ',
		'ENUM.WORKSTATE.THRESHING_U': 'Rozładunek w trakcie młócenia',
		'ENUM.WORKSTATE.THRESHING_W_SC': 'Omłot przy użyciu sieczkarni do słomy ',
		'ENUM.WORKSTATE.THRESHING_W_SC_U': 'Rozładunek podczas młócenia przy użyciu sieczkarni do słomy ',
		'ENUM.WORKSTATE.TRANSPORT_LOADED': 'Załadowany',
		'ENUM.WORKSTATE.TRANSPORT_LOADED_MISC': 'Załadowany oczekuje',
		'ENUM.WORKSTATE.TRANSPORT_LOADING': 'Załadunek',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED': 'Rozładowany ',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED_MISC': 'Oczekiwanie na rozładunek ',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING': 'Rozładunek ',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING_DRIV': 'Rozładunek podczas jazdy ',
		'ENUM.WORKSTATE.TURNING': 'Zawracanie',
		'ENUM.WORKSTATE.UNDEFINED': 'Niezdefiniowana ',
		'ENUM.WORKSTATE.WORKING': 'Praca ',
		'ENUM.WORKSTATE.WORKING_MISC': 'Oczekiwanie na pracę',
		'ERROR.NO_GPS_DATA': 'Brak danych gps dla wybranej maszyny',
		'ERROR_MESSAGE': 'Komunikat o błędzie ',
		'EVENTS': 'Wydarzenia ',
		'EVENTS.FIELD': 'Wydarzenia na boisku',
		'EVENTS.NO': 'Brak wydarzeń',
		'EXA_ADAPTERS': ' Adapter ',
		'EXA_ADAPTERS.AR_ACTIVATE': 'Aktywuj adapter w Agrirouter ',
		'EXA_ADAPTERS.AR_DEACTIVATE': 'Usuń adapter w Agrirouter ',
		'EXA_ADAPTERS.AR_LINK_SUCCESS': 'Adapter aktywowany w Agrirouter ',
		'EXA_ADAPTERS.AR_UNLINK_SUCCESS': ' Adapter usunięty z Agrirouter',
		'EXCEPTION.1': 'Błąd wewnętrzny ',
		'EXCEPTION.100': 'Enum nieważne',
		'EXCEPTION.1000': 'Username is empty ',
		'EXCEPTION.10000': 'Nazwa pliku jest pusta ',
		'EXCEPTION.10001': 'Dane są puste ',
		'EXCEPTION.10002': 'FormatTyp nieprawidłowy',
		'EXCEPTION.10003': 'DataRequestType nieprawidłowy',
		'EXCEPTION.10004': 'Brak RawData',
		'EXCEPTION.1001': 'Długość nazwy użytkownika jest za krótka',
		'EXCEPTION.1002': 'Nazwa użytkownika jest już zajęta ',
		'EXCEPTION.1003': 'Nieprawidłowy adres e-mail ',
		'EXCEPTION.1004': 'Adres e-mail jest już zajęty ',
		'EXCEPTION.1005': 'Hasło jest za krótkie',
		'EXCEPTION.1007': 'Nieprawidłowy kod weryfikacyjny',
		'EXCEPTION.1008': 'Niepoprawna nazwa użytkownika (lub adres e-mail) ',
		'EXCEPTION.101': ' Niepoprawna funkcja pracownika ',
		'EXCEPTION.1011': ' Użytkownik nie istnieje',
		'EXCEPTION.1012': ' Użytkownik został usunięty ',
		'EXCEPTION.1013': 'Użytkownik jest nieaktywny',
		'EXCEPTION.1014': 'Użytkownik jest zablokowany',
		'EXCEPTION.1015': 'Użytkownik nie jest aktywowany ',
		'EXCEPTION.1016': 'Użytkownik to konto firmowe',
		'EXCEPTION.102': 'Nieprawidłowa waluta',
		'EXCEPTION.1020': 'Użytkownik już istnieje ',
		'EXCEPTION.1021': ' Adres e-mail jest już zajęty ',
		'EXCEPTION.1022': 'Adres e-mail nie uległ zmianie ',
		'EXCEPTION.1023': 'Aktualne hasło nie jest zgodne',
		'EXCEPTION.1024': 'Nazwa użytkownika jest już zajęta',
		'EXCEPTION.1025': 'Użytkownik i kod nie są zgodne',
		'EXCEPTION.1026': 'Niepoprawna nazwa użytkownika (lub adres e-mail)',
		'EXCEPTION.1027': 'Użytkownik jest już aktywowany',
		'EXCEPTION.1028': 'Zabronione dla kont pracowników utworzonych dla przedsiębiorstwa ',
		'EXCEPTION.103': 'Jednostka transportowa nieprawidłowa',
		'EXCEPTION.104': ' Niepoprawny typ lokalizacji ',
		'EXCEPTION.105': 'Jednostka kosztów nieprawidłowa',
		'EXCEPTION.106': 'Jednostka nieprawidłowa',
		'EXCEPTION.107': 'Typ maszyny nieprawidłowy',
		'EXCEPTION.108': 'Nieprawidłowy status pracownika ',
		'EXCEPTION.11000': 'Typ nieprawidłowy',
		'EXCEPTION.12000': 'Typ nieprawidłowy',
		'EXCEPTION.12002': 'Liczba porządkowa jest nieważna',
		'EXCEPTION.12003': 'Stan roboczy nieprawidłowy',
		'EXCEPTION.12004': 'Nieprawidłowy status pracy',
		'EXCEPTION.12006': 'Brak konfiguracji T2',
		'EXCEPTION.12007': 'MAC jest pusty ',
		'EXCEPTION.12008': 'Nieprawidłowy MAC ',
		'EXCEPTION.12009': 'Adapter już istnieje ',
		'EXCEPTION.12010': 'Nieprawidłowy typ adaptera',
		'EXCEPTION.15000': 'Czas rozpoczęcia jest nieznany lub ma nastąpić w przyszłości ',
		'EXCEPTION.15001': 'Czas rozpoczęcia jest nieznany lub ma nastąpić w przyszłości',
		'EXCEPTION.15002': 'Czas zatrzymania jest równy lub wcześniejszy od czasu rozpoczęcia ',
		'EXCEPTION.15003': 'Nie można wygenerować pakietu SILO - brak danych pierwotnych ',
		'EXCEPTION.15004': 'Dane początkowe są zbyt stare',
		'EXCEPTION.16000': 'Nazwa jest pusta ',
		'EXCEPTION.16001': 'Przypisany klient nie istnieje',
		'EXCEPTION.16002': 'Lista znaczników jest pusta',
		'EXCEPTION.16003': 'Lista znaczników musi zawierać co najmniej trzy znaczniki ',
		'EXCEPTION.16004': 'Powierzchnia jest pusta ',
		'EXCEPTION.16005': 'Nieprawidłowy typ znacznika',
		'EXCEPTION.16006': 'Pole nie należy do zadania ',
		'EXCEPTION.16007': 'Wielkość siatki jest większa niż połowa wysokości i szerokości pola ',
		'EXCEPTION.16008': 'Brak danych do interpolacji ',
		'EXCEPTION.16009': ' Wszystkie dane zawierają tę samą wartość',
		'EXCEPTION.17000': ' Nazwa jest pusta ',
		'EXCEPTION.17001': 'Osoba do kontaktu jest pusta',
		'EXCEPTION.17002': 'Telefon jest pusty',
		'EXCEPTION.17003': 'Adres e-mail jest pusty ',
		'EXCEPTION.17004': 'Nieprawidłowy adres e-mail ',
		'EXCEPTION.17005': 'Adres jest pusty',
		'EXCEPTION.17006': 'Kod pocztowy jest pusty ',
		'EXCEPTION.17007': 'Miasto jest puste ',
		'EXCEPTION.17008': 'Kolor nieprawidłowy ((AA)RRGGBB) ',
		'EXCEPTION.18000': 'Typ nieprawidłowy',
		'EXCEPTION.19001': 'Typ nieprawidłowy',
		'EXCEPTION.19002': 'MAC jest pusty',
		'EXCEPTION.19003': 'Nieprawidłowy MAC ',
		'EXCEPTION.19004': 'Moc jest mniejsza niż zero',
		'EXCEPTION.19007': 'Pole Pracownik jest puste',
		'EXCEPTION.19008': 'Beacon nie jest beaconem implementacyjnym',
		'EXCEPTION.19009': ' Beacon nie jest beaconem dla kierowców ',
		'EXCEPTION.2': ' Duplikat wpisu',
		'EXCEPTION.200': 'Błąd przetwarzania typu obiektu Json ',
		'EXCEPTION.2000': 'Tworzenie kodu weryfikacyjnego nie powiodło się',
		'EXCEPTION.20000': 'Zbyt mała ilość danych surowych',
		'EXCEPTION.20001': 'Tworzenie pliku archiwum nie powiodło się',
		'EXCEPTION.20002': 'Ładowanie pliku archiwum nie powiodło się ',
		'EXCEPTION.2001': ' Kod weryfikacyjny jest nieprawidłowy ',
		'EXCEPTION.2002': 'Nieprawidłowy kod weryfikacyjny ',
		'EXCEPTION.201': ' Błąd zapisu typu obiektu do Json ',
		'EXCEPTION.21000': 'Nazwa przedsiębiorstwa jest pusta ',
		'EXCEPTION.21001': ' Nazwa przedsiębiorstwa jest już zajęta ',
		'EXCEPTION.21002': 'Długość nazwy przedsiębiorstwa jest poniżej minimalnej długości ',
		'EXCEPTION.21003': ' Niepoprawny adres e-mail przedsiębiorstwa ',
		'EXCEPTION.21004': 'Kod dostępu już istnieje',
		'EXCEPTION.21005': 'Przedsiębiorstwo zostanie usunięte ',
		'EXCEPTION.21006': 'Przedsiębiorstwo jest dezaktywowane ',
		'EXCEPTION.21007': 'Przedsiębiorstwo jest zablokowane',
		'EXCEPTION.21008': ' Niepoprawny typ przedsiębiorstwa ',
		'EXCEPTION.22000': 'Brak miejsc pracy do dodania ',
		'EXCEPTION.22001': 'Nie zmieniono miejsc pracy ',
		'EXCEPTION.23000': 'Przedsiębiorstwo nie zostało włączone',
		'EXCEPTION.23001': 'Przedsiębiorstwo już włączone',
		'EXCEPTION.23002': 'Adapter nie znajduje się na pokładzie',
		'EXCEPTION.23003': 'Adapter już zainstalowany',
		'EXCEPTION.23004': 'Nie można włączyć adaptera ',
		'EXCEPTION.23005': 'Nie można ponownie zainstalować adaptera ',
		'EXCEPTION.23006': 'Nie można wyłączyć adaptera',
		'EXCEPTION.23007': 'Publikowanie możliwości vCU nie powiodło się ',
		'EXCEPTION.23008': 'Publikowanie danych vCU nie powiodło się ',
		'EXCEPTION.23009': 'Publikowanie opisu urządzenia vCU nie powiodło się ',
		'EXCEPTION.23010': 'Publikowanie możliwości przedsiębiorstwa nie powiodło się ',
		'EXCEPTION.23011': ' Błąd certyfikatu Agrirouter! Czy odnowiłeś połączenie Agrirouter? ',
		'EXCEPTION.24000': 'Nazwa przedsiębiorstwa jest pusta',
		'EXCEPTION.24001': 'Nazwa przedsiębiorstwa jest już zajęta ',
		'EXCEPTION.24002': 'Długość nazwy przedsiębiorstwa jest krótsza od wymaganego minimum ',
		'EXCEPTION.24003': 'Niepoprawny adres e-mail przedsiębiorstwa ',
		'EXCEPTION.24004': 'Token dostępu już istnieje ',
		'EXCEPTION.24005': 'Przedsiębiorstwo zostaje usunięte ',
		'EXCEPTION.24006': 'Przedsiębiorstwo jest dezaktywowane ',
		'EXCEPTION.24007': 'Przedsiębiorstwo jest zablokowane ',
		'EXCEPTION.25000': 'Funkcja niedostępna dla wybranego partnera ',
		'EXCEPTION.25001': 'Synchronizacja pól nie powiodła się',
		'EXCEPTION.25002': 'Synchronizacja maszyn nie powiodła się ',
		'EXCEPTION.25003': 'Synchronizacja narzędzi nie powiodła się ',
		'EXCEPTION.25004': 'Pobieranie maszyny nie powiodło się ',
		'EXCEPTION.25005': 'Tworzenie maszyny nie powiodło się',
		'EXCEPTION.25006': ' Aktualizacja maszyny nie powiodła się ',
		'EXCEPTION.25007': 'Usuwanie maszyny nie powiodło się',
		'EXCEPTION.25008': 'Wdrożenie nie powiodło się ',
		'EXCEPTION.25009': 'Tworzenie implementacji nie powiodło się ',
		'EXCEPTION.25010': ' Aktualizacja urządzenia nie powiodła się ',
		'EXCEPTION.25011': 'Usuwanie urządzenia nie powiodło się ',
		'EXCEPTION.26000': 'Tworzenie pliku PDF nie powiodło się ',
		'EXCEPTION.26001': 'Wybrane zadanie nie jest zadaniem z włączoną funkcją SyreN. ',
		'EXCEPTION.27000': 'Maszyna nie obsługuje plików TaskData ',
		'EXCEPTION.27001': 'Tworzenie pliku TaskData nie powiodło się ',
		'EXCEPTION.27002': 'Nie udało się załadować pliku TaskData ',
		'EXCEPTION.27003': 'Maszyna nie ma przypisanego adaptera ',
		'EXCEPTION.27004': 'Nazwa jest pusta ',
		'EXCEPTION.27005': ' Planowana data jest pusta ',
		'EXCEPTION.27006': ' Planowana data nie przypada w przyszłości ',
		'EXCEPTION.27007': 'Stan jest pusty ',
		'EXCEPTION.27008': 'Plik jest pusty ',
		'EXCEPTION.27009': 'Nazwa pliku jest pusta',
		'EXCEPTION.27010': ' Data jest pusta ',
		'EXCEPTION.27011': 'Data nie przypada w przyszłości',
		'EXCEPTION.27012': 'Wielkość jest mniejsza niż jeden',
		'EXCEPTION.27013': ' Operacja TaskData nie jest możliwa w tym momencie',
		'EXCEPTION.27014': ' Nazwa pliku jest już zajęta',
		'EXCEPTION.27015': 'Brak otwartych zadań',
		'EXCEPTION.27016': 'Można pobrać tylko jeden plik TaskData bez opłat',
		'EXCEPTION.28001': 'Nieobsługiwany typ pliku ',
		'EXCEPTION.29000': 'Aktualizacja niedozwolona (już zrealizowana)',
		'EXCEPTION.29001': ' Nie określono żadnej maszyny ani narzędzia',
		'EXCEPTION.29002': 'Dozwolone tylko maszyny LUB narzędzia ',
		'EXCEPTION.29003': ' Wartość bazowa musi być większa od zera ',
		'EXCEPTION.29004': 'Wartość Warn musi być większa od zera',
		'EXCEPTION.29005': 'Wartość należna musi być większa od zera ',
		'EXCEPTION.29006': 'Przedział czasowy musi być większy niż przedział ostrzeżeń',
		'EXCEPTION.3000': 'Nieprawidłowe dane logowania ',
		'EXCEPTION.3001': 'Konto jest zablokowane ',
		'EXCEPTION.3002': ' Konto nie jest aktywne ',
		'EXCEPTION.3003': 'Sesja wygasła - Proszę zalogować się ponownie ',
		'EXCEPTION.3004': ' Inny użytkownik zalogowany na to samo konto',
		'EXCEPTION.31000': 'Aplikacja nie jest obsługiwana',
		'EXCEPTION.4000': ' Pole Make jest puste ',
		'EXCEPTION.4001': 'Pole Model jest puste ',
		'EXCEPTION.4002': 'Rok musi być większy od 1950, oraz nie może być w przyszłości',
		'EXCEPTION.4003': 'Koszt jest mniejszy lub równy zero ',
		'EXCEPTION.4004': 'Godziny pracy są mniejsze od zera ',
		'EXCEPTION.4005': 'Przebieg jest mniejszy od zera',
		'EXCEPTION.4007': 'Szerokość robocza jest mniejsza od zera',
		'EXCEPTION.4008': ' Kolor nieprawidłowy ((AA)RRGGBB) ',
		'EXCEPTION.4009': ' XtrCanValuesConfig nieprawidłowy ',
		'EXCEPTION.401': 'Nieautoryzowany',
		'EXCEPTION.4010': 'Zbyt wiele wartości konfiguracyjnych ',
		'EXCEPTION.4011': 'Nieprawidłowa konfiguracja układu dynamicznego',
		'EXCEPTION.4012': 'Typ maszyny nie jest ciągnikiem',
		'EXCEPTION.4013': 'Maksymalna liczba licencji jest wykorzystana',
		'EXCEPTION.4014': ' Data jest w przyszłości',
		'EXCEPTION.4015': 'Blokada prędkości jest nieprawidłowa',
		'EXCEPTION.403': 'Zakazane',
		'EXCEPTION.450': ' Błąd polecenia ',
		'EXCEPTION.451': 'Brak wymaganej licencji',
		'EXCEPTION.452': 'Nieprawidłowy parametr filtra',
		'EXCEPTION.5000': 'Pole Make jest puste',
		'EXCEPTION.5001': 'Pole Model jest puste',
		'EXCEPTION.5002': 'Rok musi być większy od 1950, oraz nie może być w przyszłości',
		'EXCEPTION.5003': 'Typ1 jest pusty',
		'EXCEPTION.5004': 'Typ2 jest nieprawidłowy',
		'EXCEPTION.5005': 'Koszt jest mniejszy lub równy zero ',
		'EXCEPTION.5006': 'Szerokość robocza jest mniejsza od zera',
		'EXCEPTION.5007': 'Wartość transportowa jest mniejsza od zera ',
		'EXCEPTION.5008': 'Jednostka transportowa jest nieprawidłowa. ',
		'EXCEPTION.5009': 'Typ3 jest nieprawidłowy ',
		'EXCEPTION.5010': 'Nieprawidłowa kombinacja typów',
		'EXCEPTION.5011': 'Nieprawidłowy identyfikator rachunkowości ',
		'EXCEPTION.6000': 'Typ nieprawidłowy',
		'EXCEPTION.6001': 'Promień jest pusty lub poniżej zera ',
		'EXCEPTION.6002': 'Nazwa jest pusta',
		'EXCEPTION.6003': 'Lista znaczników jest pusta',
		'EXCEPTION.6004': 'Lista znaczników musi zawierać co najmniej trzy znaczniki ',
		'EXCEPTION.6005': 'Nieprawidłowy typ znacznika',
		'EXCEPTION.6006': 'Nieprawidłowy typ wagi',
		'EXCEPTION.700': 'Nieprawidłowa nazwa zmiennej',
		'EXCEPTION.7001': ' Konto nie istnieje ',
		'EXCEPTION.7002': 'Konto jest zablokowa',
		'EXCEPTION.701': 'Nieprawidłowy wzór',
		'EXCEPTION.702': 'CANIdName nieprawidłowe',
		'EXCEPTION.703': 'Nieprawidłowy stan',
		'EXCEPTION.704': 'Nieprawidłowa nazwa zmiennej ',
		'EXCEPTION.705': 'Nieprawidłowy parametr stanu pracy ',
		'EXCEPTION.706': 'Stan roboczy nieprawidłowy dla typu urządzenia',
		'EXCEPTION.707': ' Tworzenie pliku nie powiodło się',
		'EXCEPTION.800': 'Niepoprawna nazwa wartości ConfigValue ',
		'EXCEPTION.8000': 'Pole pracodawcy jest puste ',
		'EXCEPTION.8001': 'Pole pracownik jest puste  ',
		'EXCEPTION.8002': 'Pracownik nie został odnaleziony przez pracodawcę',
		'EXCEPTION.8003': 'Koszt mniejszy od zera',
		'EXCEPTION.8004': 'Maksymalna liczba pobranych licencji użytkownika',
		'EXCEPTION.8005': 'Nie jest to twój pracodawca',
		'EXCEPTION.8006': 'Pracownik już istnieje',
		'EXCEPTION.8007': 'Token dostępowy jest pusty',
		'EXCEPTION.8008': 'Nieprawidłowy token dostępu ',
		'EXCEPTION.8009': 'W przedsiębiorstwie musi istnieć co najmniej jeden administrator ',
		'EXCEPTION.8010': ' Użytkownik może być połączony tylko z przedsiębiorstwem, które go utworzyło ',
		'EXCEPTION.900': 'Nie istnieje ',
		'EXCEPTION.9000': 'Czas rozpoczęcia jest nieokreślony lub wypada w przyszłości',
		'EXCEPTION.9001': 'Czas zatrzymania jest nieokreślony lub wypada w przyszłości',
		'EXCEPTION.9002': 'Czas zatrzymania jest równy lub wcześniejszy od czasu rozpoczęcia ',
		'EXCEPTION.9003': 'Kierowca nie jest pracownikiem firmy zlecającej pracę ',
		'EXCEPTION.9004': 'Implementacja nie należy do pracodawcy',
		'EXCEPTION.9005': 'Typ1 nieważny',
		'EXCEPTION.9006': 'Typ2 nieważny',
		'EXCEPTION.9007': 'Typ3 nieważny',
		'EXCEPTION.9008': 'Nie można wygenerować zadania - brak danych wyjściowych',
		'EXCEPTION.9009': 'Właściciel maszyny nie jest zgodny z właścicielem narzędzia roboczego',
		'EXCEPTION.901': 'Już istnieje',
		'EXCEPTION.9010': 'Praca już istnieje ',
		'EXCEPTION.9012': 'Praca nie jest jeszcze gotowa',
		'EXCEPTION.9013': 'Zadanie jest zaznaczone do usunięcia ',
		'EXCEPTION.9014': 'Praca została zarchiwizowana - Brak dostępnych lokalizacji pracy',
		'EXCEPTION.9015': 'Zbyt stare wartości danych surowych. ',
		'EXCEPTION.9016': 'Co najmniej jedna praca jest częścią zadania',
		'EXCEPTION.9017': 'Miejsca pracy nie pasują do siebie (maszyna, kierowca, urządzenie muszą się zgadzać)',
		'EXCEPTION.9018': 'Zbyt duża rozbieżność między miejscami pracy ',
		'EXCEPTION.9019': 'Co najmniej jedna praca jest częścią zadania ',
		'EXCEPTION.902': 'Właściciel nie istnieje ',
		'EXCEPTION.9020': 'Brak czasu podziału',
		'EXCEPTION.9021': 'Czas podziału nie jest dłuższy niż czas rozpoczęcia i krótszy niż czas zakończenia ',
		'EXCEPTION.9022': 'Brak identyfikatorów zadań do połączenia',
		'EXCEPTION.9023': 'Wymagane co najmniej dwa miejsca pracy',
		'EXCEPTION.9024': 'Gęstość punktów musi być większa od zera i mniejsza lub równa jeden ',
		'EXCEPTION.903': 'Obiekt o podanym id nie istnieje ',
		'EXCEPTION.904': 'Szerokość geograficzna poza zasięgiem',
		'EXCEPTION.905': 'Długość geograficzna poza zasięgiem',
		'EXCEPTION.906': 'Nie zgadza się właściciel',
		'EXCEPTION.907': 'Parametr jest pusty ',
		'EXCEPTION.99': 'Nieprawidłowy parametr ',
		'EXPORT': ' Eksport ',
		'EXPORT.FILTERED_JOBS': 'Eksportuj wszystkie przefiltrowane zadania',
		'EXPORT.JOB_DETAILS': 'Eksportuj szczegóły zadania',
		'EXPORT.OPERATIONS.CUSTOMER.PERIOD': 'Eksport wszystkich danych klienta w wybranym okresie',
		'EXPORT.OPERATIONS.FIELDS.PERIOD': 'Eksport wszystkich operacji na polach w wybranym okresie ',
		'EXPORT.OPERATIONS.LOCATIONS.PERIOD': 'Eksport wszystkich operacji na lokalizacjach w wybranym okresie ',
		'EXPORT.POINTS': 'Punkty danych',
		'EXPORT.POLYGONS': 'Wielokąty',
		'EXPORT.RAW_DATA_AS_SILO': 'Eksport danych wyjściowych jako plik SILO ',
		'EXPORT.SELECTED': 'Wybór eksportu',
		'EXPORT.SELECT_DATA': 'Proszę wybrać dane, które mają być zawarte w raporcie PDF ',
		'EXPORT.SELECT_PERIOD': 'Wybierz okres do eksportu:',
		"FERTILIZER": "Nawóz ",
		'FIELD': ' Pole ',
		'FIELD.ADD': 'Dodaj pole',
		'FIELD.ADD.SUCCESS': 'Pole zostało pomyślnie dodane ',
		'FIELD.DEACTIVATE.QUESTION': 'Czy naprawdę chcesz dezaktywować pole?',
		'FIELD.DEACTIVATE.SUCCESS': 'Pole bylo úspěšně deaktivováno',
		'FIELD.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć to pole? ',
		'FIELD.DELETE.SUCCESS': 'Pole pomyślnie usunięte',
		'FIELD.DETAILS': 'Szczegóły pola',
		'FIELD.DRAW.START': 'Narysuj granice pól na mapie!',
		'FIELD.EDIT.SUCCESS': 'Pole pomyślnie edytowane ',
		'FIELD.INTERPOLATE': ' Interpoluj ',
		'FIELD.INTERPOLATED_VALUES': 'Wartości interpolowane',
		'FIELD.INTERPOLATION': 'Interpolacja ',
		'FIELD.INTERPOLATION_SETTINGS': 'Ustawienia interpolacji ',
		'FIELD.INTERPOLATION_SETTINGS.FINE': 'Dobrze ',
		'FIELD.INTERPOLATION_SETTINGS.FINE+': 'Bardzo dobrze ',
		'FIELD.INTERPOLATION_SETTINGS.ROUGH': 'Surowy',
		'FIELD.INTERPOLATION_SETTINGS.STANDARD': 'Standard ',
		'FIELD.NUMBER': 'Numer pola ',
		'FIELD.PROCESSED': 'Pole przetwarzane',
		'FIELDS': 'Pola',
		'FIELDS.ALL': 'Wszystkie pola',
		'FIELDS.DEACTIVATE.FAILURE': 'Niektórych pól nie można było dezaktywować.',
		'FIELDS.DEACTIVATE.QUESTION': 'Czy naprawdę chcesz dezaktywować pola?',
		'FIELDS.DEACTIVATE.SUCCESS': 'Pole byla úspěšně deaktivována',
		'FIELDS.DELETE.FAILURE': 'Niektóre pola nie mogły zostać usunięte.',
		'FIELDS.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć wybrane pola?',
		'FIELDS.DELETE.SUCCESS': 'Pola zostały pomyślnie usunięte ',
		'FIELDS.EDIT': 'Edytuj pola',
		'FIELDS.IMPORT': 'Pola importowe ',
		'FIELDS.IMPORT.ASSIGN_CUSTOMER.QUESTION': 'Czy chcesz przypisać klienta do wybranych pól? ',
		'FIELDS.IMPORT.SHAPE': 'Proszę wybrać plik SHAPE do importu.',
		'FIELDS.IMPORT.SUCCESS': 'Úspěšně importovaná pole',
		'FIELDS.MANAGEMENT': 'Zarządzanie polami',
		'FIELDS.NO': 'Brak pól ',
		'FIELDS.NOT_SELECTED': 'Nie wybrano żadnych pól ',
		'FIELDS.REACTIVATE.FAILURE': 'Niektórych pól nie można było ponownie aktywować.',
		'FIELDS.REACTIVATE.QUESTION': 'Czy naprawdę chcesz ponownie aktywować wybrane pola?',
		'FIELDS.REACTIVATE.SUCCESS': 'Pomyślna reaktywacja pól',
		'FIELDS.SELECT': 'Wybierz pola',
		'FIELDS.SELECTED': 'Wybrane pola',
		'FILE': 'Plik ',
		'FILE.GENERATING': 'Plik jest generowany i dodawany do menedżera plików w skrócie',
		'FILE.GENERATING.READY': 'Nowy plik jest gotowy do pobrania',
		'FILE.MANAGER': 'Menedżer plików',
		'FILE.NO_FILES': 'Brak istniejących plików',
		'FILE.UPLOAD': ' Prześlij plik',
		'FILE_TRANSFER': 'Zarządzanie ISOTaskData',
		'FILE_TRANSFER.ADD': 'Dodaj ISOTaskData',
		'FILE_TRANSFER.ADD.SUCCESS': 'ISOTaskData została pomyślnie dodana',
		'FILE_TRANSFER.CREATE': 'Dodaj ISOTaskData',
		'FILE_TRANSFER.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć ISOTaskData?',
		'FILE_TRANSFER.DELETE.SUCCESS': 'ISOTaskData została pomyślnie usunięta',
		'FILE_TRANSFER.FINISHED_TASKS': 'Gotowe zadania',
		'FILE_TRANSFER.NO': 'Nr ISOTaskData',
		'FILE_TRANSFER.QUEUED_TASKS': 'Zadania w kolejce',
		'FILTER': 'Filtr ',
		'FIRMWARE_VERSION': 'Wersja oprogramowania sprzętowego ',
		'FIRSTNAME': 'Imię ',
		'FORMS.FILE_TOO_LARGE': 'Plik jest zbyt duży',
		'FORMS.NO_PASSWORD_MATCH': 'Hasła nie pasują do siebie!',
		'FORMS.REQUIRED': 'Wymagane',
    'FORMS.INVALID_EMAIL': 'Nieprawidłowy adres e-mail',
		'FORMULA': ' Formuła ',
		'FUEL': 'Paliwo ',
		'FUEL.CONSUMPTION': 'Zużycie paliwa na ha',
		'FUEL.CONSUMPTION.AREA': 'Poziom zużycia paliwa na powierzchnię ',
		'FUEL.CONSUMPTION.AVERAGE': 'Zużycie paliwa',
		'FUEL.CONSUMPTION.OVERALL': 'Ogólne zużycie paliwa',
		'FUEL.CONSUMPTION.TOTAL': 'Całkowite zużycie paliwa',
		'FUEL.COST': 'Koszt paliwa ',
		'FUEL.LEVEL': 'Poziom paliwa ',
		'FUEL.PRICE_PER_LITER': 'Cena paliwa za litr',
		'FUEL.WARNING': 'Niski poziom paliwa! ',
		'GENERAL_INSPECTION': 'Kontrola ogólna ',
		'GEOMETRIES.UPDATE': 'Aktualizacja pól i lokalizacji',
		'GEOMETRY.ADD.REGENERATION_NEEDED': 'Wszystkie dane bazowe muszą zostać zaktualizowane, aby przypisać je poprawnie po dodaniu nowej geometrii. Czy chcesz zaktualizować dane teraz?',
		'GEOMETRY.CLICK_TO_SAVE': 'Aby zapisać, kliknij na mapa.',
		'GPS': 'GPS',
		'GPS.GPS': 'Wewnętrzny GPS ',
		'GPS.LP': 'Ostatnia znana pozycja',
		'GPS.RTK': 'RTK',
		'GPS.RTK_H': 'RTK (duża dokładność)',
		'GPS.STATUS': 'Status GPS',
		'GPS_HITCH_DISTANCE.IMPLEMENT.INFO': 'For recording the machine track correctly you need to input the distance between the hitch (A) and the point of application of the implement (B). The distance is measured in cm.',
		'GPS_HITCH_DISTANCE.MACHINE.INFO': 'For recording the machine track correctly you need to input the distance between the GPS receiver (A) and the hitch of the machine (B). The distance is measured in cm.',
		'GPS_TO_HITCH_DISTANCE': 'Odległość GPS do zaczepu',
		'HARDWARE': 'Oprogramowanie',
		'HARDWARE.SETUP.PRINT_STICKER': 'Drukowanie naklejek na sprzęt',
		'HARDWARE.SETUP.PRINT_STICKER_PACKAGING': 'Drukuj naklejkę na opakowanie',
		'HARDWARE.SETUP.RESET_DEVICE': 'Reset urządzenia',
		'HARDWARE.SETUP.SET_SERIAL': 'Ustaw serial',
		'HEADLAND.PASSES': 'Headland passes',
		'HELPER_MODEL_TEXT': 'Model zgodnie z danymi wejściowymi',
		'HINT_MARKERS.SHOW': 'Pokaż znaczniki wskazówek',
		'HITCH_TO_APPLICATION_DISTANCE': 'Odległość między zaczepem a aplikacją',
		'HOME': ' Witamy',
		'HOME.CONTACTREPLY1': ' W tym celu zapraszamy do kontaktu telefonicznego ',
		'HOME.CONTACTREPLY2': 'lub wyślij nam e-mail na adres ',
		'HOME.INTRODUCTORY_VIDEOS': ' Filmy wprowadzające ',
		'HOME.NEWSINFO1': 'Wszystkie nowości i interesujące informacje na temat zarządzania flotą i śledzenia maszyn można znaleźć na naszej stronie internetowej ',
		'HOME.NEWSINFO2': 'lub na naszej ',
		'HOME.PROFILEEXPLANATION': 'W zakładce \"Mój profil\" możesz zmienić swoje dane osobowe, e-mail i hasło. ',
		'HOME.QUESTIONSYSTEM': 'Czy masz jakieś pytania dotyczące naszego systemu? ',
		'HOME.TITLE': 'Witamy ',
		'HOME.WELCOMEAREA': 'Witaj na swoim gospodarstwie! ',
		'IDLE': 'Idle',
		'IGNORE': 'Zignoruj',
		'IMPLEMENT': 'Implementcja',
		'IMPLEMENT.ADD': 'Dodaj implementacje',
		'IMPLEMENT.ADD.SUCCESS': 'Implementacja dodana pomyślnie ',
		'IMPLEMENT.CLASS': 'Klasa implementu',
		'IMPLEMENT.DELETE.QUESTION': ' Czy naprawdę chcesz usunąć implementacje?',
		'IMPLEMENT.DELETE.SUCCESS': 'Implementacja pomyślnie usunięty ',
		'IMPLEMENT.DETAILS': 'Szczegóły implementu',
		'IMPLEMENT.EDIT': 'Edytuj implementację',
		'IMPLEMENT.EDIT.SUCCESS': 'Implementacja zakończona sukcesem ',
		'IMPLEMENT.FIXED': 'Naprawiono implementację',
		'IMPLEMENT.NO': 'Brak implementacji',
		'IMPLEMENT.PROCESS.0': 'Brak osprzętu',
		'IMPLEMENT.PROCESS.1': 'Prasowanie bel okrągłych',
		'IMPLEMENT.PROCESS.10': 'Rolowanie ',
		'IMPLEMENT.PROCESS.11': 'Siew',
		'IMPLEMENT.PROCESS.12': ' Sadzenie ',
		'IMPLEMENT.PROCESS.13': 'Nawożenie',
		'IMPLEMENT.PROCESS.14': 'Oprysk',
		'IMPLEMENT.PROCESS.15': 'Nawadnianie ',
		'IMPLEMENT.PROCESS.16': 'Koszenie',
		'IMPLEMENT.PROCESS.17': 'Odbiór',
		'IMPLEMENT.PROCESS.18': 'Transport',
		'IMPLEMENT.PROCESS.19': 'Zamiatanie',
		'IMPLEMENT.PROCESS.2': 'Prasowanie bel prostokątnych',
		'IMPLEMENT.PROCESS.20': 'Pług śnieżny',
		'IMPLEMENT.PROCESS.21': 'Rozsypywanie soli',
		'IMPLEMENT.PROCESS.22': 'Ogławianie',
		'IMPLEMENT.PROCESS.23': 'Nawożenie ',
		'IMPLEMENT.PROCESS.24': 'Pompowanie gnojowicy',
		'IMPLEMENT.PROCESS.25': 'Mieszanie gnojowicy ',
		'IMPLEMENT.PROCESS.26': 'Sadzenie ziemniaków',
		'IMPLEMENT.PROCESS.27': 'Zbiór ziemniaków',
		'IMPLEMENT.PROCESS.28': 'Rozdzielanie ',
		'IMPLEMENT.PROCESS.29': 'Formowanie redliny ',
		'IMPLEMENT.PROCESS.3': 'Owijanie bel',
		'IMPLEMENT.PROCESS.30': 'Usuwanie łęcin',
		'IMPLEMENT.PROCESS.31': 'Koszenie na pokos',
		'IMPLEMENT.PROCESS.32': 'Bronowanie',
		'IMPLEMENT.PROCESS.33': 'Bronowanie',
		'IMPLEMENT.PROCESS.34': 'Siekanie',
		'IMPLEMENT.PROCESS.35': 'Zamiatanie',
		'IMPLEMENT.PROCESS.36': 'Odśnieżanie',
		'IMPLEMENT.PROCESS.37': 'Transport zbiorników na gnojowicę',
		'IMPLEMENT.PROCESS.38': 'Formowanie legowisk',
		'IMPLEMENT.PROCESS.39': 'Żywienie',
		'IMPLEMENT.PROCESS.4': 'owijanie bel ',
		'IMPLEMENT.PROCESS.40': 'Transport drewna ',
		'IMPLEMENT.PROCESS.41': 'Piłowanie drewna ',
		'IMPLEMENT.PROCESS.42': 'Rozdrabnianie drewna',
		'IMPLEMENT.PROCESS.43': 'Frezowanie pniaków',
		'IMPLEMENT.PROCESS.44': 'Załadunek materiałów sypkich',
		'IMPLEMENT.PROCESS.45': 'Załadunek palet ',
		'IMPLEMENT.PROCESS.46': 'Załadunek bel ',
		'IMPLEMENT.PROCESS.47': 'Mielenie CCM',
		'IMPLEMENT.PROCESS.48': 'Push',
		'IMPLEMENT.PROCESS.49': 'Ciężar przód/tył',
		'IMPLEMENT.PROCESS.5': ' Orka',
		'IMPLEMENT.PROCESS.50': 'Młócenie',
		'IMPLEMENT.PROCESS.51': 'Siekanie',
		'IMPLEMENT.PROCESS.52': ' Prasowanie bel o wysokim docisku',
		'IMPLEMENT.PROCESS.53': ' Unleafing ',
		'IMPLEMENT.PROCESS.54': 'Frezowanie',
		'IMPLEMENT.PROCESS.55': 'Uprawa gleby',
		'IMPLEMENT.PROCESS.56': 'Strzyżenie',
		'IMPLEMENT.PROCESS.57': 'Prace montażowe',
		'IMPLEMENT.PROCESS.58': 'Entrain',
		'IMPLEMENT.PROCESS.59': 'Załadunek i rozładunek',
		'IMPLEMENT.PROCESS.6': 'Kultywatorowanie',
		'IMPLEMENT.PROCESS.60': 'Mycie',
		'IMPLEMENT.PROCESS.61': 'Zagęszczanie',
		'IMPLEMENT.PROCESS.7': 'Bronowanie',
		'IMPLEMENT.PROCESS.8': 'Głęboszowanie',
		'IMPLEMENT.PROCESS.9': 'Bronowanie wirnikowe',
		'IMPLEMENT.PROCESS.deadhead': 'Bez wdrożenia',
		'IMPLEMENT.REMOVE': 'Usunąć narzędzie',
		'IMPLEMENT.RESOURCE.0': 'niezdefiniowane',
		'IMPLEMENT.RESOURCE.1': 'Pasza ',
		'IMPLEMENT.RESOURCE.10': 'Obornik',
		'IMPLEMENT.RESOURCE.11': 'Gnojowica ',
		'IMPLEMENT.RESOURCE.12': 'Kompost',
		'IMPLEMENT.RESOURCE.13': 'Aplikowanie gnojowicy wężami',
		'IMPLEMENT.RESOURCE.14': 'Zrębki drewniane',
		'IMPLEMENT.RESOURCE.15': 'Kukurydza',
		'IMPLEMENT.RESOURCE.16': 'Słonecznik',
		'IMPLEMENT.RESOURCE.17': 'Sorgo ',
		'IMPLEMENT.RESOURCE.18': 'Żyto',
		'IMPLEMENT.RESOURCE.19': 'Pszenżyto',
		'IMPLEMENT.RESOURCE.2': 'Sianokiszonka',
		'IMPLEMENT.RESOURCE.20': 'Pszenica',
		'IMPLEMENT.RESOURCE.21': 'Fasola zwyczajna',
		'IMPLEMENT.RESOURCE.22': 'Groch ',
		'IMPLEMENT.RESOURCE.23': 'Trawy polne',
		'IMPLEMENT.RESOURCE.24': 'Trawy koniczyny',
		'IMPLEMENT.RESOURCE.25': 'Jęczmień ',
		'IMPLEMENT.RESOURCE.26': ' Owies ',
		'IMPLEMENT.RESOURCE.27': 'Orkisz',
		'IMPLEMENT.RESOURCE.28': 'Lnicznik siewny',
		'IMPLEMENT.RESOURCE.29': 'Siemię lniane',
		'IMPLEMENT.RESOURCE.3': 'Kiszonka',
		'IMPLEMENT.RESOURCE.30': 'Rzepak',
		'IMPLEMENT.RESOURCE.31': 'Soja',
		'IMPLEMENT.RESOURCE.32': 'Poplon',
		'IMPLEMENT.RESOURCE.33': 'Burak cukrowy',
		'IMPLEMENT.RESOURCE.34': 'Ziemniaki',
		'IMPLEMENT.RESOURCE.35': 'Miskantus',
		'IMPLEMENT.RESOURCE.36': 'Topinambur',
		'IMPLEMENT.RESOURCE.37': 'Warzywa',
		'IMPLEMENT.RESOURCE.38': 'Truskawki',
		'IMPLEMENT.RESOURCE.39': 'Nawóz płynny',
		'IMPLEMENT.RESOURCE.4': 'Siano ',
		'IMPLEMENT.RESOURCE.40': 'Wapno',
		'IMPLEMENT.RESOURCE.41': ' Diammonphosphat ',
		'IMPLEMENT.RESOURCE.42': 'Granulki z mąki Haara, PK, K, P, KAS ',
		'IMPLEMENT.RESOURCE.43': 'Mocznik ',
		'IMPLEMENT.RESOURCE.44': ' Diesel ',
		'IMPLEMENT.RESOURCE.45': ' AdBlue ',
		'IMPLEMENT.RESOURCE.46': ' Grunt',
		'IMPLEMENT.RESOURCE.47': 'Środek ochrony roślin',
		'IMPLEMENT.RESOURCE.48': 'Różnorodne',
		'IMPLEMENT.RESOURCE.49': 'Woda',
		'IMPLEMENT.RESOURCE.5': 'CCM',
		'IMPLEMENT.RESOURCE.50': 'Mieszanki paszowe',
		'IMPLEMENT.RESOURCE.6': 'Kukurydza ',
		'IMPLEMENT.RESOURCE.7': 'Słoma',
		'IMPLEMENT.RESOURCE.8': 'Kiszonka z kukurydzy',
		'IMPLEMENT.RESOURCE.9': 'Ziarno',
		'IMPLEMENT.TYPE': 'Typ urządzenia',
		'IMPLEMENT.TYPE.1': 'Prasy zwijające / owijarki',
		'IMPLEMENT.TYPE.10': 'Przyczepy transportowe ',
		'IMPLEMENT.TYPE.10_1': 'Wywrotka trójstronna ',
		'IMPLEMENT.TYPE.10_10': 'Przyczepa niskopodwoziowa ',
		'IMPLEMENT.TYPE.10_11': 'Przyczepa z podnośnikiem hakowym ',
		'IMPLEMENT.TYPE.10_12': 'Przyczepa do przewozu zwierząt',
		'IMPLEMENT.TYPE.10_13': 'Wózek do naczepy dolly',
		'IMPLEMENT.TYPE.10_14': 'Cysterna ',
		'IMPLEMENT.TYPE.10_2': 'Wywrotka',
		'IMPLEMENT.TYPE.10_3': 'Przyczepa przeładowcza',
		'IMPLEMENT.TYPE.10_4': 'Przyczepa platformowa',
		'IMPLEMENT.TYPE.10_5': ' Wóz paszowy ',
		'IMPLEMENT.TYPE.10_6': 'Przyczepa do kiszonki ',
		'IMPLEMENT.TYPE.10_7': 'Przyczepa do transportu bel ',
		'IMPLEMENT.TYPE.10_8': 'Przyczepa z ścianą przesuwną',
		'IMPLEMENT.TYPE.10_9': 'Cysterna do przewozu gnojowicy ',
		'IMPLEMENT.TYPE.11': 'Przyczepa do przewozu zwierząt',
		'IMPLEMENT.TYPE.11_1': 'Paszowóz ciągany',
		'IMPLEMENT.TYPE.11_2': 'Wóz paszowy ',
		'IMPLEMENT.TYPE.11_3': 'Picking-up/distribution wagon ',
		'IMPLEMENT.TYPE.12': ' Leśnictwo ',
		'IMPLEMENT.TYPE.12_1': 'Przyczepa do przewozu drewna',
		'IMPLEMENT.TYPE.12_2': 'Łupak drewna',
		'IMPLEMENT.TYPE.12_3': 'Trak do cięcia ',
		'IMPLEMENT.TYPE.12_4': 'Łuparka do drewna',
		'IMPLEMENT.TYPE.12_5': ' Frezarka do pniaków ',
		'IMPLEMENT.TYPE.12_6': 'Wciągarka leśna ',
		'IMPLEMENT.TYPE.12_7': 'Mulczarka leśna ',
		'IMPLEMENT.TYPE.12_8': 'Rozdrabniacz do drewna',
		'IMPLEMENT.TYPE.12_8_1': 'Rębak tarczowy zawieszany',
		'IMPLEMENT.TYPE.12_8_2': 'Rębak tarczowy zaczepiany',
		'IMPLEMENT.TYPE.12_8_3': 'Rębak do trocin',
		'IMPLEMENT.TYPE.12_8_4': ' Rębak bębnowy zaczepiany ',
		'IMPLEMENT.TYPE.12_8_5': ' Rębak bębnowy zaczepiany (samojezdny) ',
		'IMPLEMENT.TYPE.12_9': 'Hydrauliczne nożyce do przycinania gałęzi i krzewów ',
		'IMPLEMENT.TYPE.13': ' Sprzęt komunalny ',
		'IMPLEMENT.TYPE.13_1': ' Zamiatarki ',
		'IMPLEMENT.TYPE.13_10': 'Path maintenance device ',
		'IMPLEMENT.TYPE.13_11': 'Frezarka do drewna',
		'IMPLEMENT.TYPE.13_12': 'Solarka',
		'IMPLEMENT.TYPE.13_13': 'Ładowacze',
		'IMPLEMENT.TYPE.13_14': 'Urządzenie czyszczące',
		'IMPLEMENT.TYPE.13_15': 'Urządzenie do nawadniania',
		'IMPLEMENT.TYPE.13_16': 'Pomost roboczy',
		'IMPLEMENT.TYPE.13_17': 'Mulczer powierzchniowy',
		'IMPLEMENT.TYPE.13_18': 'Czoło wysięgnika',
		'IMPLEMENT.TYPE.13_18_1': 'Głowica tnąca',
		'IMPLEMENT.TYPE.13_18_2': 'Głowica mulczująca',
		'IMPLEMENT.TYPE.13_18_3': 'Nożyce do żywopłotu',
		'IMPLEMENT.TYPE.13_18_4': 'Kosz rozliczeniowy',
		'IMPLEMENT.TYPE.13_18_5': 'Grabie',
		'IMPLEMENT.TYPE.13_19': 'Centrum/struktura outriggerów',
		'IMPLEMENT.TYPE.13_19_1': 'Głowica tnąca',
		'IMPLEMENT.TYPE.13_19_2': 'Głowica mulczująca',
		'IMPLEMENT.TYPE.13_19_3': 'Nożyce do żywopłotu',
		'IMPLEMENT.TYPE.13_19_4': 'Kosz rozliczeniowy',
		'IMPLEMENT.TYPE.13_19_5': 'Grabie',
		'IMPLEMENT.TYPE.13_1_1': 'Zamiatarka czołowa ',
		'IMPLEMENT.TYPE.13_1_2': 'Zamiatarka tylna',
		'IMPLEMENT.TYPE.13_1_3': 'Struktura',
		'IMPLEMENT.TYPE.13_2': 'Pług śnieżny',
		'IMPLEMENT.TYPE.13_20': 'Tylny wysięgnik',
		'IMPLEMENT.TYPE.13_20_1': 'Głowica tnąca',
		'IMPLEMENT.TYPE.13_20_2': 'Głowica mulczująca',
		'IMPLEMENT.TYPE.13_20_3': 'Nożyce do żywopłotu',
		'IMPLEMENT.TYPE.13_20_4': 'Kosz rozliczeniowy',
		'IMPLEMENT.TYPE.13_20_5': 'Grabie',
		'IMPLEMENT.TYPE.13_21': 'Dmuchawa do liści',
		'IMPLEMENT.TYPE.13_22': 'Zagęszczarka bankietowa / zagęszczarka płytowa',
		'IMPLEMENT.TYPE.13_3': ' Snow plough - typu V',
		'IMPLEMENT.TYPE.13_4': 'Pług do śniegu wirnikowy ',
		'IMPLEMENT.TYPE.13_5': 'Rozsiewacz zawieszany',
		'IMPLEMENT.TYPE.13_6': 'Rozsiewacz zaczepiany',
		'IMPLEMENT.TYPE.13_7': 'Kosiarka drogowa',
		'IMPLEMENT.TYPE.13_8': ' Kosiarka wysięgnikowa ',
		'IMPLEMENT.TYPE.13_9': 'Kosiarka',
		'IMPLEMENT.TYPE.14': ' Osprzęt do ładowacza czołowego ',
		'IMPLEMENT.TYPE.14_1': ' Łyżka',
		'IMPLEMENT.TYPE.14_2': ' Łyżka objętościowa',
		'IMPLEMENT.TYPE.14_3': 'Widły do palet',
		'IMPLEMENT.TYPE.14_4': 'Chwytak do bel ',
		'IMPLEMENT.TYPE.14_5': 'Widełki do bel',
		'IMPLEMENT.TYPE.14_6': 'Łyżka chwytakowa',
		'IMPLEMENT.TYPE.14_7': ' Platforma robocza ',
		'IMPLEMENT.TYPE.14_8': 'Widły do obornika',
		'IMPLEMENT.TYPE.15': 'Przystawki zbierające',
		'IMPLEMENT.TYPE.15_1': 'Narzędzia do cięcia ',
		'IMPLEMENT.TYPE.15_1_1': ' Standard cięcia ',
		'IMPLEMENT.TYPE.15_1_2': 'Cutting foldable ',
		'IMPLEMENT.TYPE.15_2': 'Przystawka do zbioru kukurydzy',
		'IMPLEMENT.TYPE.15_2_1': 'Standardowa przystawka do zbioru kukurydzy',
		'IMPLEMENT.TYPE.15_3': 'Przystawka do kukurydzy',
		'IMPLEMENT.TYPE.15_4': 'Zaczep GPS',
		'IMPLEMENT.TYPE.15_5': 'Pick-Up ',
		'IMPLEMENT.TYPE.15_6': ' Rodevorsatz ',
		'IMPLEMENT.TYPE.15_7': 'System rejestrowania',
		'IMPLEMENT.TYPE.15_8': 'Podbieranie pokosu',
		'IMPLEMENT.TYPE.16': 'Różnorodne',
		'IMPLEMENT.TYPE.16_1': 'Śrutownik do CCM',
		'IMPLEMENT.TYPE.16_2': 'Obciążnik przedni',
		'IMPLEMENT.TYPE.16_3': ' Obciążnik tylny ',
		'IMPLEMENT.TYPE.16_4': 'Spychacz - pług',
		'IMPLEMENT.TYPE.17': 'Sady i winnice ',
		'IMPLEMENT.TYPE.17_1': 'Pług',
		'IMPLEMENT.TYPE.17_2': 'Sadzarka',
		'IMPLEMENT.TYPE.17_3': 'Defoliator ',
		'IMPLEMENT.TYPE.17_4': ' Frezarka do korzeni ',
		'IMPLEMENT.TYPE.18': 'Uprawa warzyw ',
		'IMPLEMENT.TYPE.18_1': ' Kombajn do zbioru marchwi ',
		'IMPLEMENT.TYPE.18_2': 'Kombajn do zbioru cebuli ',
		'IMPLEMENT.TYPE.18_4': 'Kombajn do zbierania cebulek',
		'IMPLEMENT.TYPE.18_5': 'Kombajn do zbioru porów ',
		'IMPLEMENT.TYPE.19': 'Technologia buraka cukrowego ',
		'IMPLEMENT.TYPE.19_1': 'Kombajn do zbioru buraków cukrowych - samojezdny',
		'IMPLEMENT.TYPE.19_1_1': 'Kombajn bunkrowy',
		'IMPLEMENT.TYPE.19_1_2': 'Przeciążenie lub',
		'IMPLEMENT.TYPE.1_1': ' Prasa rolująca ',
		'IMPLEMENT.TYPE.1_2': 'Prasa kostkująca',
		'IMPLEMENT.TYPE.1_3': 'Prasoowijarka',
		'IMPLEMENT.TYPE.1_4': 'Owijarka do bel',
		'IMPLEMENT.TYPE.1_5': 'Prasa wysokiego stopnia prasowania',
		'IMPLEMENT.TYPE.2': 'Uprawa gleby ',
		'IMPLEMENT.TYPE.2_1': 'Pług',
		'IMPLEMENT.TYPE.2_10': 'Kultywator wirnikowy (glebogryzarka)',
		'IMPLEMENT.TYPE.2_10_1': 'Glebogryzarka rotacyjna - zamontowana',
		'IMPLEMENT.TYPE.2_10_2': 'Glebogryzarka rotacyjna - dołączona',
		'IMPLEMENT.TYPE.2_11': 'Pakomat czołowy',
		'IMPLEMENT.TYPE.2_12': 'Wał',
		'IMPLEMENT.TYPE.2_12_1': 'Rolka - zamontowana',
		'IMPLEMENT.TYPE.2_12_2': 'Rolka - dołączona',
		'IMPLEMENT.TYPE.2_13': 'Brony wirnikowe ',
		'IMPLEMENT.TYPE.2_13_1': 'Brony wirnikowe - montowane',
		'IMPLEMENT.TYPE.2_13_2': 'Brony wirnikowe - dołączone',
		'IMPLEMENT.TYPE.2_14': ' Kultywator wirnikowy ',
		'IMPLEMENT.TYPE.2_14_1': 'Kultywator wirnikowy - zamontowany',
		'IMPLEMENT.TYPE.2_14_2': 'Kultywator wirnikowy - dołączony',
		'IMPLEMENT.TYPE.2_15': 'Kombinacja uprawowo siewna',
		'IMPLEMENT.TYPE.2_15_1': 'Zestaw do siewu - zamontowany',
		'IMPLEMENT.TYPE.2_15_2': 'Kombinacja nasion - w załączeniu',
		'IMPLEMENT.TYPE.2_16': 'Prasa ',
		'IMPLEMENT.TYPE.2_17': 'Zgarniacz',
		'IMPLEMENT.TYPE.2_17_1': 'Zgarniacze - montowane',
		'IMPLEMENT.TYPE.2_17_2': 'Zgarniacze - dołączone',
		'IMPLEMENT.TYPE.2_18': 'Brona palcowa',
		'IMPLEMENT.TYPE.2_18_1': 'Brona do słomy - zamontowana',
		'IMPLEMENT.TYPE.2_18_2': 'Brona do słomy - dołączona',
		'IMPLEMENT.TYPE.2_19': 'Brona chwastownikowa (opielacz)',
		'IMPLEMENT.TYPE.2_19_1': 'Dalsze kultywatory zawieszane - zawieszane',
		'IMPLEMENT.TYPE.2_19_2': 'Kolejne kultywatory - w załączeniu',
		'IMPLEMENT.TYPE.2_1_1': 'Pług zawieszany ',
		'IMPLEMENT.TYPE.2_1_2': 'Pług półzawieszany ',
		'IMPLEMENT.TYPE.2_1_3': 'Pług półzawieszany  (na kole) ',
		'IMPLEMENT.TYPE.2_2': 'Kultywator ',
		'IMPLEMENT.TYPE.2_20': 'Inne kultywatory ',
		'IMPLEMENT.TYPE.2_2_1': 'Kultywator zawieszany ',
		'IMPLEMENT.TYPE.2_2_2': 'Kultywator półzawieszany ',
		'IMPLEMENT.TYPE.2_3': 'Brona talerzowa ',
		'IMPLEMENT.TYPE.2_3_1': 'Brona talerzowa zawieszana',
		'IMPLEMENT.TYPE.2_3_2': 'Brona talerzowa półzawieszana',
		'IMPLEMENT.TYPE.2_4': 'Kompaktowa brona talerzowa',
		'IMPLEMENT.TYPE.2_4_1': 'Brona talerzowa kompaktowa - zamontowana',
		'IMPLEMENT.TYPE.2_4_2': 'Brona do płyt kompaktowych - dołączona',
		'IMPLEMENT.TYPE.2_5': 'Głębosz',
		'IMPLEMENT.TYPE.2_5_1': 'Luzownik głęboki - zamontowany',
		'IMPLEMENT.TYPE.2_5_2': 'Głęboki spulchniacz - dołączony',
		'IMPLEMENT.TYPE.2_6': 'Agregat łopatkowy',
		'IMPLEMENT.TYPE.2_6_1': 'Brodzik - zamontowany',
		'IMPLEMENT.TYPE.2_6_2': 'Szpadel - w załączeniu',
		'IMPLEMENT.TYPE.2_7': 'Brona wirnikowa',
		'IMPLEMENT.TYPE.2_7_1': 'Brona wirnikowa - zamontowana',
		'IMPLEMENT.TYPE.2_7_2': 'Brona wirnikowa - dołączona',
		'IMPLEMENT.TYPE.2_8': 'Motyczka obrotowa',
		'IMPLEMENT.TYPE.2_8_1': 'Motyczka obrotowa - zamontowana',
		'IMPLEMENT.TYPE.2_8_2': 'Motyczka obrotowa - dołączona',
		'IMPLEMENT.TYPE.2_9': 'Brona wahadłowa',
		'IMPLEMENT.TYPE.2_9_1': 'Brona wibracyjna - zawieszana',
		'IMPLEMENT.TYPE.2_9_2': 'Brona wibracyjna - dołączona',
		'IMPLEMENT.TYPE.3': 'Siewniki / Sadzarki ',
		'IMPLEMENT.TYPE.3_1': 'Siewnik mechaniczny ',
		'IMPLEMENT.TYPE.3_1_1': 'Siewnik nabudowany do poplonów',
		'IMPLEMENT.TYPE.3_1_2': 'Siewnik nabudowany',
		'IMPLEMENT.TYPE.3_1_3': 'Kombinacja uprawowo-siewna',
		'IMPLEMENT.TYPE.3_1_4': ' Pół-zawieszany agregat uprawowo-siewny ',
		'IMPLEMENT.TYPE.3_2': ' Siewnik pneumatyczny ',
		'IMPLEMENT.TYPE.3_2_1': 'Siewnik nabudowany do poplonów',
		'IMPLEMENT.TYPE.3_2_2': 'Siewnik nabudowany',
		'IMPLEMENT.TYPE.3_2_3': 'Kombinacja uprawowo-siewna',
		'IMPLEMENT.TYPE.3_2_4': ' Pół-zawieszany agregat uprawowo-siewny ',
		'IMPLEMENT.TYPE.3_3': ' Siewnik mechaniczny punktowy ',
		'IMPLEMENT.TYPE.3_3_1': 'Siewnik nabudowany do poplonów',
		'IMPLEMENT.TYPE.3_3_2': 'Siewnik nabudowany',
		'IMPLEMENT.TYPE.3_3_3': 'Kombinacja uprawowo-siewna',
		'IMPLEMENT.TYPE.3_3_4': ' Pół-zawieszany agregat uprawowo-siewny',
		'IMPLEMENT.TYPE.3_4': 'Pneumatyczny siewnik  punktowy',
		'IMPLEMENT.TYPE.3_4_1': 'Siewnik nabudowany do poplonów',
		'IMPLEMENT.TYPE.3_4_2': 'Siewnik nabudowany',
		'IMPLEMENT.TYPE.3_4_3': 'Kombinacja uprawowo-siewna',
		'IMPLEMENT.TYPE.3_4_4': ' Pół-zawieszany agregat uprawowo-siewny',
		'IMPLEMENT.TYPE.3_5': 'Siewnik punktowy',
		'IMPLEMENT.TYPE.3_5_1': 'Siewnik do siewu bezpośredniego - zawieszany',
		'IMPLEMENT.TYPE.3_5_2': 'Siewnik do siewu bezpośredniego - dołączony',
		'IMPLEMENT.TYPE.3_6': ' Siewnik do siewu jednoziarnowego diorect ',
		'IMPLEMENT.TYPE.3_6_1': 'Jednoziarnisty siewnik do siewu bezpośredniego - zawieszany',
		'IMPLEMENT.TYPE.3_6_2': 'Jednoziarnisty siewnik do siewu bezpośredniego - dołączony',
		'IMPLEMENT.TYPE.3_7': 'Sadzarki',
		'IMPLEMENT.TYPE.3_7_1': 'Planter - zamontowany',
		'IMPLEMENT.TYPE.3_7_2': 'Planter - dołączony',
		'IMPLEMENT.TYPE.3_8': 'Siewnik do traw',
		'IMPLEMENT.TYPE.3_8_1': 'Siewnik do użytków zielonych - zawieszany',
		'IMPLEMENT.TYPE.3_8_2': 'Siewnik do użytków zielonych - w załączeniu',
		'IMPLEMENT.TYPE.3_9': 'Zbiornik przedni',
		'IMPLEMENT.TYPE.4': 'Rozsiewacz ',
		'IMPLEMENT.TYPE.4_1': 'Rozrzutnik - zamontowany',
		'IMPLEMENT.TYPE.4_2': 'Rozsiewacz półzawieszany',
		'IMPLEMENT.TYPE.5': 'Ochrona roślin ',
		'IMPLEMENT.TYPE.5_1': 'Opryskiwacz zawieszany ',
		'IMPLEMENT.TYPE.5_2': 'Opryskiwacz zaczepiany ',
		'IMPLEMENT.TYPE.5_3': 'Pielniki i wykaszarki',
		'IMPLEMENT.TYPE.5_3_1': 'Pielnik',
		'IMPLEMENT.TYPE.5_3_2': 'Rębak',
		'IMPLEMENT.TYPE.5_4': 'Brona chwastownik',
		'IMPLEMENT.TYPE.5_4_1': ' Hackstriegel angebaut ',
		'IMPLEMENT.TYPE.5_4_2': 'Hackstriegel angehängt ',
		'IMPLEMENT.TYPE.6': 'Technologia nawożenia naturalnego',
		'IMPLEMENT.TYPE.6_1': 'Muck/compost spreader ',
		'IMPLEMENT.TYPE.6_2': 'Wóz asenizacyjny ',
		'IMPLEMENT.TYPE.6_2_1': 'Rozlewacz właściwy',
		'IMPLEMENT.TYPE.6_2_2': 'Belka z wężami wleczonymi',
		'IMPLEMENT.TYPE.6_2_3': 'Belka z płozami',
		'IMPLEMENT.TYPE.6_2_4': 'Aplikatory doglebowy',
		'IMPLEMENT.TYPE.6_2_5': 'Kultywator talerzowy z aplikatorem gnojowicy',
		'IMPLEMENT.TYPE.6_2_6': 'Aplikator talerzowy',
		'IMPLEMENT.TYPE.6_2_7': 'Aplikator doglebowy Striptill',
		'IMPLEMENT.TYPE.6_2_8': 'Rozlewacz obrotowy',
		'IMPLEMENT.TYPE.6_3': 'Pompa do gnojowicy',
		'IMPLEMENT.TYPE.6_4': 'Mieszadło do gnojowicy ',
		'IMPLEMENT.TYPE.6_5': 'Zbiornik na gnojowicę ',
		'IMPLEMENT.TYPE.6_6': 'System węży ',
		'IMPLEMENT.TYPE.6_6_1': 'Dystrybutor węży wleczonych ',
		'IMPLEMENT.TYPE.6_6_2': 'Dystrybutor z płozami',
		'IMPLEMENT.TYPE.6_6_3': 'Aplikator tarczowy gnojowicy',
		'IMPLEMENT.TYPE.6_6_4': 'Kultywator gnojowicy',
		'IMPLEMENT.TYPE.6_6_5': 'Brona talerzowa do gnojowicy ',
		'IMPLEMENT.TYPE.6_6_6': 'Aplikator gnojowicy',
		'IMPLEMENT.TYPE.6_6_7': 'Rozlewacz obrotowy',
		'IMPLEMENT.TYPE.7': 'Technologia nawadniania ',
		'IMPLEMENT.TYPE.7_1': 'Deszczownia szpulowa',
		'IMPLEMENT.TYPE.7_2': 'Belka nawadniająca ',
		'IMPLEMENT.TYPE.8': 'Urządzenia do uprawy ziemniaków ',
		'IMPLEMENT.TYPE.8_1': 'Sadzarka do ziemniaków ',
		'IMPLEMENT.TYPE.8_1_1': ' Sadzarka bez  z brony wirnikowej ',
		'IMPLEMENT.TYPE.8_1_2': 'Sadzarka z broną wirnikową ',
		'IMPLEMENT.TYPE.8_1_3': 'Siewnik bez zamontowanej brony mechanicznej/pełnej brony polowej ',
		'IMPLEMENT.TYPE.8_1_4': 'Maszyna do formowania redlin z zamontowaną broną wirnikową / kultywatorem polowym ',
		'IMPLEMENT.TYPE.8_2': 'Kombajn do ziemniaków z opielaczem',
		'IMPLEMENT.TYPE.8_3': 'Kombajn do ziemniaków ze zbiornikiem',
		'IMPLEMENT.TYPE.8_4': ' Kombajn do ziemniaków z przenośnikiem',
		'IMPLEMENT.TYPE.8_5': 'Redliniarka',
		'IMPLEMENT.TYPE.8_6': 'Rozdrabniacz łętów',
		'IMPLEMENT.TYPE.8_7': 'Obsypnik do redlin',
		'IMPLEMENT.TYPE.8_8': 'Rozdrabniacz łętów',
		'IMPLEMENT.TYPE.9': 'Maszyny do użytków zielonych ',
		'IMPLEMENT.TYPE.9_1': 'Kosiarka bębnowa',
		'IMPLEMENT.TYPE.9_1_1': ' Kosiarka bębnowa z kondycjonerem ',
		'IMPLEMENT.TYPE.9_1_2': 'Kosiarka bębnowa bez kondycjonera ',
		'IMPLEMENT.TYPE.9_1_3': 'Kosiarka bębnowa z zamontowanym kondycjonerem ',
		'IMPLEMENT.TYPE.9_1_4': ' Kosiarka bębnowa dołączona bez kondycjonera ',
		'IMPLEMENT.TYPE.9_2': 'Kosiarka dyskowa',
		'IMPLEMENT.TYPE.9_2_1': 'Kosiarka dyskowa z kondycjonerem ',
		'IMPLEMENT.TYPE.9_2_2': ' Kosiarka dyskowa bez kondycjonera ',
		'IMPLEMENT.TYPE.9_2_3': 'Kosiarka dyskowa z dołączonym kondycjonerem ',
		'IMPLEMENT.TYPE.9_2_4': ' Kosiarka dyskowa zaczepiana bez kondycjonera ',
		'IMPLEMENT.TYPE.9_3': 'Przetrząsacz karuzelowy ',
		'IMPLEMENT.TYPE.9_3_1': 'Przetrząsacz karuzelowy/zawieszany przetrząsacz karuzelowy ',
		'IMPLEMENT.TYPE.9_3_2': 'Zawieszany przetrząsacz karuzelowy',
		'IMPLEMENT.TYPE.9_4': 'Zgrabiarki',
		'IMPLEMENT.TYPE.9_4_1': 'Zgrabiarka jednokaruzelowa',
		'IMPLEMENT.TYPE.9_4_2': 'Zgrabiarka dwukaruzelowa (układanie pokosu na boki) ',
		'IMPLEMENT.TYPE.9_4_3': ' Zgrabiarka dwukaruzelowa (centralne układanie pokosu) ',
		'IMPLEMENT.TYPE.9_4_4': 'Zgrabiarka czterokaruzelowa',
		'IMPLEMENT.TYPE.9_4_5': 'Fuzja ciągła',
		'IMPLEMENT.TYPE.9_4_6': 'Zgrabiarka rotacyjna',
		'IMPLEMENT.TYPE.9_5': 'Brony do użytków zielonych',
		'IMPLEMENT.TYPE.9_6': 'Brona do pastwiska',
		'IMPLEMENT.TYPE.9_7': 'Wał łąkowy',
		'IMPLEMENT.TYPE.9_8': 'Rozdrabniacz',
		'IMPLEMENTS': 'Narzędzie ',
		'IMPLEMENTS.ALL': 'Wszystkie narzędzia ',
		'IMPLEMENTS.DEACTIVATE.FAILURE': 'Niektórych narzędzi nie można było dezaktywować.',
		'IMPLEMENTS.DEACTIVATE.QUESTION': 'Czy naprawdę chcesz dezaktywować wybrane narzędzia?',
		'IMPLEMENTS.DEACTIVATE.SUCCESS': 'Urządzenia zostały pomyślnie dezaktywowane',
		'IMPLEMENTS.DELETE.FAILURE': 'Niektórych narzędzi nie można było usunąć.',
		'IMPLEMENTS.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć wybrane narzędzia? ',
		'IMPLEMENTS.DELETE.SUCCESS': 'Narzędzia zostały usunięte ',
		'IMPLEMENTS.MANAGEMENT': 'Zarządzanie narzędziami',
		'IMPLEMENTS.NO': 'Brak narzędzi',
		'IMPLEMENTS.NOT_SELECTED': 'Žádné vybrané nářadí',
		'IMPLEMENTS.REACTIVATE.FAILURE': 'Niektórych urządzeń nie można było ponownie aktywować.',
		'IMPLEMENTS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected implements?',
		'IMPLEMENTS.REACTIVATE.SUCCESS': 'Urządzenia zostały pomyślnie reaktywowane',
		'IMPLEMENTS.SELECTED': 'Wybrane narzędzia',
		'IMPLEMENT_SCAN_DISABLED': 'Nieaktywne skanowanie sygnalizatorów beacon',
		'IMPORT': 'Import',
		'INACTIVE': 'Nieaktywne',
		'INDIVIDUAL_LABELING': ' Indywidualne oznaczenia',
		'INFO': 'Info',
		'INTERPOLATION.MAP': 'Mapa interpolacji',
		'INTERPOLATION.MAP.SETTINGS': 'Ustawienia mapy interpolacji',
		'IO_BOX_ACTIVATED': 'IOBox aktywne',
		'ISOBUS.DDI.1': 'Wartość Zadana Ilość Na Powierzchnię W Dawce',
		'ISOBUS.DDI.10': ' Maksymalna Ilość Substancji Na Powierzchnię W Dawce',
		'ISOBUS.DDI.100': 'Zanieczyszczenie upraw ',
		'ISOBUS.DDI.101': ' Zadana szerokość beli ',
		'ISOBUS.DDI.102': 'Rzeczywista szerokość beli ',
		'ISOBUS.DDI.103': 'Domyślna szerokość beli ',
		'ISOBUS.DDI.104': 'Minimalna szerokość beli ',
		'ISOBUS.DDI.105': ' Maksymalna szerokość beli ',
		'ISOBUS.DDI.106': 'Zadana wysokość beli ',
		'ISOBUS.DDI.107': 'Aktualna wysokość beli  ',
		'ISOBUS.DDI.108': 'Domyślna wysokość beli ',
		'ISOBUS.DDI.109': 'Minimalna wysokość beli ',
		'ISOBUS.DDI.11': 'Zadana gęstość siewu na ha',
		'ISOBUS.DDI.110': 'Maksymalna wysokość beli ',
		'ISOBUS.DDI.111': 'Zadana wielkość beli ',
		'ISOBUS.DDI.112': 'Rzeczywista wielkość beli ',
		'ISOBUS.DDI.113': 'Domyślna wielkość beli ',
		'ISOBUS.DDI.114': 'Minimalna wielkość beli ',
		'ISOBUS.DDI.115': 'Maksymalna wielkość beli ',
		'ISOBUS.DDI.116': 'Całkowita powierzchnia',
		'ISOBUS.DDI.117': 'Efektywna odległość całkowita ',
		'ISOBUS.DDI.118': 'Nieefektywna odległość całkowita ',
		'ISOBUS.DDI.119': ' Efektywny czas całkowity ',
		'ISOBUS.DDI.12': 'Rzeczywista ilość na powierzchnię jednostki aplikacji',
		'ISOBUS.DDI.120': 'Nieefektywny czas całkowity ',
		'ISOBUS.DDI.121': ' Waga gęstości produktu na objętość',
		'ISOBUS.DDI.122': 'Waga gęstości produktu na ilości',
		'ISOBUS.DDI.123': 'Waga objętość produktu na jednostkę',
		'ISOBUS.DDI.124': 'Zawór pomocniczy Skalowanie Extend',
		'ISOBUS.DDI.125': 'Zawór pomocniczy Skalowanie Retrakcja',
		'ISOBUS.DDI.126': 'Rampa zaworu pomocniczego wysuwana do góry',
		'ISOBUS.DDI.127': 'Wysunięcie rampy zaworu pomocniczego w dół',
		'ISOBUS.DDI.128': 'Zawór pomocniczy Rampa cofnięta do góry',
		'ISOBUS.DDI.129': 'Zawór pomocniczy Rampa cofnięta w dół',
		'ISOBUS.DDI.13': 'Domyślna jednostka na powierzchnię aplikowanej dawki ',
		'ISOBUS.DDI.130': 'Wartość progowa pływalności zaworu pomocniczego',
		'ISOBUS.DDI.131': 'Zwiększenie wydajności zaworu pomocniczego',
		'ISOBUS.DDI.132': 'Zawór pomocniczy Progresywność Wycofanie',
		'ISOBUS.DDI.133': 'Zawór pomocniczy porty inwersyjne ',
		'ISOBUS.DDI.134': ' Przesunięcie pozycji elementu urządzenia X ',
		'ISOBUS.DDI.135': ' Przesunięcie pozycji elementu urządzenia Y',
		'ISOBUS.DDI.136': ' Przesunięcie pozycji elementu urządzenia Z',
		'ISOBUS.DDI.137': 'Pojemność objętościowa urządzenia ',
		'ISOBUS.DDI.138': 'Pojemność masowa urządzenia',
		'ISOBUS.DDI.139': 'Pojemność liczby urządzeń ',
		'ISOBUS.DDI.14': 'Minimalna ilość na powierzchnię aplikacyjną dawki ',
		'ISOBUS.DDI.140': ' Zadana wartość procentowa dawki',
		'ISOBUS.DDI.141': ' Aktualny stan pracy ',
		'ISOBUS.DDI.142': 'Fizyczna wartość zadana czasu opóźnienia',
		'ISOBUS.DDI.143': 'Fizyczna Wartość Rzeczywista Opóźnienia Czasu',
		'ISOBUS.DDI.144': 'Kąt odchylenia',
		'ISOBUS.DDI.145': 'Kąt skrętu',
		'ISOBUS.DDI.146': 'Kąt nachylenia ',
		'ISOBUS.DDI.147': 'Liczba logowań',
		'ISOBUS.DDI.148': 'Całkowite zużycie paliwa',
		'ISOBUS.DDI.149': ' Chwilowe zużycie paliwa na godzinę',
		'ISOBUS.DDI.15': ' Maksymalna ilość na powierzchnię aplikowanej dawki ',
		'ISOBUS.DDI.150': 'Chwilowe zużycie paliwa na powierzchnię ',
		'ISOBUS.DDI.151': 'Chwilowa powierzchnia na czas wydajności',
		'ISOBUS.DDI.153': ' Rzeczywisty znormalizowany wskaźnik wegetacyjny (NDVI) ',
		'ISOBUS.DDI.154': 'Fizyczna długość robocza elementu',
		'ISOBUS.DDI.155': 'Fizyczna szerokość robocza elementu',
		'ISOBUS.DDI.156': 'Obiekt fizyczny Wysokość',
		'ISOBUS.DDI.157': 'Rodzaj złącza',
		'ISOBUS.DDI.158': 'Stan kontrolny recepty(zadania)',
		'ISOBUS.DDI.159': 'Liczba bloków na sekcję ',
		'ISOBUS.DDI.16': ' Odstępy między zadanymi wartościami aplikacji',
		'ISOBUS.DDI.160': ' Stan kontroli sekcji ',
		'ISOBUS.DDI.161': ' Aktualny skrócony stan roboczy (1-16) ',
		'ISOBUS.DDI.162': ' Aktualny skrócony stan roboczy (17-32) ',
		'ISOBUS.DDI.163': ' Aktualny skrócony stan roboczy (33-48) ',
		'ISOBUS.DDI.164': ' Aktualny skrócony stan roboczy (49-64)',
		'ISOBUS.DDI.165': ' Aktualny skrócony stan roboczy (65-80) ',
		'ISOBUS.DDI.166': ' Aktualny skrócony stan roboczy (81-96) ',
		'ISOBUS.DDI.167': ' Aktualny skrócony stan roboczy (97-112) ',
		'ISOBUS.DDI.168': ' Aktualny skrócony stan roboczy (113-128) ',
		'ISOBUS.DDI.169': ' Aktualny skrócony stan roboczy  (129-144) ',
		'ISOBUS.DDI.17': 'Aktualna dawka rozsiewu ',
		'ISOBUS.DDI.170': 'Aktualny skrócony stan roboczy  (145-160) ',
		'ISOBUS.DDI.171': 'Aktualny skrócony stan roboczy (161-176) ',
		'ISOBUS.DDI.172': 'Aktualny skrócony stan roboczy (177-192) ',
		'ISOBUS.DDI.173': 'Aktualny skrócony stan roboczy (193-208) ',
		'ISOBUS.DDI.174': 'Aktualny skrócony stan roboczy  (209-224) ',
		'ISOBUS.DDI.175': 'Aktualny skrócony stan roboczy (225-240) ',
		'ISOBUS.DDI.176': 'Aktualny skrócony stan roboczy  (241-256) ',
		'ISOBUS.DDI.177': 'Aktualna długość cięcia ',
		'ISOBUS.DDI.178': 'Rodzaj elementu instancji',
		'ISOBUS.DDI.179': 'Aktualny status aktywności',
		'ISOBUS.DDI.18': 'Domyślny rozstaw Dawkowanie',
		'ISOBUS.DDI.180': 'Odległość punktu odniesienia urządzenia (DRP) od masy',
		'ISOBUS.DDI.181': 'Sucha masa na powierzchnię Plon',
		'ISOBUS.DDI.182': 'Sucha masa na czas Wydajność',
		'ISOBUS.DDI.183': 'Wydajność Całkowita sucha masa',
		'ISOBUS.DDI.184': 'Wilgotność referencyjna dla suchej masy',
		'ISOBUS.DDI.185': 'Nasiona Bawełna Masa na powierzchnię Plon',
		'ISOBUS.DDI.186': 'Lint Bawełna Masa na powierzchnię Plon',
		'ISOBUS.DDI.187': 'Nasiona Bawełna Masa na czas Plon',
		'ISOBUS.DDI.188': 'Kłaczki Masa bawełny na czas Wydajność',
		'ISOBUS.DDI.189': 'Wydajność Całkowita masa nasienna Bawełna',
		'ISOBUS.DDI.19': 'Minimalna rozstawa Dawka',
		'ISOBUS.DDI.190': 'Wydajność Całkowita masa kłaczków Bawełna',
		'ISOBUS.DDI.191': 'Procentowa frekwencja kłaczków',
		'ISOBUS.DDI.192': 'Temperatura otoczenia',
		'ISOBUS.DDI.193': 'Wartość zadana Ciśnienie produktu',
		'ISOBUS.DDI.194': 'Rzeczywiste ciśnienie produktu',
		'ISOBUS.DDI.195': 'Minimalne ciśnienie produktu',
		'ISOBUS.DDI.196': 'Maksymalne ciśnienie produktu',
		'ISOBUS.DDI.197': 'Wartość zadana Ciśnienie wyjściowe pompy',
		'ISOBUS.DDI.198': 'Rzeczywiste ciśnienie wyjściowe pompy',
		'ISOBUS.DDI.199': 'Minimalne ciśnienie wyjściowe pompy',
		'ISOBUS.DDI.2': 'Rzeczywista objętość na powierzchnię Dawka',
		'ISOBUS.DDI.20': 'Maksymalna rozstawa Dawka',
		'ISOBUS.DDI.200': 'Maksymalne ciśnienie wyjściowe pompy',
		'ISOBUS.DDI.201': 'Wartość zadana ciśnienia mieszania w zbiorniku',
		'ISOBUS.DDI.202': 'Rzeczywiste ciśnienie mieszania w zbiorniku',
		'ISOBUS.DDI.203': 'Minimalne ciśnienie mieszania w zbiorniku',
		'ISOBUS.DDI.204': 'Maksymalne ciśnienie mieszania w zbiorniku',
		'ISOBUS.DDI.205': 'Czas włączenia SC',
		'ISOBUS.DDI.206': 'Czas wyłączenia SC',
		'ISOBUS.DDI.207': 'Prędkość wiatru',
		'ISOBUS.DDI.208': 'Kierunek wiatru',
		'ISOBUS.DDI.209': 'Wilgotność względna',
		'ISOBUS.DDI.21': 'Wartość zadana Objętość na objętość Dawkowanie',
		'ISOBUS.DDI.210': 'Warunki na niebie',
		'ISOBUS.DDI.211': 'Ostatnia bela Płatki na belę',
		'ISOBUS.DDI.212': 'Ostatnia bela Średnia wilgotność',
		'ISOBUS.DDI.213': 'Ostatnia bela Średnia liczba uderzeń na płatek',
		'ISOBUS.DDI.214': 'Liczba beli na całe życie',
		'ISOBUS.DDI.215': 'Dożywotnie godziny pracy',
		'ISOBUS.DDI.216': 'Rzeczywiste ciśnienie hydrauliczne beli',
		'ISOBUS.DDI.217': 'Ostatnia bela Średnie ciśnienie hydrauliczne',
		'ISOBUS.DDI.218': 'Wartość zadana Kompresja beli Obciążenie tłoka',
		'ISOBUS.DDI.219': 'Rzeczywiste obciążenie tłoka ściskającego belę',
		'ISOBUS.DDI.22': 'Rzeczywista objętość Dawka na objętość',
		'ISOBUS.DDI.220': 'Ostatnia bela Średnia bela Kompresja Obciążenie nurnika',
		'ISOBUS.DDI.221': 'Ostatnia bela z nałożonym środkiem konserwującym',
		'ISOBUS.DDI.222': 'Numer ostatniej etykiety beli',
		'ISOBUS.DDI.223': 'Ostatnia Bela Masa',
		'ISOBUS.DDI.224': 'Delta T',
		'ISOBUS.DDI.225': 'Wartość zadana Długość robocza',
		'ISOBUS.DDI.226': 'Rzeczywista długość robocza',
		'ISOBUS.DDI.227': 'Minimalna długość robocza',
		'ISOBUS.DDI.228': 'Maksymalna długość robocza',
		'ISOBUS.DDI.229': 'Rzeczywista waga netto',
		'ISOBUS.DDI.23': 'Domyślna objętość na objętość Dawkowanie',
		'ISOBUS.DDI.230': 'Waga netto Państwo',
		'ISOBUS.DDI.231': 'Wartość zadana Waga netto',
		'ISOBUS.DDI.232': 'Rzeczywista masa brutto',
		'ISOBUS.DDI.233': 'Masa brutto Państwo',
		'ISOBUS.DDI.234': 'Minimalna masa brutto',
		'ISOBUS.DDI.235': 'Maksymalna masa brutto',
		'ISOBUS.DDI.236': 'Thresher Engagement Łączny czas',
		'ISOBUS.DDI.237': 'Stan faktyczny Wysokość robocza nagłówka',
		'ISOBUS.DDI.238': 'Aktualna prędkość obrotowa hedera',
		'ISOBUS.DDI.239': 'Status wstrzymania produkcji',
		'ISOBUS.DDI.24': 'Minimalna objętość na objętość Dawkowanie',
		'ISOBUS.DDI.240': 'Stan faktyczny systemu (nie)załadunku',
		'ISOBUS.DDI.241': 'Temperatura upraw',
		'ISOBUS.DDI.242': 'Wartość zadana Prześwit sita',
		'ISOBUS.DDI.243': 'Rzeczywisty prześwit sita',
		'ISOBUS.DDI.244': 'Minimalna odległość między sitami',
		'ISOBUS.DDI.245': 'Maksymalna odległość między sitami',
		'ISOBUS.DDI.246': 'Wartość zadana Czyszczenie czafki',
		'ISOBUS.DDI.247': 'Rzeczywisty prześwit fartucha',
		'ISOBUS.DDI.248': 'Minimalny prześwit fartucha',
		'ISOBUS.DDI.249': 'Maksymalny prześwit fartucha',
		'ISOBUS.DDI.25': 'Maksymalna objętość na objętość Dawkowanie',
		'ISOBUS.DDI.250': 'Wartość zadana Wklęsłość',
		'ISOBUS.DDI.251': 'Rzeczywisty prześwit wklęsły',
		'ISOBUS.DDI.252': 'Minimalny prześwit wklęsły',
		'ISOBUS.DDI.253': 'Maksymalny prześwit wklęsły',
		'ISOBUS.DDI.254': 'Rozdzielenie wartości zadanej Prędkość obrotowa wentylatora',
		'ISOBUS.DDI.255': 'Rzeczywiste oddzielenie Prędkość obrotowa wentylatora',
		'ISOBUS.DDI.256': 'Minimalna separacja Prędkość obrotowa wentylatora',
		'ISOBUS.DDI.257': 'Maksymalna prędkość obrotowa wentylatora separacyjnego',
		'ISOBUS.DDI.258': 'Temperatura oleju hydraulicznego',
		'ISOBUS.DDI.259': 'Opóźnienie plonu Czas ignorowania',
		'ISOBUS.DDI.26': 'Wartość zadana Masa na masę Dawka',
		'ISOBUS.DDI.260': 'Wydajność Czas ignorowania ołowiu',
		'ISOBUS.DDI.261': 'Średnia masa plonu na czas',
		'ISOBUS.DDI.262': 'Średnia wilgotność upraw',
		'ISOBUS.DDI.263': 'Średnia masa plonu na powierzchnię',
		'ISOBUS.DDI.264': 'Przesunięcie osi X łącznika',
		'ISOBUS.DDI.265': 'Pozostały obszar',
		'ISOBUS.DDI.266': 'Zastosowanie w całym okresie użytkowania Masa całkowita',
		'ISOBUS.DDI.267': 'Lifetime Application Total Count',
		'ISOBUS.DDI.268': 'Wydajność w całym okresie użytkowania Wielkość całkowita',
		'ISOBUS.DDI.269': 'Wydajność życiowa Masa całkowita',
		'ISOBUS.DDI.27': 'Masa rzeczywista na masę Dawkowanie',
		'ISOBUS.DDI.270': 'Plon w całym okresie użytkowania Całkowita liczba',
		'ISOBUS.DDI.271': 'Czas życia Powierzchnia całkowita',
		'ISOBUS.DDI.272': 'Żywotność Efektywny dystans całkowity',
		'ISOBUS.DDI.273': 'Czas życia Nieefektywny Całkowita odległość',
		'ISOBUS.DDI.274': 'Żywotność Efektywny czas całkowity',
		'ISOBUS.DDI.275': 'Czas życia Nieefektywny Czas całkowity',
		'ISOBUS.DDI.276': 'Zużycie paliwa w całym okresie użytkowania',
		'ISOBUS.DDI.277': 'Średnie zużycie paliwa w całym okresie eksploatacji na godzinę',
		'ISOBUS.DDI.278': 'Średnie zużycie paliwa w całym okresie eksploatacji na areał',
		'ISOBUS.DDI.279': 'Wydajność życiowa Całkowita sucha masa',
		'ISOBUS.DDI.28': 'Domyślna masa na masę Dawkowanie',
		'ISOBUS.DDI.280': 'Wydajność życiowa Całkowita masa nasienna Bawełna',
		'ISOBUS.DDI.281': 'Wydajność życiowa Całkowita masa kłaczków Bawełna',
		'ISOBUS.DDI.282': 'Czas całkowity (Lifetime Threshing Engagement)',
		'ISOBUS.DDI.283': 'Precut Całkowita liczba',
		'ISOBUS.DDI.284': 'Nieobcięte Ogółem Liczba',
		'ISOBUS.DDI.285': 'Lifetime Precut Całkowita liczba',
		'ISOBUS.DDI.286': 'Żywotność Nieobcięte Ogółem Liczba',
		'ISOBUS.DDI.287': 'Tryb przepisywania wartości zadanej',
		'ISOBUS.DDI.288': 'Tryb rzeczywistej recepty',
		'ISOBUS.DDI.289': 'Wartość zadana Stan pracy',
		'ISOBUS.DDI.29': 'Minimalna masa na masę Dawkowanie',
		'ISOBUS.DDI.290': 'Wartość zadana Stan pracy skondensowanej (1-16) ',
		'ISOBUS.DDI.291': 'Wartość zadana Stan pracy skondensowanej (17-32)',
		'ISOBUS.DDI.292': 'Wartość zadana Skondensowany stan pracy (33-48)',
		'ISOBUS.DDI.293': 'Wartość zadana Skondensowany stan pracy (49-64)',
		'ISOBUS.DDI.294': 'Wartość zadana Skondensowany stan pracy (65-80)',
		'ISOBUS.DDI.295': 'Wartość zadana Skondensowany stan pracy (81-96)',
		'ISOBUS.DDI.296': 'Wartość zadana Skondensowany stan pracy (97-112)',
		'ISOBUS.DDI.297': 'Wartość zadana Stan pracy skondensowanej (113-128)',
		'ISOBUS.DDI.298': 'Wartość zadana Stan pracy skondensowanej (129-144)',
		'ISOBUS.DDI.299': 'Wartość zadana Stan pracy skondensowanej (145-160)',
		'ISOBUS.DDI.3': 'Domyślna objętość na powierzchnię Dawkowanie',
		'ISOBUS.DDI.30': 'Maksymalna masa na masę Dawkowanie',
		'ISOBUS.DDI.300': 'Wartość zadana Stan pracy skondensowanej (161-176) ',
		'ISOBUS.DDI.301': 'Wartość zadana Skondensowany stan pracy (177-192)',
		'ISOBUS.DDI.302': 'Wartość zadana Stan pracy skondensowanej (193-208)',
		'ISOBUS.DDI.303': 'Wartość zadana Stan pracy skondensowanej (209-224) ',
		'ISOBUS.DDI.304': 'Wartość zadana Stan pracy skondensowanej (225-240) ',
		'ISOBUS.DDI.305': 'Wartość zadana Skondensowany stan roboczy (241-256)',
		'ISOBUS.DDI.306': 'Prawdziwy punkt obrotu Przesunięcie X',
		'ISOBUS.DDI.307': 'Prawdziwy punkt obrotu Przesunięcie Y',
		'ISOBUS.DDI.308': 'Rzeczywisty procent Wskaźnik zastosowania',
		'ISOBUS.DDI.309': 'Minimalny procentowy wskaźnik zastosowania',
		'ISOBUS.DDI.31': 'Wartość zadana Objętość na masę Dawkowanie',
		'ISOBUS.DDI.310': 'Maksymalny procentowy wskaźnik stosowania',
		'ISOBUS.DDI.311': 'Potencjał plonów względnych',
		'ISOBUS.DDI.312': 'Minimalny względny potencjał plonu',
		'ISOBUS.DDI.313': 'Maksymalny potencjał plonu względnego',
		'ISOBUS.DDI.314': 'Rzeczywisty procent Sucha masa roślin uprawnych',
		'ISOBUS.DDI.315': 'Średni procent suchej masy roślinnej',
		'ISOBUS.DDI.316': 'Efektywne całkowite zużycie paliwa',
		'ISOBUS.DDI.317': 'Nieefektywne całkowite zużycie paliwa',
		'ISOBUS.DDI.318': 'Efektywne całkowite zużycie płynów spalinowych do silników wysokoprężnych',
		'ISOBUS.DDI.319': 'Nieefektywne całkowite zużycie płynu spalinowego do silników wysokoprężnych',
		'ISOBUS.DDI.32': 'Rzeczywista objętość na masę Dawkowanie',
		'ISOBUS.DDI.320': 'Ostatnio załadowana Waga',
		'ISOBUS.DDI.321': 'Ostatni wyładowany ciężar',
		'ISOBUS.DDI.322': 'Numer identyfikacyjny ładunku',
		'ISOBUS.DDI.323': 'Numer identyfikacyjny rozładunku',
		'ISOBUS.DDI.324': 'Łączny czas załączenia rozdrabniacza',
		'ISOBUS.DDI.325': 'Lifetime Application Całkowita objętość',
		'ISOBUS.DDI.326': 'Wartość zadana Prędkość głowicy',
		'ISOBUS.DDI.327': 'Rzeczywista prędkość hedera',
		'ISOBUS.DDI.328': 'Minimalna prędkość hedera',
		'ISOBUS.DDI.329': 'Maksymalna prędkość hedera',
		'ISOBUS.DDI.33': 'Domyślna objętość na masę Dawkowanie',
		'ISOBUS.DDI.330': 'Wartość zadana Prędkość obrotowa bębna tnącego',
		'ISOBUS.DDI.331': 'Rzeczywista prędkość obrotowa bębna tnącego',
		'ISOBUS.DDI.332': 'Minimalna prędkość obrotowa bębna tnącego',
		'ISOBUS.DDI.333': 'Maksymalna prędkość bębna tnącego',
		'ISOBUS.DDI.334': 'Godziny pracy od ostatniego ostrzenia',
		'ISOBUS.DDI.335': 'Godziny pracy przedniego WOM-u',
		'ISOBUS.DDI.336': 'Godziny pracy tylnego WOM-u',
		'ISOBUS.DDI.337': 'Żywotność godzin pracy przedniego WOM-u',
		'ISOBUS.DDI.338': 'Żywotność Godziny pracy tylnego WOM-u',
		'ISOBUS.DDI.339': 'Efektywny całkowity czas załadunku',
		'ISOBUS.DDI.34': 'Minimalna objętość na masę Dawkowanie',
		'ISOBUS.DDI.340': 'Efektywny całkowity czas rozładunku',
		'ISOBUS.DDI.341': 'Wartość zadana Ziarno Kernel Krakers Gapka',
		'ISOBUS.DDI.342': 'Ziarno rzeczywiste Kernel Cracker Luka',
		'ISOBUS.DDI.343': 'Minimalne odstępy między ziarnami w przypadku krakersów',
		'ISOBUS.DDI.344': 'Maksymalne odstępy między ziarnami Kernel Cracker Gap',
		'ISOBUS.DDI.345': 'Wartość zadana Szerokość pokosu',
		'ISOBUS.DDI.346': 'Rzeczywista szerokość pokosu',
		'ISOBUS.DDI.347': 'Minimalna szerokość pokosu',
		'ISOBUS.DDI.348': 'Maksymalna szerokość pokosu',
		'ISOBUS.DDI.349': 'Redukcja dryfu dyszy',
		'ISOBUS.DDI.35': 'Maksymalna objętość na masę Dawkowanie',
		'ISOBUS.DDI.350': 'Funkcja lub działanie Technika',
		'ISOBUS.DDI.351': 'Aplikacja Całkowita objętość',
		'ISOBUS.DDI.352': 'Zastosowanie Masa całkowita',
		'ISOBUS.DDI.353': 'Całkowite zastosowanie azotu',
		'ISOBUS.DDI.354': 'Całkowita aplikacja amonu',
		'ISOBUS.DDI.355': 'Całkowita dawka fosforu',
		'ISOBUS.DDI.356': 'Całkowita dawka potasu',
		'ISOBUS.DDI.357': 'Całkowita ilość suchej masy',
		'ISOBUS.DDI.358': 'Średnia masa suchego plonu na czas',
		'ISOBUS.DDI.359': 'Średnia masa suchego plonu na powierzchnię',
		'ISOBUS.DDI.36': 'Wartość zadana Objętość na czas Dawkowanie',
		'ISOBUS.DDI.360': 'Ostatnia bela Rozmiar',
		'ISOBUS.DDI.361': 'Ostatnia bela Gęstość',
		'ISOBUS.DDI.362': 'Całkowita długość beli',
		'ISOBUS.DDI.363': 'Ostatnia bela Sucha masa',
		'ISOBUS.DDI.364': 'Rzeczywisty rozmiar płatków',
		'ISOBUS.DDI.365': 'Wartość zadana Ciśnienie docisku',
		'ISOBUS.DDI.366': 'Rzeczywista siła docisku',
		'ISOBUS.DDI.367': 'Skrócona sekcja Stan przekroczenia (1-16)',
		'ISOBUS.DDI.368': 'Skrócona sekcja Nadwyżka stanu (17-32)',
		'ISOBUS.DDI.369': 'Skrócona sekcja Nadwyżka państwa (33-48)',
		'ISOBUS.DDI.37': 'Rzeczywista objętość na czas Dawkowanie',
		'ISOBUS.DDI.370': 'Skrócona sekcja Nadwyżka stanu (49-64)',
		'ISOBUS.DDI.371': 'Skrócona sekcja Nadrzędny stan (65-80)',
		'ISOBUS.DDI.372': 'Skrócona sekcja Nadwyżka państwa (81-96)',
		'ISOBUS.DDI.373': 'Skrócona sekcja Nadwyżka stanu (97-112)',
		'ISOBUS.DDI.374': 'Skrócona sekcja Nadwyżka państwa (113-128)',
		'ISOBUS.DDI.375': 'Skrócona sekcja Uchylenie Państwo (129-144) ',
		'ISOBUS.DDI.376': 'Skrócona sekcja Uchylenie Państwo (145-160) ',
		'ISOBUS.DDI.377': 'Skrócona sekcja Uchylenie Państwo  (161-176) ',
		'ISOBUS.DDI.378': 'Skrócona sekcja Uchylenie Państwo (177-192) ',
		'ISOBUS.DDI.379': 'Skrócona sekcja Uchylenie Państwo  (193-208) ',
		'ISOBUS.DDI.38': 'Domyślna objętość na czas Dawkowanie',
		'ISOBUS.DDI.380': 'Skrócona sekcja Uchylenie Państwo  (209-224) ',
		'ISOBUS.DDI.381': 'Skrócona sekcja Uchylenie Państwo (225-240) ',
		'ISOBUS.DDI.382': 'Skrócona sekcja Uchylenie Państwo  (241-256) ',
		'ISOBUS.DDI.383': 'Widoczny kierunek wiatru',
		'ISOBUS.DDI.384': 'Widoczna prędkość wiatru',
		'ISOBUS.DDI.385': 'Ciśnienie atmosferyczne MSL',
		'ISOBUS.DDI.386': 'Rzeczywiste ciśnienie atmosferyczne',
		'ISOBUS.DDI.387': 'Całkowita liczba obrotów w ułamkowych obrotach',
		'ISOBUS.DDI.388': 'Obroty całkowite w Obroty całkowite',
		'ISOBUS.DDI.389': 'Obroty wartości zadanej określone jako liczba na czas',
		'ISOBUS.DDI.39': 'Minimalna objętość na czas Dawkowanie',
		'ISOBUS.DDI.390': 'Rzeczywiste obroty na czas',
		'ISOBUS.DDI.391': 'Domyślne obroty na czas',
		'ISOBUS.DDI.392': 'Minimalna liczba obrotów na czas',
		'ISOBUS.DDI.393': 'Maksymalna liczba obrotów na czas',
		'ISOBUS.DDI.394': 'Rzeczywista zawartość zbiornika paliwa',
		'ISOBUS.DDI.395': 'Rzeczywista zawartość zbiornika płynu spalinowego do silników wysokoprężnych',
		'ISOBUS.DDI.396': 'Prędkość zadana',
		'ISOBUS.DDI.397': 'Prędkość rzeczywista',
		'ISOBUS.DDI.398': 'Prędkość minimalna',
		'ISOBUS.DDI.399': 'Prędkość maksymalna',
		'ISOBUS.DDI.4': 'Minimalna objętość na powierzchnię Dawkowanie',
		'ISOBUS.DDI.40': 'Maksymalna objętość na czas Dawkowanie',
		'ISOBUS.DDI.400': 'Źródło prędkości',
		'ISOBUS.DDI.401': 'Rzeczywiste stosowanie azotu',
		'ISOBUS.DDI.402': 'Rzeczywiste zastosowanie amonu',
		'ISOBUS.DDI.403': 'Rzeczywiste zastosowanie fosforu',
		'ISOBUS.DDI.404': 'Rzeczywiste zastosowanie potasu',
		'ISOBUS.DDI.405': 'Rzeczywiste zastosowanie suchej masy',
		'ISOBUS.DDI.406': 'Rzeczywista zawartość białka',
		'ISOBUS.DDI.407': 'Średnia zawartość białka',
		'ISOBUS.DDI.408': 'Średnie zanieczyszczenie upraw',
		'ISOBUS.DDI.409': 'Całkowite zużycie płynów spalinowych do silników wysokoprężnych',
		'ISOBUS.DDI.41': 'Wartość zadana Masa na czas Dawkowanie',
		'ISOBUS.DDI.410': 'Płyn spalinowy do silników wysokoprężnych Kons. na czas',
		'ISOBUS.DDI.411': 'Płyn spalinowy do silników wysokoprężnych Kons. na obszar',
		'ISOBUS.DDI.412': 'Zużycie płynu spalinowego w całym okresie eksploatacji',
		'ISOBUS.DDI.413': 'Średnie zużycie płynu spalinowego w całym okresie eksploatacji na czas',
		'ISOBUS.DDI.414': 'Średnie zużycie płynu do silników wysokoprężnych w całym okresie eksploatacji na obszar',
		'ISOBUS.DDI.415': 'Rzeczywista liczba nasion (Seed Singulation Percentage)',
		'ISOBUS.DDI.416': 'Średnia procentowa liczba nasion (Seed Singulation Percentage)',
		'ISOBUS.DDI.417': 'Rzeczywista wartość procentowa pominięcia nasion',
		'ISOBUS.DDI.418': 'Średnia wartość procentowa pominięcia nasion',
		'ISOBUS.DDI.419': 'Rzeczywista liczba nasion Procent',
		'ISOBUS.DDI.42': 'Masa rzeczywista na czas Dawkowanie',
		'ISOBUS.DDI.420': 'Średnia liczba nasion Procent',
		'ISOBUS.DDI.421': 'Odchylenie rzeczywistego rozstawu nasion',
		'ISOBUS.DDI.422': 'Średnia odległość między nasionami Odchylenie',
		'ISOBUS.DDI.423': 'Rzeczywisty współczynnik zmienności rozstawu nasion Procent',
		'ISOBUS.DDI.424': 'Średni współczynnik zmienności rozstawu nasion Procent',
		'ISOBUS.DDI.425': 'Wartość zadana Maksymalne dopuszczalne odchylenie odstępu między nasionami',
		'ISOBUS.DDI.426': 'Ustawienie siły docisku jako siły',
		'ISOBUS.DDI.427': 'Rzeczywista siła docisku jako siła',
		'ISOBUS.DDI.428': 'Obciążona masa całkowita',
		'ISOBUS.DDI.429': 'Masa całkowita bez obciążenia',
		'ISOBUS.DDI.43': 'Domyślna masa na czas Dawkowanie',
		'ISOBUS.DDI.430': 'Czas życia z obciążeniem Masa całkowita',
		'ISOBUS.DDI.431': 'Czas życia bez obciążenia Masa całkowita',
		'ISOBUS.DDI.432': 'Zadana dawka stosowania azotu',
		'ISOBUS.DDI.433': 'Rzeczywista dawka azotu',
		'ISOBUS.DDI.434': 'Minimalna dawka azotu',
		'ISOBUS.DDI.435': 'Maksymalna dawka azotu',
		'ISOBUS.DDI.436': 'Zadana dawka stosowania amonu',
		'ISOBUS.DDI.437': 'Rzeczywista dawka stosowania amonu',
		'ISOBUS.DDI.438': 'Minimalna dawka stosowania amonu',
		'ISOBUS.DDI.439': 'Maksymalna dawka amonu',
		'ISOBUS.DDI.44': 'Minimalna masa na czas Dawkowanie',
		'ISOBUS.DDI.440': 'Zadana dawka fosforu',
		'ISOBUS.DDI.441': 'Rzeczywista dawka fosforu',
		'ISOBUS.DDI.442': 'Minimalna dawka fosforu',
		'ISOBUS.DDI.443': 'Maksymalna dawka fosforu',
		'ISOBUS.DDI.444': 'Zadana dawka potasu',
		'ISOBUS.DDI.445': 'Rzeczywista dawka potasu',
		'ISOBUS.DDI.446': 'Minimalna dawka potasu',
		'ISOBUS.DDI.447': 'Maksymalna dawka potasu',
		'ISOBUS.DDI.448': 'Zadana dawka suchej masy',
		'ISOBUS.DDI.449': 'Rzeczywista dawka suchej masy',
		'ISOBUS.DDI.45': 'Maksymalna masa na czas Dawkowanie',
		'ISOBUS.DDI.450': 'Minimalna dawka suchej masy',
		'ISOBUS.DDI.451': 'Maksymalna dawka suchej masy',
		'ISOBUS.DDI.452': 'Załadowany Pojemność całkowita',
		'ISOBUS.DDI.453': 'Objętość całkowita bez obciążenia',
		'ISOBUS.DDI.454': 'Żywotność obciążona Pojemność całkowita',
		'ISOBUS.DDI.455': 'Czas życia bez obciążenia Pojemność całkowita',
		'ISOBUS.DDI.456': 'Ostatni załadowany wolumen',
		'ISOBUS.DDI.457': 'Ostatni rozładowany wolumen',
		'ISOBUS.DDI.458': 'Załadowany Całkowita liczba',
		'ISOBUS.DDI.459': 'Nieobciążony Łącznie',
		'ISOBUS.DDI.46': 'Wartość zadana Licznik na czas Dawka',
		'ISOBUS.DDI.460': 'Lifetime Loaded Total Count (czas życia)',
		'ISOBUS.DDI.461': 'Czas życia bez obciążenia Całkowita liczba',
		'ISOBUS.DDI.462': 'Ostatnio załadowana liczba',
		'ISOBUS.DDI.463': 'Ostatnie rozładowanie Liczby',
		'ISOBUS.DDI.464': 'Licznik zaciągu',
		'ISOBUS.DDI.465': 'Licznik czasu pracy',
		'ISOBUS.DDI.466': 'Rzeczywisty kąt względny złącza',
		'ISOBUS.DDI.467': 'Rzeczywista zawartość procentowa',
		'ISOBUS.DDI.468': 'Gleba Śnieg/warunek mrozu',
		'ISOBUS.DDI.469': 'Szacowany stan wody w glebie',
		'ISOBUS.DDI.47': 'Faktyczna liczba na czas Dawkowanie',
		'ISOBUS.DDI.470': 'Zagęszczenie gleby',
		'ISOBUS.DDI.472': 'Wartość zadana Długość cięcia',
		'ISOBUS.DDI.473': 'Minimalna długość cięcia',
		'ISOBUS.DDI.474': 'Maksymalna długość cięcia',
		'ISOBUS.DDI.475': 'Wartość zadana Ciśnienie hydrauliczne beli',
		'ISOBUS.DDI.476': 'Minimalne ciśnienie hydrauliczne beli',
		'ISOBUS.DDI.477': 'Maksymalne ciśnienie hydrauliczne beli',
		'ISOBUS.DDI.478': 'Wartość zadana Wielkość płatków',
		'ISOBUS.DDI.479': 'Minimalna wielkość płatków',
		'ISOBUS.DDI.48': 'Domyślnie Ilość na czas Dawka',
		'ISOBUS.DDI.480': 'Maksymalna wielkość płatków',
		'ISOBUS.DDI.481': 'Wartość zadana Liczba podbalasów',
		'ISOBUS.DDI.482': 'Ostatnia bela Liczba bel cząstkowych',
		'ISOBUS.DDI.483': 'Wartość zadana Prędkość obrotowa silnika',
		'ISOBUS.DDI.484': 'Rzeczywista prędkość obrotowa silnika',
		'ISOBUS.DDI.485': 'Minimalna prędkość obrotowa silnika',
		'ISOBUS.DDI.486': 'Maksymalna prędkość obrotowa silnika',
		'ISOBUS.DDI.488': 'Poziom procentowy w zbiorniku płynu spalinowego do silników wysokoprężnych',
		'ISOBUS.DDI.489': 'Maksymalna zawartość zbiornika płynu spalinowego do silników wysokoprężnych',
		'ISOBUS.DDI.49': 'Minimalna liczba na czas Dawka stosowania',
		'ISOBUS.DDI.490': 'Maksymalna zawartość zbiornika paliwa',
		'ISOBUS.DDI.491': 'Poziom procentowy paliwa',
		'ISOBUS.DDI.492': 'Całkowita liczba godzin pracy silnika',
		'ISOBUS.DDI.493': 'Żywotność Godziny pracy silnika',
		'ISOBUS.DDI.494': 'Identyfikator partnera ostatniego zdarzenia (bajt 1-4)',
		'ISOBUS.DDI.495': 'Identyfikator partnera ostatniego zdarzenia (bajt 5-8)',
		'ISOBUS.DDI.496': 'Identyfikator partnera ostatniego zdarzenia (bajt 9-12)',
		'ISOBUS.DDI.497': 'Identyfikator partnera ostatniego zdarzenia (bajt 13-16)',
		'ISOBUS.DDI.498': 'Ostatnie zdarzenie Typ ID partnera',
		'ISOBUS.DDI.499': 'Ostatnie zdarzenie ID partnera Kod ID producenta',
		'ISOBUS.DDI.5': 'Maksymalna objętość na powierzchnię Dawkowanie',
		'ISOBUS.DDI.50': 'Maksymalna liczba na czas Dawkowanie',
		'ISOBUS.DDI.500': 'Ostatnie zdarzenie ID partnera Klasa urządzenia',
		'ISOBUS.DDI.501': 'Wartość zadana Moment obrotowy silnika',
		'ISOBUS.DDI.502': 'Rzeczywisty moment obrotowy silnika',
		'ISOBUS.DDI.503': 'Minimalny moment obrotowy silnika',
		'ISOBUS.DDI.504': 'Maksymalny moment obrotowy silnika',
		'ISOBUS.DDI.505': 'Poziom kontroli linii tramwajowej',
		'ISOBUS.DDI.506': 'Wartość zadana Poziom sterowania linią tramwajową',
		'ISOBUS.DDI.507': 'Numer kolejny linii tramwajowej',
		'ISOBUS.DDI.508': 'Unikalny identyfikator linii odniesienia A-B wytycznych',
		'ISOBUS.DDI.509': 'Rzeczywisty numer ścieżki',
		'ISOBUS.DDI.51': 'Wartość zadana Głębokość uprawy',
		'ISOBUS.DDI.510': 'Numer ścieżki po prawej stronie',
		'ISOBUS.DDI.511': 'Numer ścieżki po lewej stronie',
		'ISOBUS.DDI.512': 'Linia prowadząca Szerokość pokosu',
		'ISOBUS.DDI.513': 'Odchylenie linii orientacyjnej',
		'ISOBUS.DDI.514': 'Jakość GNSS',
		'ISOBUS.DDI.515': 'Stan kontroli linii tramwajowej',
		'ISOBUS.DDI.516': 'Wskaźnik przedawkowania tramliny',
		'ISOBUS.DDI.517': 'Wartość zadana ścieżek technologicznych Stan roboczy (1-16)',
		'ISOBUS.DDI.518': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (1-16)',
		'ISOBUS.DDI.519': 'Ostatnia bela Licznik żywotności',
		'ISOBUS.DDI.52': 'Rzeczywista głębokość uprawy',
		'ISOBUS.DDI.520': 'Rzeczywista wysokość zadaszenia',
		'ISOBUS.DDI.521': 'Typ instalacji GNSS',
		'ISOBUS.DDI.522': 'Sznurek Bela Razem Liczba',
		'ISOBUS.DDI.523': 'Bela siatki Całkowita liczba',
		'ISOBUS.DDI.524': 'Bela sznurka na całe życie Całkowita liczba',
		'ISOBUS.DDI.525': 'Żywotność Bela siatkowa Całkowita liczba',
		'ISOBUS.DDI.526': 'Rzeczywista temperatura płynu chłodzącego',
		'ISOBUS.DDI.528': 'Ostatnia bela Pojemność',
		'ISOBUS.DDI.529': 'Ustawienie kąta pochylenia talerzy uprawowych',
		'ISOBUS.DDI.53': 'Domyślna głębokość uprawy',
		'ISOBUS.DDI.530': 'Rzeczywisty kąt pochylenia talerzy uprawowych',
		'ISOBUS.DDI.531': 'Rzeczywiście zastosowany środek konserwujący na masę plonu',
		'ISOBUS.DDI.532': 'Wartość zadana Zastosowany środek konserwujący na masę plonu',
		'ISOBUS.DDI.533': 'Domyślnie zastosowany środek konserwujący na masę plonu',
		'ISOBUS.DDI.534': 'Minimalna ilość środka konserwującego na masę użytkową',
		'ISOBUS.DDI.535': 'Maksymalna ilość zastosowanego środka konserwującego na masę plonu',
		'ISOBUS.DDI.536': 'Łącznie zastosowany środek konserwujący',
		'ISOBUS.DDI.537': 'Środek konserwujący stosowany przez całe życie',
		'ISOBUS.DDI.538': 'Średnia ilość zastosowanego środka konserwującego na masę plonu',
		'ISOBUS.DDI.539': 'Rzeczywista objętość zbiornika środka konserwującego',
		'ISOBUS.DDI.54': 'Minimalna głębokość uprawy',
		'ISOBUS.DDI.540': 'Rzeczywisty poziom środka konserwującego w zbiorniku',
		'ISOBUS.DDI.541': 'Aktualne obroty WOM',
		'ISOBUS.DDI.542': 'Wartość zadana prędkości obrotowej WOM',
		'ISOBUS.DDI.543': 'Standardowa liczba obrotów WOM',
		'ISOBUS.DDI.544': 'Minimalna prędkość obrotowa WOM',
		'ISOBUS.DDI.545': 'Maksymalna prędkość WOM',
		'ISOBUS.DDI.546': 'Żywotność Zaangażowanie w cięcie Czas całkowity',
		'ISOBUS.DDI.547': 'Wartość zadana Kompresja beli Obciążenie tłoka',
		'ISOBUS.DDI.548': 'Rzeczywiste obciążenie tłoka ściskającego belę',
		'ISOBUS.DDI.549': 'Ostatnia bela Średnia bela Kompresja Obciążenie nurnika',
		'ISOBUS.DDI.55': 'Maksymalna głębokość uprawy',
		'ISOBUS.DDI.550': 'Okrycie terenu',
		'ISOBUS.DDI.551': 'Rzeczywisty moment obrotowy WOM',
		'ISOBUS.DDI.552': 'Wartość zadana momentu obrotowego PTO',
		'ISOBUS.DDI.553': 'Domyślny moment obrotowy WOM',
		'ISOBUS.DDI.554': 'Minimalny moment obrotowy WOM',
		'ISOBUS.DDI.555': 'Maksymalny moment obrotowy WOM',
		'ISOBUS.DDI.556': 'Obecne warunki pogodowe',
		'ISOBUS.DDI.557': 'Wartość zadana Prąd elektryczny',
		'ISOBUS.DDI.558': 'Rzeczywisty prąd elektryczny',
		'ISOBUS.DDI.559': 'Minimalny prąd elektryczny',
		'ISOBUS.DDI.56': 'Wartość zadana Głębokość siewu',
		'ISOBUS.DDI.560': 'Maksymalny prąd elektryczny',
		'ISOBUS.DDI.561': 'Domyślny prąd elektryczny',
		'ISOBUS.DDI.562': 'Napięcie zadane',
		'ISOBUS.DDI.563': 'Napięcie domyślne',
		'ISOBUS.DDI.564': 'Napięcie rzeczywiste',
		'ISOBUS.DDI.565': 'Minimalne napięcie',
		'ISOBUS.DDI.566': 'Napięcie maksymalne',
		'ISOBUS.DDI.567': 'Rzeczywista oporność elektryczna',
		'ISOBUS.DDI.568': 'Wartość zadana Moc elektryczna',
		'ISOBUS.DDI.569': 'Rzeczywista moc elektryczna',
		'ISOBUS.DDI.57': 'Rzeczywista głębokość siewu',
		'ISOBUS.DDI.570': 'Domyślne zasilanie elektryczne',
		'ISOBUS.DDI.571': 'Maksymalna moc elektryczna',
		'ISOBUS.DDI.572': 'Minimalna moc elektryczna',
		'ISOBUS.DDI.573': 'Całkowita energia elektryczna',
		'ISOBUS.DDI.574': 'Wartość zadana Energia elektryczna na obszar Wskaźnik zastosowania',
		'ISOBUS.DDI.575': 'Rzeczywista energia elektryczna na obszar Wskaźnik zastosowania',
		'ISOBUS.DDI.576': 'Maksymalna ilość energii elektrycznej na powierzchnię Wydajność',
		'ISOBUS.DDI.577': 'Minimalna ilość energii elektrycznej na obszar Zastosowania',
		'ISOBUS.DDI.578': 'Temperatura zadana',
		'ISOBUS.DDI.579': 'Temperatura rzeczywista',
		'ISOBUS.DDI.58': 'Domyślna głębokość siewu',
		'ISOBUS.DDI.580': 'Temperatura minimalna',
		'ISOBUS.DDI.581': 'Temperatura maksymalna',
		'ISOBUS.DDI.582': 'Temperatura domyślna',
		'ISOBUS.DDI.583': 'Wartość zadana Częstotliwość',
		'ISOBUS.DDI.584': 'Rzeczywista częstotliwość',
		'ISOBUS.DDI.585': 'Minimalna częstotliwość',
		'ISOBUS.DDI.586': 'Maksymalna częstotliwość',
		'ISOBUS.DDI.587': 'Poprzedni Opady deszczu',
		'ISOBUS.DDI.588': 'Wartość zadana Objętość na powierzchnię Dawkowanie',
		'ISOBUS.DDI.589': 'Rzeczywista objętość na powierzchnię Dawka',
		'ISOBUS.DDI.59': 'Minimalna głębokość siewu',
		'ISOBUS.DDI.590': 'Minimalna objętość na powierzchnię Dawkowanie',
		'ISOBUS.DDI.591': 'Maksymalna objętość na powierzchnię Dawkowanie',
		'ISOBUS.DDI.592': 'Domyślna objętość na powierzchnię Dawkowanie',
		'ISOBUS.DDI.593': 'Typ trakcji',
		'ISOBUS.DDI.594': 'Typ układu kierowniczego',
		'ISOBUS.DDI.595': 'Tryb maszynowy',
		'ISOBUS.DDI.596': 'Powierzchnia ładunkowa Stan pokrycia',
		'ISOBUS.DDI.597': 'Całkowita odległość',
		'ISOBUS.DDI.598': 'Czas życia Dystans całkowity',
		'ISOBUS.DDI.599': 'Całkowita odległość Pole',
		'ISOBUS.DDI.6': 'Wartość zadana Masa na powierzchnię Dawkowanie',
		'ISOBUS.DDI.60': 'Maksymalna głębokość siewu',
		'ISOBUS.DDI.600': 'Żywotność Całkowita odległość Pole',
		'ISOBUS.DDI.601': 'Całkowita odległość Ulica',
		'ISOBUS.DDI.602': 'Czas życia Całkowita odległość Ulica',
		'ISOBUS.DDI.603': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (17-32)',
		'ISOBUS.DDI.604': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (33-48)',
		'ISOBUS.DDI.605': 'Rzeczywista linia tramwajowa Skondensowany stan pracy  (49-64) ',
		'ISOBUS.DDI.606': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (65-80) ',
		'ISOBUS.DDI.607': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (81-96)',
		'ISOBUS.DDI.608': 'Actual Tramline Condensed Work State (97-112)',
		'ISOBUS.DDI.609': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (113-128) ',
		'ISOBUS.DDI.61': 'Wartość zadana Wysokość robocza',
		'ISOBUS.DDI.610': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (129-144)',
		'ISOBUS.DDI.611': 'Rzeczywista linia tramwajowa Skondensowany stan pracy  (145-160) ',
		'ISOBUS.DDI.612': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (161-176)',
		'ISOBUS.DDI.613': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (177-192) ',
		'ISOBUS.DDI.614': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (193-208)',
		'ISOBUS.DDI.615': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (209-224)',
		'ISOBUS.DDI.616': 'Rzeczywista linia tramwajowa Skondensowany stan pracy  (225-240) ',
		'ISOBUS.DDI.617': 'Rzeczywista linia tramwajowa Skondensowany stan pracy (241-256)',
		'ISOBUS.DDI.618': 'Wartość zadana Tramwajowa skondensowana Stan roboczy (17-32)',
		'ISOBUS.DDI.619': 'Wartość zadana Tramwajowa skondensowana Stan roboczy  (33-48)',
		'ISOBUS.DDI.62': 'Rzeczywista wysokość robocza',
		'ISOBUS.DDI.620': 'Wartość zadana Tramwajowa skondensowana Stan roboczy  (49-64)',
		'ISOBUS.DDI.621': 'Wartość zadana Tramwajowa skondensowana Stan roboczy  (65-80)',
		'ISOBUS.DDI.622': 'Wartość zadana Tramwajowa skondensowana Stan roboczy  (81-96)',
		'ISOBUS.DDI.623': 'Wartość zadana Tramwajowa skondensowana Stan roboczy  (97-112)',
		'ISOBUS.DDI.624': 'Wartość zadana Tramwajowa skondensowana Stan roboczy  (113-128)',
		'ISOBUS.DDI.625': 'Wartość zadana Tramwajowa skondensowana Stan roboczy ',
		'ISOBUS.DDI.626': 'Wartość zadana Tramwajowa skondensowana Stan roboczy (145-160)',
		'ISOBUS.DDI.627': 'Wartość zadana Tramwajowa skondensowana Stan roboczy (161-176)',
		'ISOBUS.DDI.628': 'Wartość zadana Tramwajowa skondensowana Stan roboczy  (177-192)',
		'ISOBUS.DDI.629': 'Wartość zadana Tramwajowa skondensowana Stan roboczy  (193-208)',
		'ISOBUS.DDI.63': 'Domyślna wysokość robocza',
		'ISOBUS.DDI.630': 'Wartość zadana Tramwajowa skondensowana Stan roboczy  (209-224)',
		'ISOBUS.DDI.631': 'Wartość zadana Tramwajowa skondensowana Stan roboczy  (225-240)',
		'ISOBUS.DDI.632': 'Wartość zadana Tramwajowa skondensowana Stan roboczy (241-256)',
		'ISOBUS.DDI.634': 'Rzeczywista objętość na odległość Dawka aplikacji',
		'ISOBUS.DDI.635': 'Domyślna objętość na odległość dawki aplikacji',
		'ISOBUS.DDI.636': 'Minimalna objętość na odległość dawkowania',
		'ISOBUS.DDI.637': 'Maksymalna objętość na odległość Dawka aplikacji',
		'ISOBUS.DDI.638': 'Zadane ciśnienie w oponach',
		'ISOBUS.DDI.639': 'Rzeczywiste ciśnienie w oponach',
		'ISOBUS.DDI.64': 'Minimalna wysokość robocza',
		'ISOBUS.DDI.640': 'Domyślne ciśnienie w oponach',
		'ISOBUS.DDI.641': 'Minimalne ciśnienie w oponach',
		'ISOBUS.DDI.642': 'Maksymalne ciśnienie w oponach',
		'ISOBUS.DDI.643': 'Rzeczywista temperatura opony',
		'ISOBUS.DDI.65': 'Maksymalna wysokość robocza',
		'ISOBUS.DDI.66': 'Wartość zadana Szerokość robocza',
		'ISOBUS.DDI.67': 'Rzeczywista szerokość robocza',
		'ISOBUS.DDI.68': 'Domyślna szerokość robocza',
		'ISOBUS.DDI.69': 'Minimalna szerokość robocza',
		'ISOBUS.DDI.7': 'Masa rzeczywista na powierzchnię Dawkowanie',
		'ISOBUS.DDI.70': 'Maksymalna szerokość robocza',
		'ISOBUS.DDI.71': 'Wartość zadana Ilość Zawartość',
		'ISOBUS.DDI.72': 'Rzeczywista objętość Zawartość',
		'ISOBUS.DDI.73': 'Maksymalna zawartość objętościowa',
		'ISOBUS.DDI.74': 'Wartość zadana Zawartość masy',
		'ISOBUS.DDI.75': 'Masa rzeczywista Zawartość',
		'ISOBUS.DDI.76': 'Maksymalna masa Zawartość',
		'ISOBUS.DDI.77': 'Zawartość licznika wartości zadanej',
		'ISOBUS.DDI.78': 'Rzeczywista liczba Zawartość',
		'ISOBUS.DDI.79': 'Maksymalne liczenie Zawartość',
		'ISOBUS.DDI.8': 'Domyślna masa na powierzchnię Dawkowanie',
		'ISOBUS.DDI.80': 'Aplikacja Całkowita objętość',
		'ISOBUS.DDI.81': 'Zastosowanie Masa całkowita',
		'ISOBUS.DDI.82': 'Wniosek Łączna liczba',
		'ISOBUS.DDI.83': 'Objętość na powierzchnię Plon',
		'ISOBUS.DDI.84': 'Masa na powierzchnię Plon',
		'ISOBUS.DDI.85': 'Liczba na obszar Plon',
		'ISOBUS.DDI.86': 'Objętość na czas Wydajność',
		'ISOBUS.DDI.87': 'Masa na czas Wydajność',
		'ISOBUS.DDI.88': 'Count Per Time Yield',
		'ISOBUS.DDI.89': 'Wydajność Całkowita objętość',
		'ISOBUS.DDI.9': 'Minimalna masa na powierzchnię Dawka',
		'ISOBUS.DDI.90': 'Wydajność Masa całkowita',
		'ISOBUS.DDI.91': 'Wydajność Całkowita liczba',
		'ISOBUS.DDI.92': 'Wielkość na powierzchnię Straty w uprawach',
		'ISOBUS.DDI.93': 'Masa na obszar Straty w uprawach',
		'ISOBUS.DDI.94': 'Liczba na obszar Straty w uprawach',
		'ISOBUS.DDI.95': 'Ilość na czas Straty w uprawach',
		'ISOBUS.DDI.96': 'Masa na czas Strata w plonie',
		'ISOBUS.DDI.97': 'Liczba na czas Straty w uprawach',
		'ISOBUS.DDI.98': 'Procentowa strata w uprawach',
		'ISOBUS.DDI.99': 'Wilgotność upraw',
		'ISOBUS.DEVICE_CLASS.0': 'Nie określono',
		'ISOBUS.DEVICE_CLASS.1': 'Ciągnik',
		'ISOBUS.DEVICE_CLASS.10': 'Nawadnianie',
		'ISOBUS.DEVICE_CLASS.11': 'Transport/przyczepa',
		'ISOBUS.DEVICE_CLASS.12': 'Operacje na terenie gospodarstwa',
		'ISOBUS.DEVICE_CLASS.13': 'Zasilane urządzenia pomocnicze',
		'ISOBUS.DEVICE_CLASS.14': 'Uprawy specjalne',
		'ISOBUS.DEVICE_CLASS.15': 'Prace ziemne',
		'ISOBUS.DEVICE_CLASS.16': 'Skidder (zrywka)',
		'ISOBUS.DEVICE_CLASS.17': 'Systemy czujników',
		'ISOBUS.DEVICE_CLASS.18': ' - ',
		'ISOBUS.DEVICE_CLASS.19': 'Żniwiarze drewna',
		'ISOBUS.DEVICE_CLASS.2': 'Uprawa roli',
		'ISOBUS.DEVICE_CLASS.20': 'Spedytorzy',
		'ISOBUS.DEVICE_CLASS.21': 'Ładowarki do drewna',
		'ISOBUS.DEVICE_CLASS.22': 'Maszyny do obróbki drewna',
		'ISOBUS.DEVICE_CLASS.23': 'Mulczery',
		'ISOBUS.DEVICE_CLASS.24': 'Pojazdy użytkowe',
		'ISOBUS.DEVICE_CLASS.25': 'Aplikatory gnojowicy/obornika',
		'ISOBUS.DEVICE_CLASS.26': 'Podajniki/Mieszalniki',
		'ISOBUS.DEVICE_CLASS.27': 'Chwastowniki',
		'ISOBUS.DEVICE_CLASS.3': 'Uprawa wtórna',
		'ISOBUS.DEVICE_CLASS.4': 'Sadzarki/siewnika',
		'ISOBUS.DEVICE_CLASS.5': 'Nawozy',
		'ISOBUS.DEVICE_CLASS.6': 'Opryskiwacze',
		'ISOBUS.DEVICE_CLASS.7': 'Harwestery',
		'ISOBUS.DEVICE_CLASS.8': 'Kombajny do zbioru korzeni',
		'ISOBUS.DEVICE_CLASS.9': 'Forage',
		"ISOBUS.ELEMENT_NUMBER": "Numer elementu",
		'JOB.ARCHIVE.QUESTION': 'Czy naprawdę chcesz zarchiwizować tę pracę?',
		'JOB.ARCHIVE.SUCCESS': 'Praca zostanie zarchiwizowana',
		'JOB.CAN_NOT_BE_DISPLAYED_COMPLETELY': 'Praca nie może być wyświetlona w całości. Wszelkie informacje powyżej mogą być nieaktualne i zostaną ponownie obliczone.',
		'JOB.CURRENT_STATUS': 'Stan obecny',
		'JOB.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć tę pracę?',
		'JOB.DELETE.SUCCESS': 'Praca zostanie usunięta',
		'JOB.DETAILS': 'Szczegóły dotyczące pracy',
		'JOB.DRIVER_IMPLEMENT': 'Usunąć lub zmienić sterownik/implement.',
		'JOB.EDIT': 'Edytuj pracę',
		'JOB.REGENERATE': 'Zregenerować pracę',
		'JOB.REGENERATE.DRIVER': 'Aktualizacja danych Operatora',
		'JOB.REGENERATE.FIELDS': 'Aktualizacja danych pola',
		'JOB.REGENERATE.IMPLEMENT': 'Aktualizacja danych wykonawczych',
		'JOB.REGENERATE.INTRO': 'Jeśli dane rozliczeniowe dla maszyn, narzędzi lub kierowców uległy zmianie, można je również zaktualizować.',
		'JOB.REGENERATE.LOCATIONS': 'Aktualizacja danych lokalizacji',
		'JOB.REGENERATE.MACHINE': 'Aktualizacja danych maszyny',
		'JOB.REGENERATE.QUESTION': 'Które dane są aktualizowane?',
		'JOB.REGENERATE.SUCCESS': 'Hiob zostanie zregenerowany',
		'JOB.SPLIT': 'Podziel się pracą',
		'JOB.SPLIT.ADD_SPLIT_TIME': 'Dodaj czas podziału',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO': 'W przypadku ustawień z dokładnością do sekundy, suwak czasu można również obsługiwać za pomocą przycisków strzałek.',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO2': 'Dodaj czas(y) do podziału pracy.',
		'JOB.SPLIT.NO_CHANGE': 'Brak zmian w pracy',
		'JOB.SPLIT.NO_SPLITS': 'Nie wybrano czasu(ów) do podziału.',
		'JOB.UPDATE': 'Aktualizovat úlohy',
		'JOB.WAITING_TIME_UNTIL_READY': 'W zależności od aktualnego stanu może to potrwać kilka minut, aż zadanie zostanie całkowicie pokazane.',
		'JOBS': 'Praca',
		'JOBS.ALL': 'Wszystkie miejsca pracy',
		'JOBS.ARCHIVE.PARTIAL': 'Niektóre prace są archiwizowane.',
		'JOBS.ARCHIVE.QUESTION': 'Czy naprawdę chcesz archiwizować wybrane zadania?',
		'JOBS.ARCHIVE.SUCCESS': 'Miejsca pracy będą archiwizowane',
		'JOBS.CREATE_TASK': 'Utwórz zadanie',
		'JOBS.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć wybrane zadania? Wszystkie dane zadań zostaną usunięte nieodwracalnie.',
		'JOBS.DELETE.SUCCESS': 'Miejsca pracy zostaną usunięte',
		'JOBS.DELETED.FAILURE': 'Niektórych zadań nie można było usunąć.',
		'JOBS.EDIT': 'Edycja miejsc pracy',
		'JOBS.EDIT.SUCCESS': 'Miejsca pracy będą edytowane',
		'JOBS.IN_TASK': 'Praca w zadaniach',
		'JOBS.MERGE.SUCCESS': 'Miejsca pracy będą łączone',
		'JOBS.MERGING': 'Łączenie stanowisk pracy',
		'JOBS.NO': 'Brak pracy',
		'JOBS.NOT_SELECTED': 'Nie wybrano żadnej pracy',
		'JOBS.REGENERATE': 'Regeneracja miejsc pracy',
		'JOBS.REGENERATE.SUCCESS': 'Miejsca pracy zostaną zregenerowane',
		'JOBS.SELECTED': 'Wybrane zawody',
		'JOBS.TASK_CREATED': 'Zadanie zostało pomyślnie utworzone',
		'JOBS.UPDATE.SUCCESS': 'Pracovní místa budou aktualizována',
		'JOBS.WITHOUT_TASK': 'Praca bez zadań',
		'JOBS.WITH_TASK': 'Miejsca pracy w zadaniu',
		'KILOMETERS': 'Kilometry',
		'LANGUAGE': 'Język',
		'LANGUAGE.ADD': 'Dodaj język',
		'LANGUAGE.CODE': 'Kod języka',
		'LANGUAGE.DEFAULT': 'Domyślny język',
		'LASTNAME': 'Nazwisko',
		'LAST_ONLINE': 'Ostatni online',
		'LAST_UPDATED': 'Ostatnia aktualizacja',
		'LATITUDE': 'Szerokość geograficzna',
		'LOAD.MORE': 'Załaduj więcej',
		'LOADS': 'Obciążenia',
		'LOCATION': 'Lokalizacja',
		'LOCATION.ADD': 'Dodaj lokalizację',
		'LOCATION.ADD.SUCCESS': 'Lokalizacja została pomyślnie dodana',
		'LOCATION.DEACTIVATE.QUESTION': 'Czy naprawdę chcesz dezaktywować lokalizację?',
		'LOCATION.DEACTIVATE.SUCCESS': 'Umístění bylo úspěšně deaktivováno',
		'LOCATION.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć lokalizację?',
		'LOCATION.DELETE.SUCCESS': 'Umístění bylo úspěšně odstraněno',
		'LOCATION.DETAILS': 'Szczegóły dotyczące lokalizacji',
		'LOCATION.DRAW.START': 'Zaznacz teraz lokalizację na mapie!',
		'LOCATION.EDIT.SUCCESS': 'Lokalizacja została pomyślnie edytowana',
		'LOCATIONS': 'Lokalizacje',
		'LOCATIONS.ALL': 'Wszystkie lokalizacje',
		'LOCATIONS.DEACTIVATE.FAILURE': 'Niektórych lokalizacji nie można było dezaktywować.',
		'LOCATIONS.DEACTIVATE.QUESTION': 'Czy naprawdę chcesz dezaktywować lokalizacje?',
		'LOCATIONS.DEACTIVATE.SUCCESS': 'Lokalizacje zostały pomyślnie dezaktywowane',
		'LOCATIONS.DELETE.FAILURE': 'Niektórych lokalizacji nie można było usunąć.',
		'LOCATIONS.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć wybrane lokalizacje?',
		'LOCATIONS.DELETE.SUCCESS': 'Lokalizacje zostały pomyślnie usunięte',
		'LOCATIONS.NO': 'Brak lokalizacji',
		'LOCATIONS.NOT_SELECTED': 'Nie wybrano żadnych lokalizacji',
		'LOCATIONS.REACTIVATE.FAILURE': 'Niektórych lokalizacji nie można było ponownie aktywować.',
		'LOCATIONS.REACTIVATE.QUESTION': 'Czy naprawdę chcesz ponownie aktywować wybrane lokalizacje?',
		'LOCATIONS.REACTIVATE.SUCCESS': 'Lokalizacje zostały pomyślnie reaktywowane',
		'LOCATIONS.SELECTED': 'Wybrane lokalizacje',
		'LOG': 'Rejestr komunikatów',
		'LOGIN': 'Zaloguj się',
		'LOGIN.NOT_UNLOCKED_YET': 'Jeszcze nie odblokowane?',
		'LOGIN.NO_ACCOUNT_YET': 'Nie masz jeszcze konta?',
		'LOGIN.PASSWORD_FORGOTTEN': 'Zapomniałeś hasła?',
		'LOGIN.REGISTER': 'Zarejestruj się',
		'LOGIN.REMEMBER_PASSWORD': 'Zapamiętaj hasło',
		'LOGIN.UNLOCK': 'Odblokuj',
		'LOG_OUT': 'Wyloguj się',
		'LONGITUDE': 'Długość geograficzna',
		'LOST_PASSWORD.CHANGE_PASSWORD': 'Zmiana hasła',
		'LOST_PASSWORD.ENTER_ACTIVATION': 'Wpisz kod aktywacyjny, który otrzymałeś w wiadomości e-mail.',
		'LOST_PASSWORD.ENTER_EMAIL_HERE': 'Proszę wpisać tutaj swój e-mail.',
		'LOST_PASSWORD.ENTER_VALID_EMAIL': 'Proszę wpisać prawidłowy adres e-mail.',
		'MAC': ' MAC ',
		'MACHINE': 'Maszyna',
		'MACHINE.ADD': 'Dodaj maszynę',
		'MACHINE.ADD.SUCCESS': 'Maszyna została pomyślnie dodana',
		'MACHINE.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć maszynę?',
		'MACHINE.DELETE.SUCCESS': 'Maszyna została pomyślnie usunięta',
		'MACHINE.DETAILS': 'Szczegóły dotyczące maszyny',
		'MACHINE.EDIT': 'Maszyna do edycji',
		'MACHINE.EDIT.SUCCESS': 'Maszyna pomyślnie zredagowana',
		'MACHINE.INTERVAL.ADD': 'Dodaj interwał urządzenia',
		'MACHINE.LIVE_STATUS': 'Stan maszyny na żywo',
		'MACHINE.NO': 'Nie ma maszyny',
		'MACHINE.RELOAD_POSITIONS': 'Przeładowanie pozycji maszyny',
		'MACHINE.STATUS': 'Status maszyny',
		'MACHINES': 'Maszyna',
		'MACHINES.ALL': 'Wszystkie maszyny',
		'MACHINES.DEACTIVATE.FAILURE': 'Niektórych urządzeń nie można było dezaktywować.',
		'MACHINES.DEACTIVATE.QUESTION': 'Czy naprawdę chcesz dezaktywować wybrane urządzenia?',
		'MACHINES.DEACTIVATE.SUCCESS': 'Maszyny zostały pomyślnie dezaktywowane',
		'MACHINES.DELETE.FAILURE': 'Niektórych maszyn nie dało się usunąć.',
		'MACHINES.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć wybrane maszyny?',
		'MACHINES.DELETE.SUCCESS': 'Maszyny usunięte z powodzeniem',
		'MACHINES.MANAGEMENT': 'Zarządzanie maszynami',
		'MACHINES.NO': 'Żadnych maszyn',
		'MACHINES.NOT_SELECTED': 'Nie wybrano żadnej maszyny',
		'MACHINES.NO_LICENSE.WARNING': 'Maszyna nie ma dołączonej licencji. Bez licencji nie będą rejestrowane żadne dane',
		'MACHINES.REACTIVATE.FAILURE': 'Niektórych maszyn nie można było ponownie aktywować.',
		'MACHINES.REACTIVATE.QUESTION': 'Czy naprawdę chcesz ponownie aktywować wybrane urządzenia?',
		'MACHINES.REACTIVATE.SUCCESS': 'Maszyny zostały pomyślnie reaktywowane',
		'MACHINES.SELECTED': 'Wybrane maszyny',
		'MACHINE_COMBINATION': 'Machine combination',
		'MACHINE_IMPLEMENT': 'Maszyna/wdrożenie',
		'MAC_DEVICES': 'Urządzenia podłączone do maszyny',
		'MAINTENANCE': 'Konserwacja',
		'MAINTENANCE.AMOUNT': 'Kwota utrzymania',
		'MAINTENANCE.PERIOD': 'Okres utrzymania',
		'MAKE': 'Twórca',
		'MANURE': 'Obornik',
		'MANURE.TYPE': 'Rodzaj nawozu',
		'MAP': 'Mapa',
		'MAP.SECTION': 'Sekcja mapy',
		'MAP.SECTION.CHANGE': 'Zmiana sekcji mapy',
		'MARKER.ADD': 'Dodaj nowy znacznik',
		'MARKER.EDIT.BORDERS': 'Edytuj granice',
		'MARKER.ENTRANCE': 'Wejście',
		'MARKER.EXIT': 'Wyjście',
		'MARKER.INFO': 'Informacje',
		'MARKER.WARN': 'Warn',
		'MAX': 'Max',
		'MAX_VALUE': 'Wartość maksymalna',
		'MERGE': 'Połącz',
		'MESSAGES.NO': 'Brak wiadomości',
		'MILEAGE': 'Przebieg',
		'MILEAGE.INVALID': 'Nieprawidłowy przebieg',
		'MIN': 'Min',
		'MIN_VALUE': 'Wartość minimalna',
		'MOBILE': 'Mobilny',
		'MODE.SWITCH': 'Tryb przełączania',
		'MODEL': 'Model',
		'MYPROFILE': 'Mój profil',
		'MYPROFILE.BASIC_DATA': 'Dane podstawowe',
		'MYPROFILE.BASIC_DATA.EDIT.SUCCESS': 'Twoje podstawowe dane zostały zmienione',
		'NAME': 'Nazwa',
		'NAV.ACTIVITIES': 'Aktywności',
		'NAV.ADMIN': 'Administrator',
		'NAV.ADMIN.DASHBOARD': 'Pulpit',
		'NAV.ADMIN.INFO_VIEW': 'Admin Info',
		'NAV.ADMIN.JOB_IMPORT_VIEW': 'Job import',
		'NAV.ADMIN.JOB_VIEW': 'Widok stanowiska',
		'NAV.ADMIN.USERS': 'Zarządzanie użytkownikami',
		'NAV.CUSTOMERS': 'Klienci',
		'NAV.DASHBOARD': 'Pulpit',
		'NAV.DATA_PREPARATION': 'Przygotowanie danych',
		'NAV.EMPLOYEES': 'Pracownicy',
		'NAV.ENTERPRISE': 'Przedsiębiorstwo',
		'NAV.FIELDS': 'Pola',
		'NAV.FILE_TRANSFER': 'ISO Taskdata',
		'NAV.HARDWARE': 'Sprzęt',
		'NAV.HARDWARE_SETUP': 'Konfiguracja sprzętu',
		'NAV.IMPLEMENTS': 'Osprzęt',
		'NAV.LOCATIONS': 'Lokalizacje',
		'NAV.MACHINES': 'Maszyny',
		'NAV.MY_SECTION': 'Moja sekcja',
		'NAV.PATH_PLANNINGS': 'Path planning',
		'NAV.RETAILER': 'Sprzedawca detaliczny',
		'NAV.SETTINGS': 'Ustawienia',
		'NAV.SETTINGS.ADAPTER': 'Adapter',
		'NAV.SETTINGS.GENERAL': 'Przedsiębiorstwo',
		'NAV.SETTINGS.PARTNER': 'Partner',
		'NAV.STATISTIC': 'Statystyki',
		'NAV.TECH': 'TECH',
		'NAV.TRANSLATION.EDIT': 'Tłumaczenie edytuj',
		'NAV.TRANSLATION_MANAGEMENT': 'Zarządzanie tłumaczeniami',
		'NETWORK.ACCESS_TECHNOLOGY': 'Technologia dostępu',
		'NETWORK.OPERATOR': 'Operator',
		'NEXT': 'Następny',
		'NO': 'Nie',
		'NONE': 'Brak',
		'NOTICE': 'Uwaga',
		'NON_PRODUCTIVE_TIME': 'Czas nieproduktywny',
		'NON_PRODUCTIVE_TIMES': 'Czasy nieproduktywne',
		'NON_PRODUCTIVE_TIMES.SEPARATOR': 'Separator for non productive time computation',
		'NOT_READ': 'Nie można było odczytać.',
		'NO_DATA': 'Brak danych',
		'ONLY_ON': 'Tylko na',
		'OPACITY': 'Krycie',
		'OPERATING_HOURS': 'Godziny pracy',
		'OPERATING_HOURS.INVALID': 'Czas pracy nieważny',
		'OPERATION': 'Operacja',
		'OPERATION.NOT_SELECTED': 'Brak operacji na wybranym polu.',
		'OPERATION.SELECT': 'Wybierz operację',
		'OPERATIONS': 'Operacje',
		'OPERATIONS.ARRIVAL': 'Przybycie',
		'OPERATIONS.CUSTOMER': 'Operacje dla klienta',
		'OPERATIONS.FIELD': 'Operacje w terenie',
		'OPERATIONS.FIELDS': 'Operacje na polach',
		'OPERATIONS.FIELD_TIME': 'Czas na polu',
		'OPERATIONS.GEOMETRY': 'Geometria',
		'OPERATIONS.LOCATION': 'Operacje na miejscu',
		'OPERATIONS.LOCATIONS': 'Operacje na lokalizacjach',
		'OPERATIONS.NO': 'Brak operacji',
		'OPERATIONS.PREPARATION': 'Przygotowanie',
		'OVERRIDE.NO': 'Brak nadpisu',
		'PAGE': 'Page',
		'PAGE.OF': 'of',
		'PAGINATION.PER_PAGE': 'Na stronę',
		'PAGINATION.TOTAL': 'ogółem',
		'PAGINATOR.FIRST_PAGE': 'Pierwsza strona',
		'PAGINATOR.ITEMS_PER_PAGE': 'Pozycje na stronie',
		'PAGINATOR.LAST_PAGE': 'Ostatnia strona',
		'PAGINATOR.NEXT_PAGE': 'Następna strona',
		'PAGINATOR.OF': 'z',
		'PAGINATOR.PREVIOUS_PAGE': 'Poprzednia strona',
		'PARTNER_CONNECTION': 'Połączenie partnerskie',
		'PARTNER_CONNECTION.DOES_NOT_EXPIRE': 'Nie traci ważności',
		'PARTNER_CONNECTION.EXPIRES_ON': 'Wygasa w dniu',
		'PASSWORD': 'Hasło',
		'PASSWORD.CHANGE': 'Zmiana hasła',
		'PASSWORD.CHANGE.ACTIVATE': 'Aktualne hasło',
		'PASSWORD.CHANGE.SUCCESS': 'Hasło zostało pomyślnie zmienione',
		'PASSWORD.CONFIRM': 'Potwierdź nowe hasło',
		'PASSWORD.LENGTH.REQUIRED': 'Hasło musi mieć długość co najmniej 6 znaków',
		'PASSWORD.NEW_PASSWORD': 'Nowe hasło',
		'PASSWORD.NO_MATCH': 'Niedopasowanie potwierdzenia hasła!',
		'PATH_PLANNING.ADD': 'Plan path',
		'PATH_PLANNING.ADD.SUCCESS': 'Planned path successfully added',
		'PATH_PLANNING.ANGLE': 'Angle',
		'PATH_PLANNING.ANGLE.LONGEST_SIDE': 'Longest side',
		'PATH_PLANNING.ANGLE.OPTIMAL': 'Optimal',
		'PATH_PLANNING.ANGLE.WORKING': 'Working angle',
		'PATH_PLANNING.AREA.COVERED': 'Covered area',
		'PATH_PLANNING.AREA.OVERLAP': 'Overlapped area',
		'PATH_PLANNING.AREA.UNCOVERED': 'Uncovered area',
		'PATH_PLANNING.DETAILS': 'Planned path',
		'PATH_PLANNING.GENERATE_PATH': 'Generate path',
		'PATH_PLANNING.GEOMETRY.CHANGED.QUESTION': 'The field boundary has been changed. Do you want to store the boundary as the current boundary of the field?',
		'PATH_PLANNING.NAME': 'Path planning name',
		'PATH_PLANNING.NAME.EXPLANATION': 'Give the path planning a name',
		'PATH_PLANNING.NOT_ENOUGH_DATA_EXPECTATION': 'Currently there is not enough data to compute the expected fuel consumption, CO2 consumption and cost',
		'PATH_PLANNING.SELECT.FIELD': 'Select the field you want the path to be planned for',
		'PATH_PLANNING.SEND_TO_MACHINE': 'Send to machine',
		'PATH_PLANNING.SETTINGS.CHANGED.QUESTION': 'The settings have been changed after generating the currently shown planned path and will not be reflected when saved. Do you want to continue?',
		'PATH_PLANNING.SUBDIVIDE': 'Subdivide field',
		'PATH_PLANNINGS.DEACTIVATE.FAILURE': 'Some of the planned paths could not be deactivated',
		'PATH_PLANNINGS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the planned path?',
		'PATH_PLANNINGS.DEACTIVATE.SUCCESS': 'Planned paths have been deactivated',
		'PATH_PLANNINGS.DELETE.FAILURE': 'Some of the planned paths could not be deleted',
		'PATH_PLANNINGS.DELETE.QUESTION': 'Do you really want to delete the planned path?',
		'PATH_PLANNINGS.DELETE.SUCCESS': 'Planned paths deleted successfully',
		'PATH_PLANNINGS.MANAGEMENT': 'Planned paths management',
		'PATH_PLANNINGS.NOT_SELECTED': 'No planned path selected',
		'PATH_PLANNINGS.REACTIVATE.FAILURE': 'Some of the planned paths could not be reactivated',
		'PATH_PLANNINGS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected planned paths?',
		'PATH_PLANNINGS.REACTIVATE.SUCCESS': 'Planned paths reactivated successfully',
		'PATTERN': 'Pattern',
		'PATTERN.END_AT_ENTRANCE': 'End at entrance',
		'PATTERN.START': 'Pattern start/end',
		'PATTERN.START_AT_ENTRANCE': 'Start at entrance',
		'PAUSE': 'Pause',
		'PERFORMANCE.AVERAGE': 'Średnia wydajność',
		'PERFORMANCE.AVERAGE.EXPLAINATION': 'Wartość ta uwzględnia również wszystkie stany robocze, w tym czas przygotowania i drogi',
		'PERFORMANCE.AVERAGE.FIELD': 'Średnia wydajność (pole)',
		'PERFORMANCE.AVERAGE.FIELD.EXPLAINATION': 'Wartość ta uwzględnia tylko pracę na polu, oczekiwanie na pole i włączenie pola',
		'PERFORMANCE.TOTAL': 'Wydajność całkowita',
		'PHONE': 'Telefon kontaktowy',
		'PHONE.INVALID': 'Telefon nieważny',
		'PHONE_MOBILE': 'Telefon (komórkowy)',
		'PH_VALUE': 'Wartość PH',
		"PLANT_PROTECTANT": "Środek ochrony roślin",
		'PLAY': 'Play',
		'POSTCODE': 'Kod pocztowy',
		'PREVIOUS': 'Poprzedni',
		'PROCESS': 'Zabieg',
		'PROCESSED': 'Przetworzone',
		'PROCESSED.FAILURE': 'Awaria podczas przetwarzania',
		'PROCESSED.SUCCESSFULL': 'Przetworzone pomyślnie',
		'PRODUCT': 'Produkt',
		'PROGRESS': 'Postęp',
		'PROJECTION': 'Projekcja',
		'RAW_DATA': 'Dane surowe',
		'RECEIVED.AT': 'Otrzymane w',
		'REGENERATE': 'Regeneruj',
		'REGENERATE.SELECTED': 'Regeneruj wybrane',
		'REGISTER': 'Zarejestruj się',
		'REGISTER.ALREADY_REGISTERED?': 'Już zarejestrowany?',
		'REGISTER.I_ACCEPT_THE': 'Przyjmuję',
		'RELOAD': 'Przeładuj',
		'REMOVE': 'Usuń',
		'RENEW': 'Odnów',
		'REOCURRING': 'Powtarzające się',
		'REPORT': 'Raport',
		'RESET': 'Resetuj',
		'RESOLUTION': 'Rezolucja',
		'RESTORE.DRIVER': 'Przywracanie sterownika',
		'RESTORE.IMPLEMENT': 'Przywróć implementację',
		'ROAD': 'Droga',
		'ROLE': 'Rola',
		'RUNTIME_H': 'Czas pracy w godzinach ',
		'SAFETY_CHECK': 'Kontrola Satefy',
		'SATELITE': 'Satelita',
		'SAVE': 'Zapisz',
		'SCALE.TYPE': 'Rodzaj skali',
		'SEARCH': 'Szukaj',
		'SEASON_YEAR': 'Sezon',
		'SEASON_YEAR.START': 'Początek sezonu',
		'SELECT.ALL': 'Wybierz wszystko',
		'SELECT.CLEAR': 'Usunąć zaznaczenie',
		'SELECT.FIELD': 'Select field',
		'SENSORDATA': 'Dane z czujników',
		'SENSORDATA.DESCRIPTION': 'Wizualizacja sensordata',
		'SENSORDATA.SELECT_SENSOR': 'Wybierz czujnik',
		'SENSORDATA.SHOW_WORKSTATE_COLORS': 'Pokaż kolory stanu pracy',
		'SENSOR_PARAMETER': 'Parametr czujnika',
		'SENSOR_PARAMETER.ADD': 'Dodaj parametr czujnika',
		'SENSOR_PARAMETER.DEFINE_FOR_IMPLEMENT': 'Definiowanie indywidualnych pareterów czujników dla wybranej maszyny.',
		'SENSOR_PARAMETER.DEFINE_INDIVIDUAL_PARAM': 'Zdefiniuj swój indywidualny parametr czujnika.',
		'SENSOR_PARAMETER.INDIVIDUAL_SENSOR_PARAM': 'Indywidualny parametr czujnika',
		'SENSOR_PARAMETER.NOT_REMOVABLE_USED_IN_OTHER_PARAMETER': 'Parametr czujnika jest używany w innej konfiguracji parametrów',
		'SENSOR_PARAMETERS': 'Parametry czujników',
		'SENSOR_PARAMETERS.NO': 'Brak parametrów czujnika',
		'SERIAL': 'Numer seryjny',
		'SETTINGS': 'Ustawienia',
		'SETTINGS.ADDITIONAL': 'Additional settings',
		'SETTINGS.ADVANCED': 'Advanced settings',
		'SETTINGS.AGRIROUTER_CAN_BE_CONNECTED': 'Twoje konto Agrirouter może być połączone z exatrek w celu wymiany danych.',
		'SETTINGS.AGRIROUTER_CONNECTED_AND_READY': 'Agrirouter jest podłączony i gotowy do użycia. Połączenie jest ważne do momentu',
		'SETTINGS.CONNECTION_TO_PARTNERS': 'Połączenie z partnerami exatrek',
		'SETTINGS.FARMNET_FIELD_SYNC': 'Synchronizacja pól z 365Farmnet do exatrek',
		'SETTINGS.FARMNET_IMPLEMENT_SYNC': 'Synchronizacja implementacji z 365Farmnet do exatrek',
		'SETTINGS.FARMNET_MACHINE_SYNC': 'Synchronizacja maszyn z 365Farmnet do exatrek',
		'SETTINGS.GO_TO_FARMNET': 'Idź do 365Farmnet',
		'SETTINGS.ONLY_FARMNET_WEBAPP': 'Synchronizacja z i do 365farmnet może być używana tylko z poziomu webaplikacji 365farmnet',
		'SHOW': 'Pokaż',
		'SHOW_DIRECTION': 'Pokaż wskazówki',
		'SHOW_EVENTS': 'Pokaż wydarzenia',
		'SHOW_FIELDS': 'Pokaż pola',
		'SHOW_LOCATIONS': 'Pokaż lokalizacje',
		'SHOW_OFFLINE_MACHINES': 'Pokaż maszyny offline',
		'SHOW_TRACKS': 'Pokaż ścieżki',
		'SHOW_TRACKS_': 'Pokaż ścieżki',
		'SNACKBAR.DAYS': 'dni',
		'SNACKBAR.LICENSE_EXPIRATION_WARNING': 'Twoja licencja wygasa w',
		'SNACKBAR.MACHINE_ONLINE_WARNING': 'Przynajmniej jedna maszyna nie była online od jakiegoś czasu!',
		'SORT_BY': 'Sortuj według',
		'SPEED': 'Prędkość',
		'SPEED.AVERAGE': 'Średnia prędkość',
		'SPEED.FASTER': 'Faster',
		'SPEED.RESET': 'Reset speed',
		'SPEED.SIGNAL.OVERRIDE': 'Przesterowanie sygnału prędkości',
		'SPEED.SLOWER': 'Slower',
		'SPEED.WORKING': 'Working speed',
		'SPLIT': 'Podziel się',
		'START': 'Start',
		'STATISTICS': 'Statistics',
		'STATUS': 'Status',
		'STOP': 'Przestań',
		'STORAGE': 'Przechowywanie',
		'STORAGE.USB': 'Pamięć USB',
		'STORAGE.USB.USED': 'Używana pamięć USB',
		'STORAGE.USED': 'Używane przechowywanie',
		'SYMBOLIZATION': 'Charakterystyka',
		'TASK': 'Zadanie',
		'TASK.ADDABLE_JOBS': 'Możliwe do dodania prace',
		'TASK.ADD_JOBS': 'Dodaj zadania do zadania',
		'TASK.ARCHIVED_JOB_WARNING': 'To zadanie zawiera zarchiwizowane zadania i nie będzie pokazane w całości!',
		'TASK.DELETE.JOB.FAILURE': 'Zadanie musi zawierać co najmniej jedną pracę!',
		'TASK.DELETE.JOB.QUESTION': 'Czy naprawdę chcesz skasować pracę z zadania?',
		'TASK.DELETE.JOB.SUCCESS': 'Zadanie zostało pomyślnie usunięte z zadania',
		'TASK.DELETE.QUESTION': 'Czy naprawdę chcesz usunąć zadanie?',
		'TASK.DELETE.SUCCESS': 'Zadanie usunięte pomyślnie',
		'TASK.EDIT': 'Edycja zadania',
		'TASK.EDIT.SUCCESS': 'Zadanie zostało pomyślnie zredagowane',
		'TASK.EXPORT_DETAILS': 'Eksportowanie wybranego zadania',
		'TASK.JOBS_TO_ADD': 'Miejsca pracy, które zostaną dodane',
		'TASK.NEW': 'Nowe zadanie',
		'TASKS': 'Zadania',
		'TASKS.NO': 'Nie ma zadań',
		'TASK_CONTROLLER.ACTIVE': 'TaskController (DataLog) aktywny',
		'TASK_CONTROLLER.COMPAT_ACTIVE': 'Tryb zgodności z TaskController aktywny',
		'TAX_ID': 'Identyfikator podatkowy',
		'TC': 'Kontroler zadań',
		'TC.ACTIVE': 'Kontroler zadań aktywny',
		'TC.TC_COMP': 'Kontroler zadań komp.',
		'TERMINAL.NO': 'Nie ma terminalu',
		'TERMINAL.TYPE': 'Typ zacisku',
		'TEST.SUCCESS': 'Wniosek został przyjęty. Wkrótce otrzymasz wiadomość e-mail.',
		'TIME': 'Czas',
		'TIME.REMAINING': 'Pozostały czas',
		'TIMEZONE': 'Strefa czasowa',
		'TITLE': 'Żądanie konta testowego',
		'TOKEN': 'Kod dostępu',
		'TOTAL': 'Razem',
		'TRACKS.LOADING': 'Ładowanie ścieżek...',
		'TRACK.WIDTH': 'Rozstaw kół',
		'TRACK.WIDTH.NARROW': 'Wąski',
		'TRACK.WIDTH.NORMAL': 'Normalny',
		'TRACK.WIDTH.WIDE': 'Szeroki',
		'TRACK_LENGTH': 'Długość toru',
		'TRACK_REPLAY': 'Track replay',
		'TRANSLATABLE': 'Możliwość tłumaczenia',
		'TRANSLATABLE.ADD': 'Dodaj możliwość tłumaczenia',
		'TRANSLATION': 'Tłumaczenie',
		'TRANSPORT': 'Transport',
		'TRANSPORT/AXLES': 'Transport/osiki',
		'TRANSPORTAMOUNT_AXLES': 'Ilość transportowa/oś',
		'TURNINGS': 'Turnings',
		'TURNING_OFFSET': 'Turning offset',
		'TURNING_RADIUS': 'Turning radius',
		'TYPE': 'Typ',
		'UNDO': 'Cofnij',
		'UNIT': 'Jednostka',
		'UNKNOWN': 'Nieznany',
		'UNTIL': 'do',
		'UPLOAD': 'Prześlij',
		'UPLOAD.FINISHED': 'Wysyłanie zakończone',
		'UPLOADING': 'Przesyłanie',
		'USER.EDIT.SUCCESS': 'Użytkownik pomyślnie edytowany',
		'USERNAME': 'Nazwa użytkownika',
		'USERNAME.LENGTH.REQUIRED': 'Nazwa użytkownika musi mieć co najmniej 6 znaków.',
		'USERNAME.TAKEN': 'Ta nazwa jest już zajęta.',
		'USERNAME.VALID.CHARS': 'Nazwa użytkownika może zawierać tylko litery, cyfry, \"-\" i \"_\".',
		'USERROLE': 'Rola użytkownika',
		'USERSTATUS': 'Status użytkownika',
		'USER_CREATED': 'Użytkownik stworzony.',
		'WAITING': 'Postój',
		'WARNING': 'Ostrzeżenie',
		'WEEK.CURRENT': 'Bieżący tydzień',
		'WEEK.NEXT': 'W następnym tygodniu',
		'WEEK.PREVIOUS': 'Poprzedni tydzień',
		'WEEK.SELECTED': 'Wybrany tydzień',
		'WEIGHING': 'Ważenie',
		'WIDTH.INVALID': 'Nieprawidłowa szerokość',
		'WORKING_HOURS': 'Godziny pracy',
		'WORKING_TIME': 'Czas pracy',
		'WORKING_WIDTH': 'Szerokość robocza',
		'WORKSTATE': 'Workstate',
		'WORKSTATES': 'Stanowiska pracy',
		'YES': 'Tak',
    'NO_POSITION_MACHINE_FOUND': 'Brak pozycji maszyny',
	}
};
